
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1hCZf", function(module, exports) {
/**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $diswb = parcelRequire("diswb");


var $dpPtd = parcelRequire("dpPtd");





var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $iPRuY = parcelRequire("iPRuY");

const $927b60c9423d7a64$export$7b99cc330037c4ec = ({ children: children, contentQueryResult: contentQueryResult, route: route })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const handleUnexpectedError = (error)=>{
        experienceTracker.fail({
            name: (0, $irVI7.DATABASE_EXPERIENCE),
            error: error
        });
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iPRuY.ContentPrerequisites), {
        route: route,
        contentQueryResult: contentQueryResult,
        passThroughOnLoading: true,
        handleUnexpectedError: handleUnexpectedError
    }, children);
};



var $lfmjq = parcelRequire("lfmjq");





var $1NBp8 = parcelRequire("1NBp8");


var $bT0se = parcelRequire("bT0se");


var $83FW4 = parcelRequire("83FW4");




var $1sAhh = parcelRequire("1sAhh");



parcelRequire("3Vzvh");
var $660Iy = parcelRequire("660Iy");


var $6mKj3 = parcelRequire("6mKj3");

parcelRequire("lqy4V");
var $lsi6E = parcelRequire("lsi6E");


var $g01A4 = parcelRequire("g01A4");


var $4VJDS = parcelRequire("4VJDS");


var $9wGTI = parcelRequire("9wGTI");





var $T1bCI = parcelRequire("T1bCI");


var $9wEpK = parcelRequire("9wEpK");


var $kDuN4 = parcelRequire("kDuN4");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");





var $b8Qzg = parcelRequire("b8Qzg");

// The height of the fixed object header (including the bottom border) is needed for SSR for
// certain routes (such as Databases), when they can't use ResizeObserver to tell them how big the
// header actually is
const $d371903a3743b8b2$export$d931923c7a26ab66 = 57;



var $eStoj = parcelRequire("eStoj");








var $fyPYm = parcelRequire("fyPYm");


var $bj5fB = parcelRequire("bj5fB");


var $8dwdz = parcelRequire("8dwdz");





var $frfjk = parcelRequire("frfjk");


var $3mVfX = parcelRequire("3mVfX");


var $8i27m = parcelRequire("8i27m");


var $bQm3c = parcelRequire("bQm3c");


var $7d2Nc = parcelRequire("7d2Nc");


var $deZfn = parcelRequire("deZfn");


var $aCrkK = parcelRequire("aCrkK");


var $bvJwp = parcelRequire("bvJwp");


var $5thep = parcelRequire("5thep");


var $ai7NK = parcelRequire("ai7NK");


var $4RbZ3 = parcelRequire("4RbZ3");


var $exahZ = parcelRequire("exahZ");


var $dPJCf = parcelRequire("dPJCf");


var $aWwYt = parcelRequire("aWwYt");


var $fQa5o = parcelRequire("fQa5o");


var $3r60T = parcelRequire("3r60T");


var $7aRa9 = parcelRequire("7aRa9");


var $essql = parcelRequire("essql");





var $lrMxq = parcelRequire("lrMxq");


var $6KaG6 = parcelRequire("6KaG6");


var $5Myco = parcelRequire("5Myco");


var $hgdkS = parcelRequire("hgdkS");











var $lUzNY = parcelRequire("lUzNY");


var $ckYtV = parcelRequire("ckYtV");


var $hzClJ = parcelRequire("hzClJ");


var $j96gu = parcelRequire("j96gu");

const $c2b2a5ea7327f30e$export$7628427a4e8bf2d8 = ()=>{
    const [mainActions, setMainActions] = (0, $42omo.useState)(null);
    const [collaborators, setCollaborators] = (0, $42omo.useState)({
        collaborators: [],
        me: null
    });
    const [boardStatus, setBoardStatus] = (0, $42omo.useState)(null);
    const [moreActions, setMoreActions] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        (0, $ckYtV.contentMainActionsService).onActionsUpdate((mainAction)=>{
            setMainActions(mainAction);
        });
        (0, $hzClJ.contentCollaboratorsService).onActionsUpdate((collaborator)=>{
            setCollaborators(collaborator);
        });
        (0, $j96gu.contentBoardStatusService).onActionsUpdate((status)=>{
            setBoardStatus(status);
        });
        (0, $lUzNY.contentMoreActionsService).onActionsUpdate((moreAction)=>{
            setMoreActions(moreAction);
        });
    }, [
        setMainActions,
        setCollaborators,
        setBoardStatus,
        setMoreActions
    ]);
    return {
        mainActions: mainActions,
        collaborators: collaborators,
        contentStatus: boardStatus,
        moreActions: moreActions
    };
};


const $85ed939a521e23e1$var$ACTION_DATABASE_UNDO = 'databases-undo';
const $85ed939a521e23e1$var$ACTION_DATABASE_REDO = 'databases-redo';
const $85ed939a521e23e1$export$78a0df6be65b7b84 = ({ openSidePanel: openSidePanel, contentId: contentId, spaceKey: spaceKey, isObjectSidebarShown: isObjectSidebarShown, behavior: behavior, databaseHeaderHeight: databaseHeaderHeight, bannerState: bannerState, title: title, eventService: eventService, dbVersionHistory: dbVersionHistory, isRovoParentProduct: isRovoParentProduct })=>{
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const { moreActions: moreActions } = (0, $c2b2a5ea7327f30e$export$7628427a4e8bf2d8)();
    const undoRedoButtonActions = (0, $42omo.useMemo)(()=>{
        if (!moreActions?.items) return undefined;
        const allActions = moreActions.items.flat();
        const undoAction = allActions.find((action)=>action.id === $85ed939a521e23e1$var$ACTION_DATABASE_UNDO && !('items' in action));
        const redoAction = allActions.find((action)=>action.id === $85ed939a521e23e1$var$ACTION_DATABASE_REDO && !('items' in action));
        if (undoAction && redoAction) {
            const undoOnClick = undoAction.onClick;
            const redoOnClick = redoAction.onClick;
            return {
                canUndo: !undoAction.isDisabled,
                canRedo: !redoAction.isDisabled,
                undo: typeof undoOnClick === 'function' ? ()=>{
                    undoOnClick();
                    return true;
                } : ()=>false,
                redo: typeof redoOnClick === 'function' ? ()=>{
                    redoOnClick();
                    return true;
                } : ()=>false
            };
        }
        return undefined;
    }, [
        moreActions
    ]);
    if (isMobileApp) return null;
    const getSidePanelComponent = ()=>{
        if (openSidePanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hgdkS.VersionHistory), {
            headerHeight: bannerState.getTotalHeight(true) + databaseHeaderHeight,
            contentId: contentId,
            title: title,
            panelTop: databaseHeaderHeight,
            eventService: eventService,
            setVersion: dbVersionHistory.setDatabaseVersion,
            contentType: "database"
        });
        if ((0, $9wGTI.fg)('databases-frontend-content-wrapper')) {
            const isDatabasesStagingArea = isRovoParentProduct && (0, $9wGTI.fg)('aifc_create_enabled_ga');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lrMxq.ObjectSidebarControl), {
                contentId: contentId,
                hasCommentsButton: (0, $9wGTI.fg)('cc-whiteboards-consolidating-comments'),
                hasAiButton: true,
                hasDetailsButton: true,
                spaceKey: spaceKey,
                contentType: "database",
                hasLoomButton: true,
                hasUndoRedoButton: !!undoRedoButtonActions,
                undoRedoButtonActions: undoRedoButtonActions,
                isDatabasesStagingArea: isDatabasesStagingArea
            });
        }
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, getSidePanelComponent(), isObjectSidebarShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, behavior === 'push' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Myco.ObjectSidebarPushPlaceholder), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6KaG6.ObjectSidebarPanel), {
        ignoreGap: true
    })));
};









var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $5RBJ9 = parcelRequire("5RBJ9");

var $2Fndw = parcelRequire("2Fndw");


var $lwNi3 = parcelRequire("lwNi3");







const $ccd76be140cfb53e$var$HELP_SPOTLIGHT_STEP = 'help-spotlight';
const $ccd76be140cfb53e$var$i18n = (0, $cgtv4.defineMessages)({
    body: {
        id: "databases-onboarding-ga.getting-started.content.spotlight.help.body",
        defaultMessage: "Get help or learn more about databases anytime."
    },
    dismissBtn: {
        id: "databases-onboarding-ga.getting-started.content.spotlight.help.dismissBtn",
        defaultMessage: "OK"
    }
});
const $ccd76be140cfb53e$var$SCREEN_NAME = 'databaseGAOnboardingHelpSpotlight';
const $ccd76be140cfb53e$var$MESSAGE_ID = 'cc-databases-ga-modify-db-spotlight';
const $ccd76be140cfb53e$export$ddd6261d627a25f6 = ({ currentStep: currentStep, setNextStep: setNextStep = ()=>{} })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const showHelpSpotlight = currentStep === $ccd76be140cfb53e$var$HELP_SPOTLIGHT_STEP;
    const coordinationClient = (0, $lwNi3.useCoordinationClient)();
    (0, $42omo.useEffect)(()=>{
        if (showHelpSpotlight) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: $ccd76be140cfb53e$var$SCREEN_NAME
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentStep
    ]);
    const handleDismiss = (0, $42omo.useCallback)(async ()=>{
        setNextStep();
        try {
            await coordinationClient.stop($ccd76be140cfb53e$var$MESSAGE_ID);
        } catch (err) {
            (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
            });
        }
    }, [
        setNextStep,
        coordinationClient
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, showHelpSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5RBJ9.default), {
        dialogWidth: 287,
        targetRadius: 100,
        target: "app-navigation-help",
        key: "database-ga-onboarding",
        dialogPlacement: "top right",
        actions: [
            {
                text: intl.formatMessage($ccd76be140cfb53e$var$i18n.dismissBtn),
                onClick: handleDismiss
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ccd76be140cfb53e$var$i18n.body))));
};


const $2b13bdf75bdd8b89$export$a7243c3337e5cc55 = ({ onboardingService: onboardingService })=>{
    const [onboardingStep, setOnboardingStep] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        onboardingService.registerOnOnboardingChangeCallback((step)=>{
            setOnboardingStep(step);
        });
    }, [
        onboardingService
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccd76be140cfb53e$export$ddd6261d627a25f6), {
        currentStep: onboardingStep,
        setNextStep: setOnboardingStep
    });
};


/* DatabaseMobileView.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");









var $7hXDW = parcelRequire("7hXDW");


var $iXCQx = parcelRequire("iXCQx");





var $1eaCJ = parcelRequire("1eaCJ");

var $63562604b11f24ae$exports = {};
$63562604b11f24ae$exports = new URL("DatabaseGraphic.c569376d.svg", import.meta.url).toString();


const $8fba8dcee85bb26b$var$MobileWebViewContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { headerHeight: headerHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_3ioxf9": (0, $7sObp.default)(`${__cmplp.headerHeight}px`),
            "--_yo5j46": (0, $7sObp.default)(`calc(100vh - ${__cmplp.headerHeight}px)`)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ckr _kqswstnw _154i5h89 _4t3i2s19 _vchhusvi _1bsb1osq _1e0c1txw _4cvr1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $8fba8dcee85bb26b$var$MobileWebViewTextContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c82smr _1bsb2hgv _1e0c1txw _4cvr1h6o _1bah1h6o _y3gn1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $8fba8dcee85bb26b$var$MobileWebViewHeader = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1fja",
            __cmplp.className
        ])
    });
});
const $8fba8dcee85bb26b$var$MobileWebViewText = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $8fba8dcee85bb26b$var$i18n = (0, $cgtv4.defineMessages)({
    title: {
        id: "confluence-databases.mobile-web-view-title",
        defaultMessage: "Databases aren\u2019t available on mobile yet"
    },
    description: {
        id: "confluence-databases.mobile-web-view-description",
        defaultMessage: "View this on Confluence Cloud for web."
    },
    details: {
        id: "confluence-databases.mobile-web-view-details",
        defaultMessage: "Use databases for managing and syncing your data across Confluence."
    },
    imageAltText: {
        id: "confluence-databases.mobile-web-view-img-alt-text",
        defaultMessage: "Graphic for databases"
    }
});
const $8fba8dcee85bb26b$export$7101457c6893431b = ({ bannerState: bannerState })=>{
    const headerHeight = (0, $42omo.useMemo)(()=>bannerState.getTotalHeight(), [
        bannerState
    ]);
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8fba8dcee85bb26b$var$MobileWebViewContainer, {
        headerHeight: headerHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($63562604b11f24ae$exports))),
        alt: intl.formatMessage($8fba8dcee85bb26b$var$i18n.imageAltText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8fba8dcee85bb26b$var$MobileWebViewTextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8fba8dcee85bb26b$var$MobileWebViewHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "medium",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $8fba8dcee85bb26b$var$i18n.title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $8fba8dcee85bb26b$var$i18n.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8fba8dcee85bb26b$var$MobileWebViewText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $8fba8dcee85bb26b$var$i18n.details))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.DATABASE_CONTENT_EXPERIENCE),
        attributes: {
            isConfluenceRenderedMobileView: true
        }
    }));
};






var $lSOAM = parcelRequire("lSOAM");

var $i3c1S = parcelRequire("i3c1S");


var $jX1qB = parcelRequire("jX1qB");

var $1UCmC = parcelRequire("1UCmC");


var $6VdZc = parcelRequire("6VdZc");

var $7fw2E = parcelRequire("7fw2E");


var $5qUgM = parcelRequire("5qUgM");


var $aWrnw = parcelRequire("aWrnw");


var $8w1c1 = parcelRequire("8w1c1");


var $1q7H7 = parcelRequire("1q7H7");


var $fgdVB = parcelRequire("fgdVB");




const $41842fe17346d9f1$export$c166e9a70918b277 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $41842fe17346d9f1$var$NOOP = ()=>{
// This is intentional
};
const $41842fe17346d9f1$export$2d5e2a82ee58820b = ({ isInitialLoad: isInitialLoad })=>{
    const segments = [
        $41842fe17346d9f1$export$c166e9a70918b277,
        (0, $5qUgM.DATABASE_HEADER_SEGMENT_METRIC)
    ];
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) segments.push((0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC));
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) segments.push((0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC));
    if (isInitialLoad) segments.push((0, $8w1c1.APP_NAVIGATION_METRIC), (0, $aWrnw.SPACE_NAVIGATION_METRIC), (0, $1q7H7.PAGE_TREE_METRIC));
    return segments;
};
const $41842fe17346d9f1$export$189913fef8bf279d = ({ contentId: contentId })=>{
    const pageLoadMetricRef = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        const expectedPageSegments = $41842fe17346d9f1$export$2d5e2a82ee58820b({
            isInitialLoad: (0, $6VdZc.isInitial)()
        });
        const untilPageSegments = expectedPageSegments.map((segment)=>({
                experience: segment,
                useFmpAsUntilStopTime: false
            }));
        pageLoadMetricRef.current = (0, $lSOAM.createPageLoadMetric)({
            key: (0, $1UCmC.DATABASE_VIEW_PAGE_KEY),
            timings: (0, $i3c1S.getWaterfallTimings)(expectedPageSegments),
            include: expectedPageSegments,
            until: untilPageSegments
        });
        if (!(0, $6VdZc.isInitial)()) {
            // Make sure all segments are re-started and not currently
            // marked as finished from a previous navigation.
            // Ensure any nested segments are restarted first. If you don't
            // do this with nested segments, you'll see some SPA-navigation
            // perf metrics not get fired (header & main page). You'll also
            // see errors like this if you enable platform browser-metrics
            // package debugging:
            // "BM log:  metric content-types-header has been stopped
            // with stopTime lower than startTime"
            (0, $5qUgM.DATABASE_HEADER_SUBSEGMENT_METRICS).forEach((m)=>m.startFromPageLoad());
            // then restart the top-level segments
            expectedPageSegments.forEach((m)=>m.startFromPageLoad());
        }
        pageLoadMetricRef.current.startPageLoad();
        pageLoadMetricRef.current.onStop((0, $7fw2E.markBrowserMetricEnd).bind(null, pageLoadMetricRef.current), $41842fe17346d9f1$var$NOOP);
        // Cleanup on unmount or when dependencies have changed
        return ()=>{
            pageLoadMetricRef.current?.cancel();
        };
    }, [
        contentId
    ]);
    return null;
};



var $hrAmX = parcelRequire("hrAmX");

const $39098ba5b77e4682$var$OBJECT_SIDEBAR_PANEL_WIDTH = 400;
const $39098ba5b77e4682$var$VERSION_HISTORY_SIDE_PANEL_WIDTH = 320;
const $39098ba5b77e4682$var$calculateIframeWidth = (isSidebarPanelOpen, isVersionHistoryOpen)=>{
    if (isSidebarPanelOpen) return `calc(100% - ${$39098ba5b77e4682$var$OBJECT_SIDEBAR_PANEL_WIDTH}px)`;
    if (isVersionHistoryOpen) return `calc(100% - ${$39098ba5b77e4682$var$VERSION_HISTORY_SIDE_PANEL_WIDTH}px)`;
    return '100%';
};
const $39098ba5b77e4682$export$5d6291e520f07268 = [
    (0, $hrAmX.BannerStateContainer)
];
const $39098ba5b77e4682$export$7cc78372144ec97a = (topNavAndBannerHeight, isVersionHistoryOpen = false, isObjectSidebarShown = false)=>({
        width: $39098ba5b77e4682$var$calculateIframeWidth(isObjectSidebarShown, isVersionHistoryOpen),
        height: topNavAndBannerHeight > 0 ? `calc(100vh - ${topNavAndBannerHeight}px)` : '100vh',
        display: 'block',
        border: '0px',
        ...isVersionHistoryOpen || isObjectSidebarShown ? {
            transition: 'width 300ms cubic-bezier(0.2, 0, 0, 1) 0s'
        } : {}
    });





class $a2b539ad3fb3b264$export$407b873dd6e77a45 {
    dispose() {
        this.onOnboardingChangeCallback = ()=>{};
    }
    /**
   * This is called in Confluence to register the onOnboardingChange callback
   * which will be called in Canvas via the Bridge API whenever a new onboarding
   * screen is shown.
   *
   * @param callback A callback that is passed the new onboarding screen name
   * whenever it changes
   */ registerOnOnboardingChangeCallback(callback) {
        this.onOnboardingChangeCallback = callback;
    }
    /**
   * This is called in Canvas via the Bridge API whenever the onboarding screen
   * changes
   *
   * @param {string} screen The new onboarding screen name
   */ onOnboardingChange(screen) {
        this.onOnboardingChangeCallback(screen);
    }
    constructor(){
        this.onOnboardingChangeCallback = void 0;
        this.onOnboardingChangeCallback = ()=>{};
    }
}


const $43867371740d70bb$export$df4cf7f032c0f91f = ({ service: service } = {})=>{
    const onboardingService = (0, $42omo.useMemo)(()=>service === undefined ? new (0, $a2b539ad3fb3b264$export$407b873dd6e77a45)() : service, [
        service
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            onboardingService.dispose();
        };
    }, [
        onboardingService
    ]);
    return onboardingService;
};






var $7zgzO = parcelRequire("7zgzO");

const $d024a3cda21e3523$export$741774b3fb39e921 = function collabSpotFromParams(params, name) {
    const rawSpot = params[name];
    if (!rawSpot || Array.isArray(rawSpot)) return;
    const maybeSpot = parseInt(rawSpot);
    if (Number.isNaN(maybeSpot)) return;
    if (maybeSpot < 1 || maybeSpot > 20) return;
    return maybeSpot;
};


const $16e23a2b49af27f1$var$envList = [
    'dev',
    'branch',
    'staging',
    'hello'
];
const $16e23a2b49af27f1$export$1c237a39a0b4e9d9 = 'parentProduct';
const $16e23a2b49af27f1$export$c0e20ddbe692c9b9 = 'smartLink';
const $16e23a2b49af27f1$export$3c73b63c43c516df = 'rovo';
const $16e23a2b49af27f1$export$6c706ba208a447e = 'themeState';
const $16e23a2b49af27f1$export$518d0d224c2c38d4 = 'mobileApp';
const $16e23a2b49af27f1$export$e75d2079ca761674 = 'presentationMode';
const $16e23a2b49af27f1$export$755848d3f223f58c = 'bridgeClient';
const $16e23a2b49af27f1$var$HEADLESS_QUERY_PARAM = 'headless';
const $16e23a2b49af27f1$var$retrieveQueryParameter = (queryParams, key)=>{
    return queryParams?.[key] && !Array.isArray(queryParams?.[key]) ? queryParams?.[key] // TypeScript doesn't acknowledge the !Array.isArray
     : undefined;
};
const $16e23a2b49af27f1$export$2c4cdbd6638ace58 = ()=>{
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    // Versioned deploys are currently only supported in development and internal
    // environments
    const allowDevParams = $16e23a2b49af27f1$var$envList.some((e)=>e === "production");
    const parentProduct = $16e23a2b49af27f1$var$retrieveQueryParameter(queryParams, $16e23a2b49af27f1$export$1c237a39a0b4e9d9);
    const presentationMode = $16e23a2b49af27f1$var$retrieveQueryParameter(queryParams, $16e23a2b49af27f1$export$e75d2079ca761674);
    const bridgeClient = $16e23a2b49af27f1$var$retrieveQueryParameter(queryParams, $16e23a2b49af27f1$export$755848d3f223f58c);
    const headless = $16e23a2b49af27f1$var$retrieveQueryParameter(queryParams, $16e23a2b49af27f1$var$HEADLESS_QUERY_PARAM);
    const frontendVersion = allowDevParams && queryParams?.['databases-frontend'] && !Array.isArray(queryParams?.['databases-frontend']) ? queryParams?.['databases-frontend'] : undefined;
    const canvasServerSpot = allowDevParams ? (0, $d024a3cda21e3523$export$741774b3fb39e921)(queryParams, 'canvas-server') : undefined;
    const canvasRelaySpot = allowDevParams ? (0, $d024a3cda21e3523$export$741774b3fb39e921)(queryParams, 'canvas-relay') : undefined;
    return {
        'databases-frontend': frontendVersion,
        'canvas-server': canvasServerSpot,
        'canvas-relay': canvasRelaySpot,
        headless: headless === 'true',
        isSmartLinkEmbed: parentProduct === $16e23a2b49af27f1$export$c0e20ddbe692c9b9,
        presentationMode: presentationMode,
        bridgeClient: bridgeClient,
        isRovoParentProduct: parentProduct === $16e23a2b49af27f1$export$3c73b63c43c516df
    };
};















var $jxpvN = parcelRequire("jxpvN");





var $iRRvH = parcelRequire("iRRvH");

const $0c1479740d6f6957$export$94780835089c97fc = 'database-frame';











var $6attE = parcelRequire("6attE");





var $j6S25 = parcelRequire("j6S25");





var $5wU3V = parcelRequire("5wU3V");





const $e4b6a73e6cb27c5d$export$3f6d3dddadd0c944 = ({ version: version, isSmartLinkEmbed: isSmartLinkEmbed, versionId: versionId, presentationMode: presentationMode, bridgeClient: bridgeClient, isRovoParentProduct: isRovoParentProduct })=>{
    const { initialThemeSerialized: initialThemeSerialized } = (0, $5wU3V.useThemingService)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    return (0, $42omo.useMemo)(()=>{
        const url = new URL(`/databases/standalone`, window.location.origin);
        if (version) url.searchParams.set('bifrost-override', version);
        if (isSmartLinkEmbed) url.searchParams.set((0, $16e23a2b49af27f1$export$1c237a39a0b4e9d9), (0, $16e23a2b49af27f1$export$c0e20ddbe692c9b9));
        if (isMobileApp) url.searchParams.set((0, $16e23a2b49af27f1$export$e75d2079ca761674), (0, $16e23a2b49af27f1$export$518d0d224c2c38d4));
        if (presentationMode !== undefined) url.searchParams.set((0, $16e23a2b49af27f1$export$e75d2079ca761674), presentationMode);
        if (isRovoParentProduct) url.searchParams.set((0, $16e23a2b49af27f1$export$1c237a39a0b4e9d9), (0, $16e23a2b49af27f1$export$3c73b63c43c516df));
        if (initialThemeSerialized) {
            const themeObject = (0, $j6S25.themeStringToObject)(initialThemeSerialized);
            url.pathname = `${url.pathname}/${themeObject.colorMode === 'dark' ? 'index-dark.html' : 'index.html'}`;
            url.searchParams.set((0, $16e23a2b49af27f1$export$6c706ba208a447e), encodeURIComponent((0, $j6S25.themeObjectToString)(themeObject)));
        }
        if (versionId && (0, $9wGTI.fg)('confluence_frontend_databases_version_history_ui')) url.searchParams.set('version', versionId);
        if (bridgeClient) url.searchParams.set((0, $16e23a2b49af27f1$export$755848d3f223f58c), bridgeClient);
        const finalUrlParts = [
            url.pathname
        ];
        if (Array.from(url.searchParams).length > 0) finalUrlParts.push(url.searchParams.toString());
        return finalUrlParts.join('?');
    }, [
        version,
        isSmartLinkEmbed,
        isMobileApp,
        initialThemeSerialized,
        versionId,
        presentationMode,
        bridgeClient,
        isRovoParentProduct
    ]);
};


const $c8b27b28e81df3c6$export$d7893480d4d656b3 = ({ spaceKey: spaceKey, contentId: contentId, contentReferenceId: contentReferenceId, spaceId: spaceId, spaceName: spaceName, title: title, identity: identity, dataSecurityPolicyPageExport: dataSecurityPolicyPageExport, refetch: refetch, version: version, isSmartLinkEmbed: isSmartLinkEmbed, versionId: versionId, presentationMode: presentationMode, bridgeClient: bridgeClient, isRovoParentProduct: isRovoParentProduct })=>{
    const [token, setToken] = (0, $42omo.useState)(undefined);
    const { activationId: activationId, userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const initialUrl = (0, $e4b6a73e6cb27c5d$export$3f6d3dddadd0c944)({
        version: version,
        isSmartLinkEmbed: isSmartLinkEmbed,
        versionId: versionId,
        presentationMode: presentationMode,
        bridgeClient: bridgeClient,
        isRovoParentProduct: isRovoParentProduct
    });
    const tokenService = (0, $6attE.useTokenService)({
        tenantId: cloudId,
        space: {
            id: spaceId
        },
        referenceId: contentReferenceId,
        shareToken: undefined,
        contentId: contentId || '',
        dataSecurityPolicyPageExport: dataSecurityPolicyPageExport || null,
        refetch: refetch,
        documentType: 'database'
    });
    (0, $42omo.useEffect)(()=>{
        tokenService.onTokenChange((newToken)=>{
            setToken(newToken);
        });
    }, [
        tokenService
    ]);
    const bridgeData = (0, $42omo.useMemo)(()=>({
            spaceKey: spaceKey,
            contentId: contentId,
            cloudId: cloudId,
            activationId: activationId,
            contentReferenceId: contentReferenceId,
            userId: userId,
            spaceId: spaceId ?? undefined,
            spaceName: spaceName ?? undefined,
            title: title ?? undefined,
            identity: identity ?? undefined,
            token: token,
            versionId: versionId
        }), [
        spaceKey,
        contentId,
        cloudId,
        activationId,
        contentReferenceId,
        userId,
        spaceId,
        spaceName,
        title,
        identity,
        token,
        versionId
    ]);
    return {
        bridgeData: bridgeData,
        initialUrl: initialUrl
    };
};









var $faVFI = parcelRequire("faVFI");











var $6hmtW = parcelRequire("6hmtW");


var $9Zj7l = parcelRequire("9Zj7l");











var $cgpF0 = parcelRequire("cgpF0");







var $13fb9812e800ac01$exports = {};
$13fb9812e800ac01$exports = JSON.parse("{\"dbAiFirstCreation\":\"aifc_create_enabled_ga\"}");


const $fa95a20420a8d0b7$export$387607e2c287cb3 = ()=>{
    const isDatabaseFeatureEnabled = (0, $42omo.useCallback)((featureName)=>{
        if (featureName in (0, (/*@__PURE__*/$parcel$interopDefault($13fb9812e800ac01$exports)))) {
            const activeFeatureGate = featureName;
            const featureGateKey = (0, (/*@__PURE__*/$parcel$interopDefault($13fb9812e800ac01$exports)))[activeFeatureGate];
            return (0, $9wGTI.fg)(featureGateKey);
        }
        return false;
    }, []);
    return {
        isDatabaseFeatureEnabled: isDatabaseFeatureEnabled
    };
};






var $9XexZ = parcelRequire("9XexZ");


var $fD5Hh = parcelRequire("fD5Hh");


var $8fSJ6 = parcelRequire("8fSJ6");




const $43acd4ee05594efc$var$CONFLUENCE_AFM_CLIENT_ID = (0, $fD5Hh.client)('confluence-afm');
const $43acd4ee05594efc$export$b3a80af63fe72378 = ({ enabled: enabled = true } = {})=>{
    // Bind the preview panel handler
    const bindPreviewPanelHandler = (0, $8fSJ6.usePreviewPanelHandler)();
    const setupHandler = (0, $42omo.useCallback)((on)=>{
        if ((0, $6mKj3.expVal)('preview_panel_for_databases', 'isEnabled', false)) bindPreviewPanelHandler(on);
    // You can add more command listeners here as needed
    // on('SomeOtherCommand', handleSomeOtherCommand);
    }, [
        bindPreviewPanelHandler
    ]);
    const { ready: ready, send: send, teardown: teardown } = (0, $9XexZ.useRovoContentBridgeAPI)($43acd4ee05594efc$var$CONFLUENCE_AFM_CLIENT_ID, setupHandler);
    // Initialize the bridge when enabled
    (0, $42omo.useEffect)(()=>{
        if (!enabled) return;
        ready();
        // Cleanup when the component unmounts or when disabled
        return ()=>{
            teardown();
        };
    }, [
        ready,
        teardown,
        enabled
    ]);
    // Return utility functions for manual service triggering if needed
    return {
        isReady: enabled,
        send: send,
        teardown: teardown
    };
};


const $6d02a548e60e8bb9$export$9a572d8e8a178282 = ({ experienceTracker: experienceTracker, onboardingService: onboardingService, segmentMetric: segmentMetric, experienceName: experienceName, versionHistoryExperienceName: versionHistoryExperienceName, versionId: versionId, getVersionName: getVersionName, objectSidebarService: objectSidebarService, databaseSpotlightCloseRef: databaseSpotlightCloseRef, flags: flags })=>{
    const { themingService: themingService } = (0, $5wU3V.useThemingService)();
    const { hideSidePanel: hideSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const { setSidebarControlState: setSidebarControlState, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const { showPanel: showDetailsPanel, hidePanel: hideDetailsPanel } = (0, $9Zj7l.useDetailsPanelService)();
    const { isDatabaseFeatureEnabled: isDatabaseFeatureEnabled } = (0, $fa95a20420a8d0b7$export$387607e2c287cb3)();
    const [flagService] = (0, $42omo.useState)(()=>new (0, $faVFI.ContentTypesFlagService)(flags));
    // Initialize the Rovo content bridge
    (0, $43acd4ee05594efc$export$b3a80af63fe72378)({
        enabled: true
    });
    (0, $42omo.useEffect)(()=>{
        objectSidebarService.onChangeObjectSidebarShown({
            isOpen: isObjectSidebarShown,
            panelId: panel?.id
        });
        objectSidebarService.onChangeObjectSidebarShown_LEGACY(isObjectSidebarShown);
    }, [
        isObjectSidebarShown,
        objectSidebarService,
        panel?.id
    ]);
    const onContentLoadSucceeded = (0, $42omo.useCallback)((attributes)=>{
        experienceTracker.succeed({
            name: experienceName,
            attributes: attributes
        });
        if (versionId) experienceTracker.succeed({
            name: versionHistoryExperienceName,
            attributes: attributes
        });
        segmentMetric.stop();
    }, [
        experienceTracker,
        experienceName,
        segmentMetric,
        versionId,
        versionHistoryExperienceName
    ]);
    const onContentLoadFailed = (0, $42omo.useCallback)((error, attributes)=>{
        error.message = `Canvas Database error: ${error.message}`;
        experienceTracker.stopOnError({
            name: experienceName,
            attributes: attributes,
            error: error
        });
        segmentMetric.cancel();
    }, [
        experienceTracker,
        experienceName,
        segmentMetric
    ]);
    const onCloseConfluenceSidePanel = (0, $42omo.useCallback)(()=>{
        hideSidePanel();
    }, [
        hideSidePanel
    ]);
    const updateObjectSidebarControlState = (0, $42omo.useCallback)((isShown)=>{
        if (isShown) setSidebarControlState('shown');
        else setSidebarControlState('hidden');
    }, [
        setSidebarControlState
    ]);
    return (0, $42omo.useMemo)(()=>({
            /**
			 * Methods part of the shared content types bridge API.
			 * See @confluence/content-types-bridge for more details.
			 */ confluenceAPI: {
                sidebar: {
                    showDetailsPanel: ()=>showDetailsPanel(),
                    hideDetailsPanel: ()=>hideDetailsPanel(),
                    showCommentsPanel: (threadId)=>commentService.showPanel(threadId),
                    hideCommentsPanel: ()=>commentService.hidePanel(),
                    onConfluenceSidebarStateChange: (callback)=>objectSidebarService.registerChangeObjectSidebarShownHandler(callback)
                },
                comments: {
                    registerOnReopenResolvedComment: (cb)=>commentService.registerOnReopenResolvedComment(cb),
                    registerOnUpdateComment: (callback)=>commentService.registerOnUpdateComment(callback),
                    registerOnResolveComment: (callback)=>commentService.registerOnResolveComment(callback),
                    onCommentsPanelSelectThread: (callback)=>commentService.registerSelectThreadHandler(callback),
                    selectCommentThread: (threadId)=>commentService.selectCommentThread(threadId),
                    registerOnDeleteComment: (callback)=>commentService.registerOnDeleteComment(callback),
                    triggerCommentPanelRefresh: ()=>commentService.triggerCommentPanelRefresh()
                },
                ...(0, $9wGTI.fg)('confluence_team_presence_database') ? {
                    shell: {
                        updateCollaborators: (collaborators)=>{
                            (0, $hzClJ.contentCollaboratorsService).updateActions(collaborators);
                        },
                        updateMainActions: ()=>{},
                        updateBoardStatus: ()=>{},
                        updateMoreActions: ()=>{},
                        updateTitle: (title)=>{
                            (0, $cgpF0.contentTypesTitleServiceSingleton).updateTitle(title);
                        },
                        isFeatureActive: (name)=>isDatabaseFeatureEnabled(name)
                    }
                } : {
                    shell: {
                        updateCollaborators: ()=>{},
                        updateMainActions: ()=>{},
                        updateBoardStatus: ()=>{},
                        updateMoreActions: ()=>{},
                        updateTitle: (title)=>{
                            (0, $cgpF0.contentTypesTitleServiceSingleton).updateTitle(title);
                        },
                        isFeatureActive: (name)=>isDatabaseFeatureEnabled(name)
                    }
                },
                modals: {
                    showFlag: (props)=>{
                        flagService.showFlag(props);
                    },
                    hideFlag: (id)=>{
                        flagService.hideFlag(id);
                    }
                }
            },
            onContentLoadSucceeded: /**
			 * Methods below here are not part of the shared content types bridge API and are specific to Databases.
			 * Please consider moving them to the shared content types bridge API if they are useful for other content types.
			 * See @confluence/content-types-bridge for more details.
			 */ onContentLoadSucceeded,
            onContentLoadFailed: onContentLoadFailed,
            updateBoardStatus: (status)=>{
                (0, $j96gu.contentBoardStatusService).updateActions(status);
            },
            updateMoreActions: (items)=>{
                (0, $lUzNY.contentMoreActionsService).updateActions(items);
            },
            onboardingService: onboardingService,
            objectSidebarMethods: {
                updateObjectSidebarControlState: updateObjectSidebarControlState,
                hideObjectSidebarPanel: ()=>{
                    // we hide an object sidebar panel in canvas when we open a db panel,
                    // so we must also hide the object sidebar controls
                    hideObjectSidebar(()=>updateObjectSidebarControlState(false));
                },
                registerChangeObjectSidebarShownHandler: (cb)=>{
                    objectSidebarService.registerChangeObjectSidebarShownHandler_LEGACY(cb);
                }
            },
            onThemeChange: (callback)=>{
                themingService.onThemeChange(callback);
            },
            registerOnReopenResolvedComment: (cb)=>{
                commentService.registerOnReopenResolvedComment(cb);
            },
            getVersionName: getVersionName,
            onCloseConfluenceSidePanel: onCloseConfluenceSidePanel,
            databaseSpotlightCloseRef: databaseSpotlightCloseRef,
            goToContent: ()=>{},
            goToHome: ()=>{},
            goToContainer: ()=>{},
            onTokenInit: ()=>{},
            onTokenChange: ()=>{},
            onContainerInit: ()=>{},
            onContainerChange: ()=>{},
            preloadToken: ()=>{},
            getToken: ()=>{},
            refreshToken: ()=>{},
            sessionData: {}
        }), [
        onContentLoadSucceeded,
        onContentLoadFailed,
        onboardingService,
        updateObjectSidebarControlState,
        hideObjectSidebar,
        themingService,
        getVersionName,
        onCloseConfluenceSidePanel,
        objectSidebarService,
        databaseSpotlightCloseRef,
        commentService,
        hideDetailsPanel,
        showDetailsPanel,
        flagService,
        isDatabaseFeatureEnabled
    ]);
};





const $3651949f5f8d6b09$export$60546e97e735ec67 = (iframeRef)=>{
    const messageCallback = (0, $42omo.useCallback)((event)=>{
        const isFromExpectedIframe = iframeRef.current && event.source === iframeRef.current.contentWindow;
        const isStringData = typeof event.data === 'string';
        if (isFromExpectedIframe && isStringData) try {
            window.parent.postMessage(event.data, '*');
        } catch (e) {}
    }, [
        iframeRef
    ]);
    (0, $42omo.useEffect)(()=>{
        window.addEventListener('message', messageCallback);
        return ()=>{
            window.removeEventListener('message', messageCallback);
        };
    }, [
        messageCallback
    ]);
};



const $a2ffc01c1841fc99$export$f8f46d431e9f554b = (bridgeClient)=>{
    if (!bridgeClient) return undefined;
    try {
        const bridgeClientData = JSON.parse(bridgeClient);
        const dbClientId = bridgeClientData?.localClientId;
        // Return undefined for null or undefined values, but keep empty strings
        return dbClientId === null || dbClientId === undefined ? undefined : dbClientId;
    } catch  {
        // Silently swallow parsing errors
        return undefined;
    }
};





const $b7c12953fdd18d98$export$64e4c7411efba81f = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, contentReferenceId: contentReferenceId, spaceKey: spaceKey, dataSecurityPolicyPageExport: dataSecurityPolicyPageExport, identity: identity, refetch: refetch, spaceId: spaceId, spaceName: spaceName, title: title, loading: loading, isSmartLinkEmbed: isSmartLinkEmbed, headerHeight: headerHeight, bannerState: bannerState, isSidePanelOpen: isSidePanelOpen, dbVersionHistory: dbVersionHistory, objectSidebarService: objectSidebarService, flags: flags, isRovoParentProduct: isRovoParentProduct })=>{
    const iframeRef = (0, $42omo.useRef)(null);
    const databaseSpotlightCloseRef = (0, $42omo.useRef)(null);
    (0, $3651949f5f8d6b09$export$60546e97e735ec67)(iframeRef);
    const onboardingService = (0, $43867371740d70bb$export$df4cf7f032c0f91f)();
    const { isObjectSidebarShown: isObjectSidebarShown } = (0, $aWwYt.useObjectSidebarState)();
    const { includeTopNav: includeTopNav } = (0, $42omo.useContext)((0, $jxpvN.BannerContext));
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const params = (0, $16e23a2b49af27f1$export$2c4cdbd6638ace58)();
    // Parse bridgeClient to extract dbClientId for Rovo receiver
    const rovoReceiverId = (0, $a2ffc01c1841fc99$export$f8f46d431e9f554b)(params.bridgeClient);
    const databaseVersionId = isSidePanelOpen && !dbVersionHistory.versionId ? 'latest' : dbVersionHistory.versionId;
    const { initialUrl: initialUrl, bridgeData: bridgeData } = (0, $c8b27b28e81df3c6$export$d7893480d4d656b3)({
        contentId: contentId,
        contentReferenceId: contentReferenceId,
        spaceKey: spaceKey,
        dataSecurityPolicyPageExport: dataSecurityPolicyPageExport,
        identity: identity,
        refetch: refetch,
        spaceId: spaceId,
        spaceName: spaceName,
        title: title,
        version: params['databases-frontend'],
        isSmartLinkEmbed: isSmartLinkEmbed,
        versionId: databaseVersionId,
        presentationMode: params.presentationMode,
        bridgeClient: params.bridgeClient,
        isRovoParentProduct: isRovoParentProduct
    });
    const handleDatabaseSpotlightClose = (event)=>{
        if (iframeRef?.current && !iframeRef.current.contains(event.target) && databaseSpotlightCloseRef.current) databaseSpotlightCloseRef.current();
    };
    const bridgeMethods = (0, $6d02a548e60e8bb9$export$9a572d8e8a178282)({
        experienceTracker: experienceTracker,
        onboardingService: onboardingService,
        segmentMetric: (0, $41842fe17346d9f1$export$c166e9a70918b277),
        experienceName: (0, $irVI7.DATABASE_CONTENT_EXPERIENCE),
        versionHistoryExperienceName: (0, $irVI7.DATABASE_LOAD_HISTORICAL_VERSION),
        versionId: databaseVersionId,
        getVersionName: dbVersionHistory.getVersionName,
        objectSidebarService: objectSidebarService,
        databaseSpotlightCloseRef: databaseSpotlightCloseRef,
        flags: flags
    });
    // @ts-expect-error -- This is a temporary solution to enable migration to the new bridge API
    window.contentAPI = bridgeMethods;
    const onIframeLoaded = (0, $42omo.useCallback)((e)=>{
        const iframe = e.target;
        if (iframe) {
            iframeRef.current = iframe;
            if (iframe.contentWindow) {
                iframe.contentWindow.databaseBridge = bridgeMethods;
                iframe.contentWindow.postMessage({
                    type: 'bridge-ready'
                }, '*');
            }
        }
    }, [
        bridgeMethods
    ]);
    (0, $42omo.useEffect)(()=>{
        if (databaseVersionId) experienceTracker.start({
            name: (0, $irVI7.DATABASE_LOAD_HISTORICAL_VERSION)
        });
    }, [
        databaseVersionId,
        experienceTracker
    ]);
    // Track clicks outside of the DB iframe to properly close database spotlights within the iframe
    (0, $42omo.useEffect)(()=>{
        document.addEventListener('mousedown', handleDatabaseSpotlightClose);
        return ()=>document.removeEventListener('mousedown', handleDatabaseSpotlightClose);
    });
    return (0, $6mKj3.expVal)('confluence_frontend_iframe_exclusion', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
        name: "confluence-database-iframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
        ref: iframeRef,
        // Every time we update iframe src attribute directly we push to the history stack which breaks the back/forward button
        // To prevent this, we pass in a key attribute to ensure that we remount the iframe each time to avoid adding to history stack
        key: initialUrl,
        src: initialUrl,
        title: (0, $0c1479740d6f6957$export$94780835089c97fc),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $39098ba5b77e4682$export$7cc78372144ec97a)(!isSmartLinkEmbed && !isMobileApp ? bannerState.getTotalHeight(includeTopNav) + headerHeight : 0, isSidePanelOpen, isObjectSidebarShown),
        "data-bridge-data": !loading ? JSON.stringify(bridgeData) : undefined,
        "data-rovo-receiver-id": rovoReceiverId,
        onLoad: onIframeLoaded
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
        ref: iframeRef,
        // Every time we update iframe src attribute directly we push to the history stack which breaks the back/forward button
        // To prevent this, we pass in a key attribute to ensure that we remount the iframe each time to avoid adding to history stack
        key: initialUrl,
        src: initialUrl,
        title: (0, $0c1479740d6f6957$export$94780835089c97fc),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $39098ba5b77e4682$export$7cc78372144ec97a)(!isSmartLinkEmbed && !isMobileApp ? bannerState.getTotalHeight(includeTopNav) + headerHeight : 0, isSidePanelOpen, isObjectSidebarShown),
        "data-bridge-data": !loading ? JSON.stringify(bridgeData) : undefined,
        "data-rovo-receiver-id": rovoReceiverId,
        onLoad: onIframeLoaded
    });
});









var $ck0S9 = parcelRequire("ck0S9");

const $a523eda9c049a947$export$1fbc2f5c44318989 = ()=>{
    const { formatDate: formatDate, formatTime: formatTime } = (0, $8C5kA.default)();
    const [databaseVersionId, setDatabaseVersionId] = (0, $42omo.useState)(null);
    const versionName = (0, $42omo.useRef)(null);
    const getVersionName = ()=>versionName.current;
    const setDatabaseVersion = (0, $42omo.useCallback)((version)=>{
        setDatabaseVersionId(version?.contentProperties?.latest?.externalVersionId || null);
        versionName.current = version ? (0, $ck0S9.getFormattedDate)(version.updatedTime, formatDate, formatTime) : null;
    }, [
        formatDate,
        formatTime
    ]);
    return {
        versionId: databaseVersionId,
        getVersionName: getVersionName,
        setDatabaseVersion: setDatabaseVersion
    };
};


const $1b79e24160cb7a6e$var$databaseShellContainerStyles = (0, $ecnYn.xcss)({
    height: '100%',
    width: '100%',
    position: 'relative',
    overflow: 'hidden'
});
const $1b79e24160cb7a6e$var$contentHeaderWrapperStyles = (0, $ecnYn.xcss)({
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid',
    borderBottomColor: 'color.border',
    backgroundColor: 'elevation.surface'
});
const $1b79e24160cb7a6e$var$archivedBannerContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
});
// If any additional fixed margins (like the fixed archive banner margin we used to have here) are
// needed for SSR, then add them to SSR_HEADER_HEIGHT because in SSR we can't use ResizeObserver to
// tell us how big the headers actually are.
const $1b79e24160cb7a6e$var$SSR_HEADER_HEIGHT = (0, $d371903a3743b8b2$export$d931923c7a26ab66);
const $1b79e24160cb7a6e$export$e5caa17eb05f2fbe = ({ spaceKey: spaceKey, contentId: contentId, contentReferenceId: contentReferenceId, loading: loading, queryNetworkStatus: queryNetworkStatus, spaceId: spaceId, spaceName: spaceName, title: title, identity: identity, refetch: refetch, dataSecurityPolicyPageExport: dataSecurityPolicyPageExport, flags: flags })=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const isLoadingNewContent = loading && queryNetworkStatus !== (0, $9wEpK.NetworkStatus).refetch;
    const { bannerHeight: archivedBannerHeight, setBannerElement: setArchivedBannerHeight } = (0, $bvJwp.useResizeBanner)(isSSR);
    const { bannerHeight: databaseHeaderHeight, setBannerElement: setDatabaseHeaderElement, setBannerHeight: setDatabaseHeaderHeight } = (0, $bvJwp.useResizeBanner)(isSSR);
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const shouldShowMobileWebView = (0, $8dwdz.shouldShowMobileWeb)() && !isMobileApp;
    const contentActions = (0, $c2b2a5ea7327f30e$export$7628427a4e8bf2d8)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const onboardingService = (0, $43867371740d70bb$export$df4cf7f032c0f91f)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const [eventService] = (0, $42omo.useState)(()=>new (0, $4RbZ3.ContentTypeEventService)());
    const [objectSidebarService] = (0, $42omo.useState)(()=>new (0, $3r60T.ContentTypesObjectSidebarService)());
    const params = (0, $16e23a2b49af27f1$export$2c4cdbd6638ace58)();
    const isSmartLinkEmbed = params['isSmartLinkEmbed'];
    const isRovoParentProduct = params['isRovoParentProduct'];
    const dbVersionHistory = (0, $a523eda9c049a947$export$1fbc2f5c44318989)();
    const isVersionHistoryEnabled = (0, $5thep.useIsVersionHistoryEnabled)('database');
    const isSidePanelOpen = (0, $ai7NK.useIsSidePanelOpen)();
    const { hideSidePanel: hideSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const behavior = (0, $aWwYt.useBehavior)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    // Used to clear existing comments data when we leave the space overview page
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { clearCommentsData: clearCommentsData } = (0, $8i27m.useCommentsDataActions)();
    (0, $exahZ.useRegisterCommentsPanelCallbacks)();
    (0, $essql.useUnreadCommentsSetup)({
        pageId: contentId
    });
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if ((0, $9wGTI.fg)('cc-whiteboards-consolidating-comments')) {
                resetInitialDataLoadedMap();
                clearCommentsData();
            }
        };
    }, [
        clearCommentsData,
        resetInitialDataLoadedMap,
        contentId
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            hideSidePanel();
        };
    }, [
        hideSidePanel
    ]);
    (0, $42omo.useEffect)(()=>{
        // hide sidebar when navigating between different databases
        hideObjectSidebar();
    }, [
        contentId,
        hideObjectSidebar
    ]);
    (0, $42omo.useEffect)(()=>{
        // hide the object sidebar panels when we open version history.
        // when we have the version history panel open, the sidebar control is not visible,
        // so we will never run into the case where we have version history open and then the user
        // opens the comments/details panel
        if (isObjectSidebarShown && isSidePanelOpen) hideObjectSidebar();
    }, [
        isObjectSidebarShown,
        isSidePanelOpen,
        hideObjectSidebar
    ]);
    const updateDatabaseHeaderEvents = (0, $42omo.useCallback)((event)=>{
        const newData = {
            objectType: 'database'
        };
        const newAttributes = {
            contentType: 'database'
        };
        event.update((payload)=>{
            const mergedAttributes = {
                ...payload.data?.attributes,
                ...newAttributes
            };
            return {
                ...payload,
                data: {
                    ...payload.data,
                    ...newData,
                    attributes: mergedAttributes
                }
            };
        });
    }, []);
    const isParentProductRovo = isRovoParentProduct && (0, $9wGTI.fg)('aifc_create_enabled_ga');
    // Always show the Object Header if enabled by the feature gate - but keep the current behavior
    // for the old content header which isn't shown in SSR
    const isHeaderShown = !isSSR || (0, $9wGTI.fg)('confluence_frontend_content_wrapper');
    const showContentTypesHeader = isHeaderShown && !isLoadingNewContent && !params.isSmartLinkEmbed && !isMobileApp && !!userId && !isParentProductRovo;
    // Use a fixed height for the SSR'ed Object Header to avoid layout shift, because ResizeObserver is not available in SSR
    const contentHeaderHeight = isSSR && !isMobileApp && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? $1b79e24160cb7a6e$var$SSR_HEADER_HEIGHT : databaseHeaderHeight;
    const headerHeight = (!isMobileApp ? archivedBannerHeight : 0) + contentHeaderHeight;
    const showContentTypesHeaderPlaceholder = isLoadingNewContent && !params.isSmartLinkEmbed && !isMobileApp && !!userId;
    const openSidePanel = isSidePanelOpen && (0, $9wGTI.fg)('confluence_frontend_databases_version_history_ui');
    const { trackExperience: trackExperience } = (0, $aCrkK.useVersionHistoryExperienceTracking)();
    (0, $42omo.useEffect)(()=>{
        const flowQueryParam = routeDataRef.current?.queryParams?.flow;
        if (flowQueryParam === 'restoreVersion') trackExperience({
            contentType: 'database',
            experience: 'restoreExperience',
            task: 'succeed'
        });
    }, [
        routeDataRef,
        contentId,
        trackExperience
    ]);
    if (!loading && !contentReferenceId) {
        experienceTracker.fail({
            name: (0, $irVI7.DATABASE_EXPERIENCE),
            error: new Error('DatabaseUnifiedQuery did not return valid referenceId')
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $frfjk.NotFoundContainer), {
            route: (0, $1NBp8.DATABASE_VIEW),
            spaceKey: spaceKey
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2b13bdf75bdd8b89$export$a7243c3337e5cc55), {
        onboardingService: onboardingService
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $41842fe17346d9f1$export$189913fef8bf279d), {
        contentId: contentId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: (0, $39098ba5b77e4682$export$5d6291e520f07268)
    }, (bannerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            direction: "column",
            xcss: $1b79e24160cb7a6e$var$databaseShellContainerStyles
        }, showContentTypesHeaderPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eStoj.ContentTypesHeaderPlaceholder), null), showContentTypesHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
            onEvent: updateDatabaseHeaderEvents
        }, isVersionHistoryEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "pinned-ct-header",
            xcss: $1b79e24160cb7a6e$var$contentHeaderWrapperStyles,
            ref: setDatabaseHeaderElement
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8Qzg.ContentTypesHeader), {
            contentId: contentId,
            contentActions: contentActions
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8Qzg.ContentTypesHeader), {
            contentId: contentId,
            contentActions: contentActions,
            onHeightChange: setDatabaseHeaderHeight
        })), !isSmartLinkEmbed && !isMobileApp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $1b79e24160cb7a6e$var$archivedBannerContainerStyles,
            ref: setArchivedBannerHeight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $deZfn.ArchivedPageBanner), {
            contentId: contentId,
            marginStyle: "both"
        }))), shouldShowMobileWebView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8fba8dcee85bb26b$export$7101457c6893431b), {
            bannerState: bannerState
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
            metric: (0, $41842fe17346d9f1$export$c166e9a70918b277)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7c12953fdd18d98$export$64e4c7411efba81f), {
            contentId: contentId,
            contentReferenceId: contentReferenceId,
            spaceKey: spaceKey,
            dataSecurityPolicyPageExport: dataSecurityPolicyPageExport,
            identity: identity,
            refetch: refetch,
            spaceId: spaceId,
            spaceName: spaceName,
            title: title,
            loading: loading,
            isSmartLinkEmbed: isSmartLinkEmbed,
            headerHeight: headerHeight,
            bannerState: bannerState,
            isSidePanelOpen: isSidePanelOpen,
            dbVersionHistory: dbVersionHistory,
            objectSidebarService: objectSidebarService,
            flags: flags,
            isRovoParentProduct: isRovoParentProduct
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fQa5o.OnboardingNthUserContentTypeSpotlight), {
            contentType: (0, $fQa5o.ContentType).DATABASE,
            contentId: contentId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $85ed939a521e23e1$export$78a0df6be65b7b84), {
            openSidePanel: openSidePanel,
            contentId: contentId,
            spaceKey: spaceKey,
            isObjectSidebarShown: isObjectSidebarShown,
            behavior: behavior,
            databaseHeaderHeight: databaseHeaderHeight,
            bannerState: bannerState,
            title: title,
            eventService: eventService,
            dbVersionHistory: dbVersionHistory,
            isRovoParentProduct: isRovoParentProduct
        }), !isSSR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fyPYm.ContentViewedEvent), {
            contentId: contentId
        })))));
};
const $1b79e24160cb7a6e$export$148ae2ec18546c6b = (0, $7aRa9.withFlags)($1b79e24160cb7a6e$export$e5caa17eb05f2fbe);



var $2iJnA = parcelRequire("2iJnA");

const $69263c81a0cd2f81$var$DatabaseContainerComponent = ({ contentId: contentId, spaceKey: spaceKey })=>{
    const { networkStatus: networkStatus, refetch: refetch, ...databaseUnifiedQueryResult } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $2iJnA.DatabaseUnifiedQuery), {
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            // The DSP query doesn't currently user the content version value, so using a fixed value
            contentVersion: 1
        },
        notifyOnNetworkStatusChange: true,
        context: {
            single: true
        }
    });
    const { data: data, loading: loading } = databaseUnifiedQueryResult;
    // Land in sample space experiment
    const { xflowSpaceCreated: xflowSpaceCreated, loading: isEligibilityLoading } = (0, $lsi6E.useIsEligibleLandInSampleSpaceXflow)();
    const shouldShowExperiment = xflowSpaceCreated && !isEligibilityLoading;
    const content = data?.content?.nodes || [];
    const contentReferenceId = content[0]?.referenceId;
    const spaceId = content[0]?.space?.id;
    const spaceName = content[0]?.space?.name;
    const title = content[0]?.title || '';
    const identity = {
        accountId: data?.user?.id,
        nickname: data?.user?.displayName,
        picture: data?.user?.photos?.find((photo)=>photo?.isPrimary)?.value,
        email: data?.user?.emails?.find((email)=>email?.isPrimary)?.value,
        locale: data?.user?.locale
    };
    const onEventHandler = (0, $42omo.useCallback)(()=>{
        refetch();
    }, [
        refetch
    ]);
    const onRestrictionUpdatedPubSubEvent = (0, $42omo.useCallback)(()=>{
        if (![
            'DUAL',
            'GRAPHQL'
        ].includes((0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', '')) || !(0, $6mKj3.expVal)('cc_fps_migration_content-restriction-updated', 'isEnabled', false)) onEventHandler();
    }, [
        onEventHandler
    ]);
    (0, $bT0se.usePubSubEvent)({
        contentId: contentId,
        contentType: 'database',
        eventName: `restrictionUpdated:database`,
        attribution: (0, $3IBnw.Attribution).CONTENT_TYPES,
        onEvent: onRestrictionUpdatedPubSubEvent,
        skip: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('cc_fps_migration_content-restriction-updated', 'isEnabled', false) && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') && (0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', '') === 'GRAPHQL'
    });
    (0, $g01A4.useContentRestrictionSubscriptionEvent)({
        contentId: contentId,
        contentType: 'database',
        callback: onEventHandler,
        subscriberId: 'DatabaseContainerSubscription'
    });
    const pageExport = data?.dataSecurityPolicy?.isActionEnabledForContent?.allowed;
    const dataSecurityPolicyPageExport = pageExport != undefined ? pageExport : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $927b60c9423d7a64$export$7b99cc330037c4ec), {
        route: (0, $1NBp8.DATABASE_VIEW),
        contentQueryResult: databaseUnifiedQueryResult
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $83FW4.CommentProvider), null, shouldShowExperiment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $660Iy.AnnouncementBanner), {
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1sAhh.DatabaseFlag), {
        spaceKey: spaceKey
    }))) : null, (0, $6mKj3.expVal)('confluence_modernized_move_dialog', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lfmjq.MovePageSuccessFlag), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1b79e24160cb7a6e$export$148ae2ec18546c6b), {
        spaceKey: spaceKey,
        contentId: contentId,
        contentReferenceId: contentReferenceId,
        loading: loading,
        spaceId: spaceId,
        queryNetworkStatus: networkStatus,
        spaceName: spaceName,
        title: title,
        identity: identity,
        refetch: refetch,
        dataSecurityPolicyPageExport: dataSecurityPolicyPageExport
    }))));
};
const $69263c81a0cd2f81$export$7c1da10f9a174f35 = $69263c81a0cd2f81$var$DatabaseContainerComponent;
module.exports["DatabaseContainer"] = $69263c81a0cd2f81$export$7c1da10f9a174f35;

});

parcelRegister("lfmjq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $7aRa9 = parcelRequire("7aRa9");

const $0d3a7c976c53fe50$export$687b1508b29e79eb = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const intl = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const moved = urlParams.get('moved');
        if (moved === 'success') {
            // Show the success flag
            flags.showSuccessFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $0d3a7c976c53fe50$var$i18n.movePageItemMovedTitle),
                isAutoDismiss: true
            });
            // Clean up URL parameters without causing a page reload
            urlParams.delete('moved');
            const newParams = urlParams.size > 0 ? `?${urlParams.toString()}` : '';
            const newUrl = `${window.location.pathname}${newParams}${window.location.hash}`;
            window.history.replaceState({}, '', newUrl);
        }
    }, [
        flags,
        intl
    ]);
    return null;
});
const $0d3a7c976c53fe50$var$i18n = (0, $cgtv4.defineMessages)({
    movePageItemMovedTitle: {
        id: "page-tree.move-page.flag.success",
        defaultMessage: "Item moved"
    }
});
module.exports["MovePageSuccessFlag"] = $0d3a7c976c53fe50$export$687b1508b29e79eb;

});

parcelRegister("83FW4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jil6p = parcelRequire("jil6p");

const $c63b34a18b0f8af5$export$f70cbd0dcaa225fc = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $c63b34a18b0f8af5$export$71e478688b05b68d = ({ children: children })=>{
    const commentService = (0, $42omo.useRef)(new (0, $jil6p.ContentTypesCommentService)()).current;
    (0, $42omo.useEffect)(()=>{
        // Cleanup on unmount
        return ()=>{
            commentService.dispose();
        };
    }, [
        commentService
    ]);
    const handleSelectThread = (0, $42omo.useCallback)((threadId)=>{
        commentService.selectCommentThread(threadId);
    }, [
        commentService
    ]);
    (0, $42omo.useEffect)(()=>{
        commentService.registerSelectThreadHandler(handleSelectThread);
        return ()=>{
            // un-set the handler on component unmount
            commentService.registerSelectThreadHandler(undefined);
        };
    }, [
        commentService,
        handleSelectThread
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>({
            commentService: commentService
        }), [
        commentService
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c63b34a18b0f8af5$export$f70cbd0dcaa225fc.Provider, {
        value: contextValue
    }, children);
};
module.exports["CommentContext"] = $c63b34a18b0f8af5$export$f70cbd0dcaa225fc;
module.exports["CommentProvider"] = $c63b34a18b0f8af5$export$71e478688b05b68d;

});

parcelRegister("jil6p", function(module, exports) {
class $569106325e18c3c1$export$6c0a8b19f951b1bc {
    dispose() {
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
    }
    /**
   * Register a handler for thread selection events
   */ registerSelectThreadHandler(handler) {
        this.selectThreadHandler = handler;
    }
    /**
   * Handle thread selection events
   */ handleSelectThread(threadId) {
        this.selectThreadHandler?.(threadId);
    }
    /**
   * Register a handler for show panel events
   */ registerShowPanelHandler(handler) {
        this.showPanelHandler = handler;
    }
    /**
   * Show the comments panel
   */ showPanel(threadId) {
        this.showPanelHandler?.(threadId);
    }
    /**
   * Register a handler for hide panel events
   */ registerHidePanelHandler(handler) {
        this.hidePanelHandler = handler;
    }
    /**
   * Hide the comments panel
   */ hidePanel() {
        this.hidePanelHandler?.();
    }
    /**
   * Register a handler for select comment thread events
   */ registerSelectCommentThreadHandler(handler) {
        this.selectCommentThreadHandler = handler;
    }
    /**
   * Select a specific comment thread
   */ selectCommentThread(threadId) {
        this.selectCommentThreadHandler?.(threadId);
    }
    /**
   * This is called in databases to register the callback confluence FE
   * will call after a resolved comment has been reopened
   */ registerOnReopenResolvedComment(callback) {
        this.reopenResolvedCommentHandler = callback;
    }
    /**
   * This will be called in confluence FE after we have successfully
   * reopened a resolved comment. This allows databases to re-fetch and re-render
   * the comment
   */ onReopenResolvedComment(commentIds) {
        this.reopenResolvedCommentHandler?.(commentIds);
    }
    /**
   * Register a handler for delete comment events (called by content types)
   */ registerOnDeleteComment(callback) {
        this.onDeleteCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onDeleteComment(threadKey) {
        this.onDeleteCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for update comment events (called by content types)
   */ registerOnUpdateComment(callback) {
        this.onUpdateCommentHandler = callback;
    }
    /**
   * Handle an update comment event (fired by CF)
   */ onUpdateComment(threadKey) {
        this.onUpdateCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for trigger comment panel refresh events (called by content types)
   */ registerTriggerCommentPanelRefresh(handler) {
        this.triggerCommentPanelRefreshHandler = handler;
        // If a refresh was requested while no handler was registered, trigger it now
        // so the newly mounted view refetches immediately.
        if (handler && this.hasPendingCommentPanelRefresh) {
            this.hasPendingCommentPanelRefresh = false;
            handler();
        }
    }
    /**
   * Register a handler for resolve comment events (called by content types)
   */ registerOnResolveComment(callback) {
        this.onResolveCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onResolveComment(threadKey) {
        this.onResolveCommentHandler?.(threadKey);
    }
    /**
   * Trigger a refresh of the comment panel
   */ async triggerCommentPanelRefresh() {
        if (this.triggerCommentPanelRefreshHandler) {
            await this.triggerCommentPanelRefreshHandler();
            return;
        }
        // No handler registered means the panel is likely closed/unmounted.
        // Remember to refresh on next registration.
        this.hasPendingCommentPanelRefresh = true;
    }
    /**
   * Register a handler for update reaction events (called by content types)
   * @param callback - A callback function that will be called when a reaction is updated
   */ registerOnUpdateReaction(callback) {
        this.onUpdateReactionHandler = callback;
    }
    /**
   * Handle an update reaction event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param emojiId - The emoji ID of the reaction
   * @param actionType - The action type of the reaction
   * @returns
   */ onUpdateReaction(threadKey, emojiId, actionType) {
        return this.onUpdateReactionHandler?.(threadKey, emojiId, actionType);
    }
    constructor(){
        this.selectThreadHandler = void 0;
        this.reopenResolvedCommentHandler = void 0;
        this.showPanelHandler = void 0;
        this.hidePanelHandler = void 0;
        this.selectCommentThreadHandler = void 0;
        this.onDeleteCommentHandler = void 0;
        this.triggerCommentPanelRefreshHandler = void 0;
        // When a refresh is requested while the comments panel is unmounted (no handler
        // registered), we set this flag so the next registration triggers a refetch.
        this.hasPendingCommentPanelRefresh = false;
        this.onUpdateCommentHandler = void 0;
        this.onResolveCommentHandler = void 0;
        this.onUpdateReactionHandler = void 0;
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.hasPendingCommentPanelRefresh = false;
    }
}
module.exports["ContentTypesCommentService"] = $569106325e18c3c1$export$6c0a8b19f951b1bc;

});

parcelRegister("3Vzvh", function(module, exports) {
$parcel$export(module.exports, "AnnouncementBanner", () => (parcelRequire("660Iy")).AnnouncementBanner);

var $660Iy = parcelRequire("660Iy");


});

parcelRegister("660Iy", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $cwkWT = parcelRequire("cwkWT");


var $5tOl1 = parcelRequire("5tOl1");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $luv00 = parcelRequire("luv00");


var $fFd9S = parcelRequire("fFd9S");


var $d0hiC = parcelRequire("d0hiC");


var $ivb8S = parcelRequire("ivb8S");

function $6023e07f07fc0e3f$var$isErrorHandled(error) {
    // Mark unauthorized error as handled and not report to monitoring client
    if ((0, $1uFM6.isUnauthorizedError)(error) || error?.graphQLErrors?.[0]?.message === 'unauthorized') {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    return false;
}
const $6023e07f07fc0e3f$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    announcementText: {
        id: "experiment-land-in-sample-space-xflow.announcement.text",
        defaultMessage: "When you\u2019re ready, try adding content here or create a fresh space from scratch. {createSpaceLink}"
    },
    bannerDismiss: {
        id: "experiment-land-in-sample-space-xflow.announcement.dismiss",
        defaultMessage: "Dismiss"
    }
});
const $6023e07f07fc0e3f$var$styles = {
    banner: "_1yt41b66 _1o3i1l7x _1il9nqa1 _1doce4h9 _bfhkp2ly _syazazsu _1pby1nn1",
    dismiss: "_nd5l1bvj _1e0c1txw _10fph9n0",
    message: "_nd5l13um"
};
const $6023e07f07fc0e3f$export$eb84257d269db72c = ({ spaceKey: spaceKey })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        ...Object.values((0, $d0hiC.LAND_IN_SAMPLE_SPACE_ONBOARDING_STATE_KEYS))
    ]);
    const { hasDismissedBanner: hasDismissedBanner } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (spaceKey !== 'XFLOW') return null;
    const handleDismissClick = ()=>{
        setOnboardingState({
            key: (0, $d0hiC.LAND_IN_SAMPLE_SPACE_ONBOARDING_STATE_KEYS).hasDismissedBanner,
            value: 'true'
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'sampleSpaceAccouncementBannerDismissButton',
                source: 'jiraConnectedSampleSpaceAnnouncementBanner'
            }
        }).fire();
    };
    if (onboardingStateError && !$6023e07f07fc0e3f$var$isErrorHandled(onboardingStateError)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: onboardingStateError
    }));
    if (hasDismissedBanner || onboardingStateLoading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": "x-flow-sample-space-announcement-banner",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cwkWT.default), {
        templateAreas: [
            'empty message close'
        ],
        templateColumns: "1fr auto 1fr",
        xcss: $6023e07f07fc0e3f$var$styles.banner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignInline: "center",
        alignBlock: "center",
        xcss: $6023e07f07fc0e3f$var$styles.message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$6023e07f07fc0e3f$export$a7357cdd1f0b0168.announcementText,
        values: {
            createSpaceLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fFd9S.CreateSpaceButton), {
                appearance: "link-button",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))), {
                    label: ""
                }),
                source: "jiraConnectedSampleSpaceAnnouncementBanner"
            })
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $6023e07f07fc0e3f$var$styles.dismiss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: formatMessage($6023e07f07fc0e3f$export$a7357cdd1f0b0168.bannerDismiss),
        isTooltipDisabled: false,
        onClick: handleDismissClick
    }))));
};
module.exports["AnnouncementBanner"] = $6023e07f07fc0e3f$export$eb84257d269db72c;

});

parcelRegister("luv00", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

function $8a88875ffe13fd4c$export$30b62f74ca853d7d() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
}
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("fFd9S", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $lBYCH = parcelRequire("lBYCH");


var $jmjWc = parcelRequire("jmjWc");


var $lqy4C = parcelRequire("lqy4C");


var $eSLr0 = parcelRequire("eSLr0");


var $4vyfK = parcelRequire("4vyfK");


var $9wGTI = parcelRequire("9wGTI");


var $jyA9t = parcelRequire("jyA9t");


var $bQm3c = parcelRequire("bQm3c");


var $bAyaS = parcelRequire("bAyaS");


var $1KBSi = parcelRequire("1KBSi");


var $b118X = parcelRequire("b118X");


var $ij8WD = parcelRequire("ij8WD");


var $bNqTI = parcelRequire("bNqTI");


const $9796960dd5ca5d58$var$CreateSpaceMenuItem = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "jJ1M0",
    name: "CreateSpaceMenuItem",
    loader: async ()=>(await (parcelRequire("b4pMV"))).CreateSpaceMenuItem
});

const $9796960dd5ca5d58$var$CreateSpaceMenuItemNav3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VVNmu",
    name: "CreateSpaceMenuItemNav3",
    loader: async ()=>(await (parcelRequire("2M1tD"))).CreateSpaceMenuItemNav3
});

const $9796960dd5ca5d58$var$CreateSpaceStandardButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VkTYH",
    name: "CreateSpaceStandardButton",
    loader: async ()=>(await Promise.resolve((parcelRequire("b118X")))).CreateSpaceStandardButton,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b118X.CreateSpaceStandardButtonLoading), null)
});

const $9796960dd5ca5d58$var$CreateSpacePlusButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Fj6Ys",
    name: "CreateSpacePlusButton",
    loader: async ()=>(await (parcelRequire("bK94N"))).CreateSpacePlusButton
});
const $9796960dd5ca5d58$export$ed60484c61c6dfb2 = ({ appearance: appearance, source: source, onClick: onClick, customFocusRef: customFocusRef, icon: icon })=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { canCreateSpace: canCreateSpace } = (0, $1KBSi.useCanCreateSpace)();
    const { openDrawer: openDrawer } = (0, $bAyaS.useCreateSpaceStoreActions)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-space-button'
    });
    const { resetStickySearchRef: resetStickySearchRef } = (0, $42omo.useContext)((0, $lBYCH.AppNavigationContext));
    const createSpaceButtonRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const preloadCreateSpace = ()=>{
        (0, $4vyfK.preloadWebItemLocation)({
            location: (0, $eSLr0.CREATE_SPACE_DIALOG)
        });
    };
    const handleCreate = (0, $42omo.useCallback)((e)=>{
        resetStickySearchRef?.current?.();
        const location = appearance === 'menu-item-nav3-with-icon' ? 'topCreateNav' : undefined;
        if (isRovoLLMEnabled && (0, $9wGTI.fg)('aifc_space_creation_enabled')) openModal(source, '');
        else openDrawer(customFocusRef || createSpaceButtonRef, location);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createSpaceButton',
                source: source,
                attributes: {
                    location: location
                }
            }
        }).fire();
        e.stopPropagation();
        onClick?.();
    }, [
        resetStickySearchRef,
        appearance,
        openDrawer,
        openModal,
        customFocusRef,
        createAnalyticsEvent,
        source,
        onClick,
        isRovoLLMEnabled
    ]);
    const handleClick = (0, $42omo.useCallback)((e)=>enforceStorageLimit(handleCreate)(e), [
        enforceStorageLimit,
        handleCreate
    ]);
    if (!canCreateSpace) return null;
    if (appearance === 'menu-item') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9796960dd5ca5d58$var$CreateSpaceMenuItem, {
        onClick: handleClick,
        onMouseDown: preloadCreateSpace
    });
    else if (appearance === 'menu-item-nav3') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9796960dd5ca5d58$var$CreateSpaceMenuItemNav3, {
        onClick: handleClick,
        onMouseDown: preloadCreateSpace
    });
    else if (appearance === 'menu-item-nav3-with-icon') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ij8WD.CreateSpaceMenuItemNav3WithIcon), {
        onClick: handleClick,
        onMouseDown: preloadCreateSpace
    });
    else if (appearance === 'compact') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9796960dd5ca5d58$var$CreateSpaceStandardButton, {
        onClick: handleClick,
        onMouseDown: preloadCreateSpace,
        appearance: "default",
        spacing: "compact",
        createSpaceButtonRef: createSpaceButtonRef,
        icon: icon
    });
    else if (appearance === 'plus') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9796960dd5ca5d58$var$CreateSpacePlusButton, {
        onClick: handleClick,
        onMouseDown: preloadCreateSpace,
        createSpaceButtonRef: createSpaceButtonRef
    });
    else if (appearance === 'link-button') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        id: "create-space-button-next",
        onClick: handleClick,
        onMouseDown: preloadCreateSpace,
        appearance: "link",
        "aria-haspopup": "dialog",
        ref: createSpaceButtonRef,
        iconAfter: icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $bNqTI.i18n).createSpaceLinkButton));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9796960dd5ca5d58$var$CreateSpaceStandardButton, {
        onClick: handleClick,
        onMouseDown: preloadCreateSpace,
        appearance: appearance,
        spacing: "default",
        createSpaceButtonRef: createSpaceButtonRef,
        icon: icon
    });
};
module.exports["CreateSpaceButton"] = $9796960dd5ca5d58$export$ed60484c61c6dfb2;

});

parcelRegister("lBYCH", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $1e166e9bfc301d21$export$695e6f0ac03b03ae = (0, $42omo.createContext)({
    isBranchDeploy: false
});
$1e166e9bfc301d21$export$695e6f0ac03b03ae.displayName = 'AppNavigationContext';
module.exports["AppNavigationContext"] = $1e166e9bfc301d21$export$695e6f0ac03b03ae;

});

parcelRegister("lqy4C", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $42omo.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $diswb = parcelRequire("diswb");

const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)((0, $eSUdr.default)`query useGetCurrentStorageUsageGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed isStorageEnforcementGracePeriodComplete gracePeriodEndDate}}`, {
        skip: skip
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $1P1Tu.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $9zUhf.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $9zUhf.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("jyA9t", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $691f60820ad9b181$var$initialState = {
    showSmartCreationModal: false,
    spaceKey: '',
    parentContent: {
        id: '',
        title: '',
        contentType: ''
    },
    content: undefined,
    stagingAreaActive: false,
    entryPoint: 'confluenceUnknown'
};
const $691f60820ad9b181$export$e324594224ef24da = {
    openModal: (entryPoint, spaceKey, parentContent, stagingAreaActive, content)=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: true,
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent ?? {
                    id: '',
                    title: '',
                    contentType: ''
                },
                content: content ?? undefined,
                stagingAreaActive: stagingAreaActive ?? false
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: false,
                content: undefined,
                stagingAreaActive: false,
                entryPoint: 'confluenceUnknown'
            });
        }
};
const $691f60820ad9b181$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $691f60820ad9b181$var$initialState,
    actions: $691f60820ad9b181$export$e324594224ef24da,
    name: 'smartCreationModalStore'
});
const $691f60820ad9b181$export$137abd744dc8b433 = (0, $9zUhf.createHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$809bddce75a17b3 = (0, $9zUhf.createActionsHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$46ab492df7c46301 = (0, $9zUhf.createStateHook)($691f60820ad9b181$export$390f32400eaf98c9);
module.exports["useSmartCreationModalStore"] = $691f60820ad9b181$export$137abd744dc8b433;
module.exports["useSmartCreationModalActions"] = $691f60820ad9b181$export$809bddce75a17b3;
module.exports["useSmartCreationModalState"] = $691f60820ad9b181$export$46ab492df7c46301;

});

parcelRegister("bAyaS", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $8eabddf4fe78ba91$var$initialState = {
    showCreateSpaceDrawer: false,
    shouldRenderDrawer: false,
    createSpaceButtonRef: {
        current: null
    },
    createSpaceButtonLocation: undefined
};
const $8eabddf4fe78ba91$export$e324594224ef24da = {
    openDrawer: (value, createSpaceButtonLocation)=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: true,
                shouldRenderDrawer: true,
                createSpaceButtonRef: value,
                createSpaceButtonLocation: createSpaceButtonLocation
            });
        },
    closeDrawer: ()=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: false,
                createSpaceButtonLocation: undefined
            });
        }
};
const $8eabddf4fe78ba91$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $8eabddf4fe78ba91$var$initialState,
    actions: $8eabddf4fe78ba91$export$e324594224ef24da,
    name: 'createSpaceStore'
});
const $8eabddf4fe78ba91$export$5642c413017336a4 = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
const $8eabddf4fe78ba91$var$getShouldRenderDrawer = (state)=>{
    return state.shouldRenderDrawer;
};
const $8eabddf4fe78ba91$export$34596812152477bc = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getShouldRenderDrawer
});
const $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing = (state)=>{
    return state.showCreateSpaceDrawer;
};
const $8eabddf4fe78ba91$export$5ff6e7335b182a8e = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing
});
const $8eabddf4fe78ba91$export$ad3d638eaaafd693 = (0, $9zUhf.createActionsHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
module.exports["useCreateSpaceStore"] = $8eabddf4fe78ba91$export$5642c413017336a4;
module.exports["useShouldRenderDrawer"] = $8eabddf4fe78ba91$export$34596812152477bc;
module.exports["useCreateSpaceStoreActions"] = $8eabddf4fe78ba91$export$ad3d638eaaafd693;

});

parcelRegister("1KBSi", function(module, exports) {

var $j1Ss3 = parcelRequire("j1Ss3");


var $bQm3c = parcelRequire("bQm3c");


var $3TUla = parcelRequire("3TUla");

const $15029de520f1b9e8$export$cadd7e072478f5e = ()=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { data: canCreateData } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $3TUla.CreateSpaceQuery), {
        skip: !isLicensed
    });
    const canCreateSpace = Boolean(canCreateData?.user?.confluence?.operations.some((obj)=>obj?.operation === 'create_space'));
    return {
        canCreateSpace: canCreateSpace
    };
};
module.exports["useCanCreateSpace"] = $15029de520f1b9e8$export$cadd7e072478f5e;

});

parcelRegister("b118X", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $eEA8O = parcelRequire("eEA8O");


var $bNqTI = parcelRequire("bNqTI");

const $22d675392ae898ef$export$73c36ab825e2dc1d = ({ onClick: onClick, onMouseDown: onMouseDown, appearance: appearance, spacing: spacing, createSpaceButtonRef: createSpaceButtonRef, icon: icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        id: "create-space-button-next",
        onClick: onClick,
        onMouseDown: onMouseDown,
        appearance: appearance,
        spacing: spacing,
        "aria-haspopup": "dialog",
        ref: createSpaceButtonRef,
        iconBefore: icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $bNqTI.i18n).createSpace));
const $22d675392ae898ef$export$f8cd162dd7453205 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($22d675392ae898ef$export$73c36ab825e2dc1d, {
        onClick: ()=>{},
        onMouseDown: ()=>{},
        appearance: "default",
        spacing: "compact"
    });
module.exports["CreateSpaceStandardButton"] = $22d675392ae898ef$export$73c36ab825e2dc1d;
module.exports["CreateSpaceStandardButtonLoading"] = $22d675392ae898ef$export$f8cd162dd7453205;

});

parcelRegister("bNqTI", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $30d8c9185ee39db8$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    createSpace: {
        id: "create-space.button",
        defaultMessage: "Create a space"
    },
    createSpaceLinkButton: {
        id: "create-space.link.button",
        defaultMessage: "Create my own space"
    }
});
module.exports["i18n"] = $30d8c9185ee39db8$export$a7357cdd1f0b0168;

});

parcelRegister("ij8WD", function(module, exports) {
/* CreateSpaceMenuItemNav3WithIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $56M4r = parcelRequire("56M4r");


var $bCECL = parcelRequire("bCECL");

const $052edb368bbb5792$var$i18n = (0, $cgtv4.defineMessages)({
    createASpace: {
        id: "create-space.menu-item-with-icon",
        defaultMessage: "Space"
    }
});
const $052edb368bbb5792$var$nonStandardIconSize = '18px !important'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $052edb368bbb5792$var$ContentIconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1o9zidpf _1bah1h6o _1bsb1ejb _1xjx1o4j _17521o4j _e2oo1o4j _w8l51o4j",
            __cmplp.className
        ])
    });
});
const $052edb368bbb5792$var$ContentTitle = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_k48p1wq8 _syazi7uo",
            __cmplp.className
        ])
    });
});
const $052edb368bbb5792$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($052edb368bbb5792$var$ContentTitle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $052edb368bbb5792$var$i18n.createASpace));
const $052edb368bbb5792$var$Avatar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($052edb368bbb5792$var$ContentIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
    type: "space"
}));
const $052edb368bbb5792$export$cdcb028897ba2364 = ({ onClick: onClick, onMouseDown: onMouseDown })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
        iconBefore: $052edb368bbb5792$var$Avatar,
        onClick: onClick,
        onMouseDown: onMouseDown,
        "aria-haspopup": "dialog",
        testId: "create-menu-link-item"
    }, $052edb368bbb5792$var$Title);
module.exports["CreateSpaceMenuItemNav3WithIcon"] = $052edb368bbb5792$export$cdcb028897ba2364;

});

parcelRegister("bCECL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $e0ycV = parcelRequire("e0ycV");


var $jRsqV = parcelRequire("jRsqV");


var $8jHAi = parcelRequire("8jHAi");


var $9RVmI = parcelRequire("9RVmI");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $5tmwS = parcelRequire("5tmwS");


var $cHaKZ = parcelRequire("cHaKZ");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");


var $gTyTP = parcelRequire("gTyTP");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16 })=>{
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    const defaultedType = type === 'liveDoc' ? 'page' : type; // Prevent using 'liveDoc' type directly
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: defaultedType,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    const definition = isLivePage && isLivePagesFeatureEnabled ? $b2e0c504f331f5cc$var$iconDefinitions['liveDoc'] : $b2e0c504f331f5cc$var$iconDefinitions[defaultedType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $cgtv4.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHaKZ))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jRsqV))),
        label: $b2e0c504f331f5cc$var$i18n.note
    }
};
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("jRsqV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e75905caaf7b6b39$var$_react = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("42omo")));

var $e75905caaf7b6b39$var$_baseNew = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e75905caaf7b6b39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e75905caaf7b6b39$var$NotepadIcon = (props)=>/*#__PURE__*/ $e75905caaf7b6b39$var$_react.default.createElement($e75905caaf7b6b39$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$e75905caaf7b6b39$var$NotepadIcon.displayName = 'NotepadIcon';
var $e75905caaf7b6b39$var$_default = module.exports.default = $e75905caaf7b6b39$var$NotepadIcon;

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
	 * Why do emojis need to be 'sanitized'? Originally emoji content properties
	 * (emoji-title-published, emoji-title-draft) were a part of a REST API
	 * where the value would be JSON and not just a string.  This is why emoji
	 * values come through with extra quotes and we have to clean that up.
	 * A URL with quotes is not a valid URL.
	 * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
	 * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
	 */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("b4pMV", function(module, exports) {

let $80f41263be07750e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $80f41263be07750e$var$load("6wr18"),
    $80f41263be07750e$var$load("k28dP"),
    $80f41263be07750e$var$load("7EorR"),
    $80f41263be07750e$var$load("ffEVr"),
    $80f41263be07750e$var$load("kiDFE")
]).then(()=>parcelRequire('9YlvD'));

});

parcelRegister("2M1tD", function(module, exports) {

let $205135c2afee5ea1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $205135c2afee5ea1$var$load("lWi9V").then(()=>parcelRequire('7VoZf'));

});

parcelRegister("bK94N", function(module, exports) {

let $88cb07f941bb279b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $88cb07f941bb279b$var$load("6wr18"),
    $88cb07f941bb279b$var$load("ffEVr"),
    $88cb07f941bb279b$var$load("3tVyh")
]).then(()=>parcelRequire('ggLdk'));

});

parcelRegister("lqy4V", function(module, exports) {
$parcel$export(module.exports, "useIsEligibleLandInSampleSpaceXflow", () => (parcelRequire("lsi6E")).useIsEligibleLandInSampleSpaceXflow);

var $lsi6E = parcelRequire("lsi6E");


});

parcelRegister("lsi6E", function(module, exports) {

var $8dwdz = parcelRequire("8dwdz");


var $dBcar = parcelRequire("dBcar");


var $1wZpa = parcelRequire("1wZpa");


var $ivb8S = parcelRequire("ivb8S");


var $dCb9P = parcelRequire("dCb9P");


var $bQm3c = parcelRequire("bQm3c");

const $c559c664ef181d12$export$f2349a4cf321119f = ()=>{
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const isEnglishAndDesktopUser = (0, $1wZpa.isLocaleEnglish)(locale) && !((0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)());
    const { isXflowUser: isXflowUser, error: userTypeError, loading: userTypeLoading } = (0, $dCb9P.useUserByLicensedProducts)({
        skip: !isEnglishAndDesktopUser
    });
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
        (0, $dBcar.ONBOARDING_EXPERIENCES).XFLOW_SPACE_CREATED
    ], !isXflowUser);
    const { isFoundingAdmin: isFoundingAdmin = false, xflowSpaceCreated: xflowSpaceCreated = false } = (0, $ivb8S.deserializeState)(onboardingStateData) || {};
    return {
        isEligible: isEnglishAndDesktopUser && isXflowUser && isFoundingAdmin,
        loading: userTypeLoading || onboardingStateLoading,
        error: userTypeError || onboardingStateError,
        xflowSpaceCreated: xflowSpaceCreated
    };
};
module.exports["useIsEligibleLandInSampleSpaceXflow"] = $c559c664ef181d12$export$f2349a4cf321119f;

});

parcelRegister("1wZpa", function(module, exports) {
/**
 * Checks if the specified locale and the browser's language setting are English.
 * Optionally skips the browser's language check.
 *
 * @param {string} locale - The locale to check. It will be transformed to lowercase for comparison.
 * @param {boolean} [skipBrowserCheck=false] - Whether to skip checking the browser's language setting. Defaults to false.
 * @returns {boolean} - Returns true if:
 *  - The passed locale starts with 'en' and navigator language setting starts with 'en'.
 *  - The passed locale starts with 'en' and either skipBrowserCheck is true or the navigator object is not available.
 * Returns false otherwise.
 */ const $ea6df990daadbbff$export$68fe00948fce4bd0 = (locale, skipBrowserCheck = false)=>{
    const englishPrefix = 'en';
    const isLocaleEnglish = locale.toLowerCase().startsWith(englishPrefix);
    // When skipBrowserCheck is true or we are not in a browser environment, only check locale
    if (skipBrowserCheck || !Boolean(window?.navigator)) return isLocaleEnglish;
    // Otherwise, check both locale and navigator language
    return isLocaleEnglish && navigator.language?.toLowerCase().startsWith(englishPrefix);
};
module.exports["isLocaleEnglish"] = $ea6df990daadbbff$export$68fe00948fce4bd0;

});

parcelRegister("dCb9P", function(module, exports) {

var $diswb = parcelRequire("diswb");


var $8Lx5S = parcelRequire("8Lx5S");


var $7HSaW = parcelRequire("7HSaW");

const $fa67f73cddf7e8a7$export$d4bea0d69a8d983f = ({ skip: skip = false })=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const skipConditions = skip || !isLicensed;
    const { data: licensedProductsData, loading: licensedProductsLoading, error: licensedProductsError } = (0, $diswb.useQuery)((0, $7HSaW.GetLicensedProductsQuery), {
        errorPolicy: 'all',
        skip: skipConditions
    });
    if (licensedProductsLoading || licensedProductsError || skipConditions) return {
        isLandUser: false,
        isXflowUser: false,
        loading: licensedProductsLoading,
        error: licensedProductsError
    };
    const licensedProducts = licensedProductsData?.confluence_tenantContext?.licensedProducts;
    const userByLicensedProducts = $fa67f73cddf7e8a7$var$checkUserByLicensedProducts(licensedProducts);
    return {
        isLandUser: skipConditions ? false : userByLicensedProducts.isLandUser,
        isXflowUser: skipConditions ? false : userByLicensedProducts.isXflowUser,
        loading: licensedProductsLoading,
        error: licensedProductsError
    };
};
/**
 *
 * @param licensedProducts
 * @returns
 * isXflowUser - if user has any active jira product
 * isLandUser - if user has only 1 active product and it's confluence
 *
 */ function $fa67f73cddf7e8a7$var$checkUserByLicensedProducts(licensedProducts) {
    if (!licensedProducts) return {
        isXflowUser: false,
        isLandUser: false
    };
    const isXflowUser = licensedProducts.some((product)=>product.productKey.toLowerCase().includes('jira'));
    return {
        isXflowUser: isXflowUser,
        isLandUser: !isXflowUser
    };
}
module.exports["useUserByLicensedProducts"] = $fa67f73cddf7e8a7$export$d4bea0d69a8d983f;

});

parcelRegister("g01A4", function(module, exports) {

var $i9VoI = parcelRequire("i9VoI");


var $9wGTI = parcelRequire("9wGTI");


var $4VJDS = parcelRequire("4VJDS");


var $6mKj3 = parcelRequire("6mKj3");

const $e0f671e8616dafd9$export$c6d4df78386dbff6 = ({ callback: callback, subscriberId: subscriberId, contentId: contentId, contentType: contentType })=>{
    (0, $i9VoI.useSubscriptionEvent)({
        onDataReceived: callback,
        delta: 'contentRestrictionUpdated',
        subscriberId: subscriberId,
        contentType: contentType,
        contentId: contentId,
        skip: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        !(0, $6mKj3.expVal)('cc_fps_migration_content-restriction-updated', 'isEnabled', false) || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') || ![
            'DUAL',
            'GRAPHQL'
        ].includes((0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', ''))
    });
};
module.exports["useContentRestrictionSubscriptionEvent"] = $e0f671e8616dafd9$export$c6d4df78386dbff6;

});

parcelRegister("i9VoI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $42omo.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("b8Qzg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7d2Nc = parcelRequire("7d2Nc");


var $5qUgM = parcelRequire("5qUgM");


var $8nrOs = parcelRequire("8nrOs");

const $3bf7bf5bf675da82$export$e3980b758fe4ea84 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8nrOs.ContentTypesHeaderLoader), props));
module.exports["ContentTypesHeader"] = $3bf7bf5bf675da82$export$e3980b758fe4ea84;

});

parcelRegister("5qUgM", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");


var $14SPd = parcelRequire("14SPd");


var $7d41Y = parcelRequire("7d41Y");


var $15M40 = parcelRequire("15M40");

const $325dcacdd45838d0$export$fd9c234c55ebf87b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS = [
    $325dcacdd45838d0$export$fd9c234c55ebf87b,
    (0, $7d41Y.FAVOURITE_BUTTON_METRIC),
    (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
];
const $325dcacdd45838d0$export$31dafa10be5579b1 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$export$13d0f4f758cb96f = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS
];
const $325dcacdd45838d0$export$2afecd1facfcf464 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.DATABASE_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$13d0f4f758cb96f
});
const $325dcacdd45838d0$export$48a0148c0fcdf96 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $15M40.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$a8f0e1718c3ba46b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$48a0148c0fcdf96
});
const $325dcacdd45838d0$export$585906e42509a641 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $15M40.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$de21700de0084df7 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.WHITEBOARD_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$585906e42509a641
});
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT"] = $325dcacdd45838d0$export$fd9c234c55ebf87b;
module.exports["OBJECT_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$31dafa10be5579b1;
module.exports["DATABASE_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$13d0f4f758cb96f;
module.exports["DATABASE_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$2afecd1facfcf464;
module.exports["SMART_LINK_EMBED_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$48a0148c0fcdf96;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$a8f0e1718c3ba46b;
module.exports["WHITEBOARD_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$585906e42509a641;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$de21700de0084df7;

});

parcelRegister("14SPd", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

var $jIOyV = parcelRequire("jIOyV");

const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
const $8ab24ab9418ac89d$export$2ba38536ff91e2a7 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.RESTRICTIONS_DIALOG_INTERACTION)
});
module.exports["RESTRICTIONS_BUTTON_METRIC"] = $8ab24ab9418ac89d$export$34cc51d2a4e5cf67;
module.exports["RESTRICTIONS_DIALOG_METRIC"] = $8ab24ab9418ac89d$export$2ba38536ff91e2a7;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["VIEW_AI_PRESENTATION_INTERACTION"] = $4fa41f80373a2ebe$export$af1eb8557193d022;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("7d41Y", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $9b3034aec76dfadd$export$ecb802558c1ba05e = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["FAVOURITE_BUTTON_METRIC"] = $9b3034aec76dfadd$export$ecb802558c1ba05e;

});

parcelRegister("15M40", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $8336b070b3684358$export$8fdec53caa79133c = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY)
});
module.exports["SHARE_BUTTON_PAGE_SEGMENT_LOAD"] = $8336b070b3684358$export$8fdec53caa79133c;

});

parcelRegister("8nrOs", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $7b80359059e5668e$export$17777490bbedaf3a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "i-H0G",
    name: "ContentTypesHeaderLoader",
    loader: async ()=>(await (parcelRequire("dX5Oi"))).ContentTypesHeader
});
module.exports["ContentTypesHeaderLoader"] = $7b80359059e5668e$export$17777490bbedaf3a;

});

parcelRegister("dX5Oi", function(module, exports) {

let $a2854ada31d7af5a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a2854ada31d7af5a$var$load("2spqH"),
    $a2854ada31d7af5a$var$load("gWSdF"),
    $a2854ada31d7af5a$var$load("hxZ2q"),
    $a2854ada31d7af5a$var$load("gC5n8"),
    $a2854ada31d7af5a$var$load("8bVS2"),
    $a2854ada31d7af5a$var$load("8KnyD"),
    $a2854ada31d7af5a$var$load("ioQAS"),
    $a2854ada31d7af5a$var$load("e9JE4"),
    $a2854ada31d7af5a$var$load("e4GNb"),
    $a2854ada31d7af5a$var$load("6wr18"),
    $a2854ada31d7af5a$var$load("8ADTD"),
    $a2854ada31d7af5a$var$load("aHhj2"),
    $a2854ada31d7af5a$var$load("6tsCm"),
    $a2854ada31d7af5a$var$load("jdHbV"),
    $a2854ada31d7af5a$var$load("3VLKz"),
    $a2854ada31d7af5a$var$load("2SjHp"),
    $a2854ada31d7af5a$var$load("li9sm"),
    $a2854ada31d7af5a$var$load("eRoc9"),
    $a2854ada31d7af5a$var$load("jwSno"),
    $a2854ada31d7af5a$var$load("e2ujj"),
    $a2854ada31d7af5a$var$load("aLLXO"),
    $a2854ada31d7af5a$var$load("5coOi"),
    $a2854ada31d7af5a$var$load("9ZkgN"),
    $a2854ada31d7af5a$var$load("2mt3f"),
    $a2854ada31d7af5a$var$load("lnnYm"),
    $a2854ada31d7af5a$var$load("4XFRu"),
    $a2854ada31d7af5a$var$load("2Mq3f"),
    $a2854ada31d7af5a$var$load("gctwz"),
    $a2854ada31d7af5a$var$load("coJiW"),
    $a2854ada31d7af5a$var$load("a4yJG"),
    $a2854ada31d7af5a$var$load("5U3YO"),
    $a2854ada31d7af5a$var$load("8YSo7"),
    $a2854ada31d7af5a$var$load("2F69B"),
    $a2854ada31d7af5a$var$load("3qsjq"),
    $a2854ada31d7af5a$var$load("lUlCu"),
    $a2854ada31d7af5a$var$load("6FuHS"),
    $a2854ada31d7af5a$var$load("eyaRC"),
    $a2854ada31d7af5a$var$load("iXzmH"),
    $a2854ada31d7af5a$var$load("65c4i"),
    $a2854ada31d7af5a$var$load("awqCy"),
    $a2854ada31d7af5a$var$load("kHOMt"),
    $a2854ada31d7af5a$var$load("jXx9i"),
    $a2854ada31d7af5a$var$load("iRFO3"),
    $a2854ada31d7af5a$var$load("aPo1I"),
    $a2854ada31d7af5a$var$load("dlZSj"),
    $a2854ada31d7af5a$var$load("fZt2F"),
    $a2854ada31d7af5a$var$load("Wowvf"),
    $a2854ada31d7af5a$var$load("let0D"),
    $a2854ada31d7af5a$var$load("6EQss"),
    $a2854ada31d7af5a$var$load("ffEVr"),
    $a2854ada31d7af5a$var$load("kUbUu"),
    $a2854ada31d7af5a$var$load("4Lgj0"),
    $a2854ada31d7af5a$var$load("kSJiq"),
    $a2854ada31d7af5a$var$load("hhss7"),
    $a2854ada31d7af5a$var$load("9ftJe"),
    $a2854ada31d7af5a$var$load("7EorR"),
    $a2854ada31d7af5a$var$load("KS1sL")
]).then(()=>parcelRequire('JJ6wk'));

});

parcelRegister("eStoj", function(module, exports) {
/* ContentTypesHeaderPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $lyx2E = parcelRequire("lyx2E");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $99bd788c321ed119$var$BreadcrumbsSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _11q7izff _4t3i1crf _1bsb1n2x",
            __cmplp.className
        ])
    });
});
const $99bd788c321ed119$var$BreadcrumbsSeparatorSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8otz2 _7bjqidpf _1kt91n76 _is06ysee",
            __cmplp.className
        ])
    });
});
const $99bd788c321ed119$var$SkeletonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTitle: isTitle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.isTitle ? "_4t3i1tcg" : "_4t3igktf",
            __cmplp.className
        ])
    });
});
const $99bd788c321ed119$var$TitleSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _11q7izff _4t3idlk8 _1bsb1g7h",
            __cmplp.className
        ])
    });
});
const $99bd788c321ed119$var$flexNavigationContainerPlaceholderStyles = (0, $ecnYn.xcss)({
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    boxSizing: 'border-box',
    justifyContent: 'space-between'
});
const $99bd788c321ed119$export$65261598592c5dcf = ({ isFloating: isFloating })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lyx2E.ContentTypesHeaderContainer), {
        isFloating: isFloating
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $99bd788c321ed119$var$flexNavigationContainerPlaceholderStyles,
        testId: "content-types-header-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lyx2E.TitleAndBreadcrumbsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99bd788c321ed119$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99bd788c321ed119$var$BreadcrumbsSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99bd788c321ed119$var$BreadcrumbsSeparatorSkeleton, {
        "data-testid": "content-types-header-placeholder-breadcrumbs-separator"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99bd788c321ed119$var$BreadcrumbsSkeleton, {
        "data-testid": "content-types-header-placeholder-breadcrumbs-skeleton"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99bd788c321ed119$var$SkeletonWrapper, {
        isTitle: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99bd788c321ed119$var$TitleSkeleton, null)))));
};
module.exports["ContentTypesHeaderPlaceholder"] = $99bd788c321ed119$export$65261598592c5dcf;

});

parcelRegister("lyx2E", function(module, exports) {
/* contentTypesHeaderStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $3d1681a377877e6e$export$e139d3b51c488e9b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFloating: isFloating, hasPointerEvents: hasPointerEvents, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fwhixl": (0, $7sObp.default)((()=>{
                return __cmplp.isFloating ? 'absolute' : 'relative';
            })()),
            "--_17xabpo": (0, $7sObp.default)((()=>{
                return __cmplp.hasPointerEvents ? 'auto' : 'none';
            })())
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_bfhk1j28 _kqswlr7h _lcxv12je _1bsb1osq _1e0c11p5",
            __cmplp.className
        ])
    });
});
const $3d1681a377877e6e$var$titleAndBreadcrumbsBaseStyles = (0, $ecnYn.xcss)({
    pointerEvents: 'auto',
    backgroundColor: 'elevation.surface',
    borderRadius: 'radius.small',
    paddingInline: 'space.100',
    paddingBlockEnd: 'space.050',
    display: 'flex',
    flexWrap: 'nowrap',
    paddingBlockStart: 'space.050',
    height: '100%'
});
// Utilized only when the content header is pinned and during the viewing of public whiteboards
const $3d1681a377877e6e$var$alignCenterStyle = (0, $ecnYn.xcss)({
    alignSelf: 'center'
});
const $3d1681a377877e6e$export$b1249ef660098484 = ({ isContentHeaderPinned: isContentHeaderPinned = false, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $3d1681a377877e6e$var$titleAndBreadcrumbsBaseStyles,
            isContentHeaderPinned && $3d1681a377877e6e$var$alignCenterStyle
        ]
    }, children);
};
module.exports["ContentTypesHeaderContainer"] = $3d1681a377877e6e$export$e139d3b51c488e9b;
module.exports["TitleAndBreadcrumbsWrapper"] = $3d1681a377877e6e$export$b1249ef660098484;

});

parcelRegister("3mVfX", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4440a0699c7a4c4d$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    return ViewValues;
}({});
var $4440a0699c7a4c4d$export$edda0a7e0ba757fd = /*#__PURE__*/ function(SortValues) {
    SortValues["PAGE_ORDER"] = "PAGE_ORDER";
    SortValues["MOST_RECENT"] = "MOST_RECENT";
    return SortValues;
}({});
var $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c = /*#__PURE__*/ function(CommentMode) {
    CommentMode["VIEW"] = "view";
    CommentMode["ADD"] = "add";
    return CommentMode;
}({});
var $4440a0699c7a4c4d$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $4440a0699c7a4c4d$var$getInitialState = ()=>({
        currentView: undefined,
        currentSort: "PAGE_ORDER",
        showInlineComments: true,
        showGeneralComments: true,
        currentlySelectedThreadKey: undefined,
        commentsMarkedAsRead: {
            inline: {},
            general: {}
        },
        initialDataLoadedForViewMap: {
            ["UNREAD"]: false,
            ["OPEN"]: false,
            ["DELETED_CONTENT"]: false,
            ["RESOLVED"]: false
        },
        replyToCommentId: undefined,
        replyToCommentUser: undefined,
        footerEditCommentIds: new Set(),
        currentlyRenderedThreads: [],
        location: undefined,
        commentType: undefined,
        commentMode: "view",
        isCommentAddPromptFocused: false,
        commentContainerToFocus: undefined,
        addFooterCommentAdf: undefined
    });
// Actions for managing the comments state in the comments panel
const $4440a0699c7a4c4d$var$actions = {
    setCurrentView: (view)=>({ setState: setState })=>{
            setState({
                currentView: view
            });
        },
    setCurrentSort: (sort)=>({ setState: setState })=>{
            setState({
                currentSort: sort
            });
        },
    setShowInlineComments: (showInline)=>({ setState: setState })=>{
            setState({
                showInlineComments: showInline
            });
        },
    setShowGeneralComments: (showGeneral)=>({ setState: setState })=>{
            setState({
                showGeneralComments: showGeneral
            });
        },
    setCurrentlySelectedThreadKey: (threadKey, commentType)=>({ setState: setState })=>{
            setState({
                currentlySelectedThreadKey: threadKey,
                commentType: commentType
            });
        },
    setCommentsInThreadToBeMarkedAsRead: ({ threadKey: threadKey, commentIds: commentIds, commentType: commentType })=>({ setState: setState, getState: getState })=>{
            const { commentsMarkedAsRead: commentsMarkedAsRead } = getState();
            if (threadKey && commentIds) {
                // Add the new comment IDs to the existing set for the specific parent
                const updatedCommentIds = {
                    ...commentsMarkedAsRead
                };
                const existingIdsSet = updatedCommentIds[commentType][threadKey] || new Set();
                commentIds.forEach((id)=>existingIdsSet.add(id));
                // Update the map with the new set of IDs
                updatedCommentIds[commentType][threadKey] = existingIdsSet;
                setState({
                    commentsMarkedAsRead: updatedCommentIds
                });
            }
        },
    setCommentsToBeMarkedAsRead: (commentsMarkedAsRead)=>({ setState: setState })=>{
            setState({
                commentsMarkedAsRead: commentsMarkedAsRead
            });
        },
    clearCommentsMarkedAsRead: ()=>({ setState: setState })=>{
            setState({
                commentsMarkedAsRead: {
                    inline: {},
                    general: {}
                }
            });
        },
    setInitialDataLoadedForView: ({ viewToSetLoaded: viewToSetLoaded })=>({ getState: getState, setState: setState })=>{
            const { initialDataLoadedForViewMap: initialDataLoadedForViewMap } = getState();
            initialDataLoadedForViewMap[viewToSetLoaded] = true;
            setState({
                initialDataLoadedForViewMap: initialDataLoadedForViewMap
            });
        },
    setReplyToCommentId: ({ parentCommentId: parentCommentId, location: location, user: user } = {})=>({ setState: setState })=>{
            setState({
                replyToCommentId: parentCommentId,
                location: location,
                replyToCommentUser: user
            });
        },
    resetInitialDataLoadedMap: ()=>({ setState: setState })=>{
            setState($4440a0699c7a4c4d$var$getInitialState());
        },
    setCurrentlyRenderedThreads: (threads)=>({ setState: setState })=>{
            setState({
                currentlyRenderedThreads: threads
            });
        },
    addFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.add(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    removeFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.delete(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    setCommentMode: (mode)=>({ setState: setState })=>{
            setState({
                commentMode: mode
            });
        },
    setIsCommentAddPromptFocused: (isFocused)=>({ setState: setState })=>{
            setState({
                isCommentAddPromptFocused: isFocused
            });
        },
    resetCommentMode: ()=>({ setState: setState })=>{
            setState({
                commentMode: "view",
                isCommentAddPromptFocused: false
            });
        },
    setCommentContainerToFocus: (commentContainerToFocus)=>({ setState: setState })=>{
            setState({
                commentContainerToFocus: commentContainerToFocus
            });
        },
    setAddFooterCommentAdf: (addFooterCommentAdf)=>({ setState: setState })=>{
            setState({
                addFooterCommentAdf: addFooterCommentAdf
            });
        }
};
const $4440a0699c7a4c4d$var$CommentsStore = (0, $1P1Tu.createStore)({
    initialState: $4440a0699c7a4c4d$var$getInitialState(),
    actions: $4440a0699c7a4c4d$var$actions,
    name: 'CommentsStore'
});
const $4440a0699c7a4c4d$export$8607294e360a4610 = (0, $9zUhf.createHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$1719a5796ebd8e85 = (0, $9zUhf.createActionsHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb = (0, $9zUhf.createStateHook)($4440a0699c7a4c4d$var$CommentsStore);
module.exports["ViewValues"] = $4440a0699c7a4c4d$export$ca559f4ef107f965;
module.exports["SortValues"] = $4440a0699c7a4c4d$export$edda0a7e0ba757fd;
module.exports["CommentMode"] = $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c;
module.exports["AddFooterCommentMode"] = $4440a0699c7a4c4d$export$94f8d08c2312472b;
module.exports["useCommentsPanel"] = $4440a0699c7a4c4d$export$8607294e360a4610;
module.exports["useCommentsPanelActions"] = $4440a0699c7a4c4d$export$1719a5796ebd8e85;
module.exports["useCommentsPanelState"] = $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb;

});

parcelRegister("deZfn", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3af5d746447ab7ac$export$a32ab742d345a2c9 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "u0VI7",
    name: "ArchivedPageBanner",
    loader: async ()=>(await (parcelRequire("gS8hC"))).ArchivedPageBanner
});

const $3af5d746447ab7ac$export$59d39ce9027a0e01 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cwXQQ",
    name: "ArchivedPageBannerAfterPaint",
    loader: async ()=>(await (parcelRequire("gS8hC"))).ArchivedPageBanner
});
module.exports["ArchivedPageBanner"] = $3af5d746447ab7ac$export$a32ab742d345a2c9;
module.exports["ArchivedPageBannerAfterPaint"] = $3af5d746447ab7ac$export$59d39ce9027a0e01;

});

parcelRegister("gS8hC", function(module, exports) {

let $c4881d540ace89f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c4881d540ace89f8$var$load("g5te7"),
    $c4881d540ace89f8$var$load("6rpul")
]).then(()=>parcelRequire('2ZkUh'));

});

parcelRegister("aCrkK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");

const $91a763c2849bb3c4$var$experienceMap = {
    whiteboard: {
        restoreModal: (0, $irVI7.WHITEBOARD_VERSION_HISTORY_LOAD_RESTORE_MODAL),
        restoreExperience: (0, $irVI7.WHITEBOARD_VERSION_HISTORY_RESTORE_EXPERIENCE),
        sidePanel: (0, $irVI7.WHITEBOARD_VERSION_HISTORY_SIDE_PANEL_EXPERIENCE)
    },
    database: {
        restoreModal: (0, $irVI7.DATABASE_VERSION_HISTORY_LOAD_RESTORE_MODAL),
        restoreExperience: (0, $irVI7.DATABASE_VERSION_HISTORY_RESTORE_EXPERIENCE),
        sidePanel: (0, $irVI7.DATABASE_VERSION_HISTORY_SIDE_PANEL_EXPERIENCE)
    }
};
const $91a763c2849bb3c4$export$9560419a530f63b5 = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const trackExperience = ({ contentType: contentType, experience: experience, task: task })=>{
        if (!contentType || !experience || !task) return;
        if (contentType === 'whiteboard' || contentType === 'database') {
            const experienceName = $91a763c2849bb3c4$var$experienceMap[contentType]?.[experience];
            if (experienceName) {
                if (task === 'start') experienceTracker.start({
                    name: experienceName
                });
                else experienceTracker.succeed({
                    name: experienceName
                });
            }
        }
    };
    return {
        trackExperience: trackExperience
    };
};
module.exports["useVersionHistoryExperienceTracking"] = $91a763c2849bb3c4$export$9560419a530f63b5;

});

parcelRegister("bvJwp", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $357714bfdc877a0f$export$75b569184a0dd765 = (isSSR)=>{
    const [bannerHeight, setBannerHeight] = (0, $42omo.useState)(0);
    const [bannerElement, setBannerElement] = (0, $42omo.useState)(null);
    const resizeObserver = (0, $42omo.useMemo)(()=>{
        if (!isSSR) return new ResizeObserver((entries)=>{
            for (const entry of entries)setBannerHeight(entry.borderBoxSize[0].blockSize);
        });
    }, [
        isSSR
    ]);
    (0, $42omo.useEffect)(()=>{
        if (bannerElement && resizeObserver) {
            resizeObserver.observe(bannerElement);
            return ()=>resizeObserver.unobserve(bannerElement);
        } else setBannerHeight(0);
    }, [
        bannerElement,
        resizeObserver
    ]);
    return {
        setBannerElement: setBannerElement,
        bannerHeight: bannerHeight,
        setBannerHeight: setBannerHeight
    };
};
module.exports["useResizeBanner"] = $357714bfdc877a0f$export$75b569184a0dd765;

});

parcelRegister("5thep", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $d81f7457a684c10d$export$c72df13ba879849e = (contentType)=>{
    return contentType === 'whiteboard' || contentType === 'database' && (0, $9wGTI.fg)('confluence_frontend_databases_version_history_ui');
};
module.exports["useIsVersionHistoryEnabled"] = $d81f7457a684c10d$export$c72df13ba879849e;

});

parcelRegister("ai7NK", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $30dd91193859fc54$export$4f97fa3245bb0e31 = {
    isSidePanelOpen: false
};
const $30dd91193859fc54$export$e324594224ef24da = {
    showSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: true
            });
        },
    hideSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: false
            });
        }
};
const $30dd91193859fc54$var$Store = (0, $1P1Tu.createStore)({
    initialState: $30dd91193859fc54$export$4f97fa3245bb0e31,
    actions: $30dd91193859fc54$export$e324594224ef24da,
    name: 'SidePanelState'
});
const $30dd91193859fc54$export$d4bcf572fecd48f5 = (0, $9zUhf.createActionsHook)($30dd91193859fc54$var$Store);
const $30dd91193859fc54$export$f3f6191f6fee6235 = (0, $9zUhf.createStateHook)($30dd91193859fc54$var$Store, {
    selector: (state)=>state.isSidePanelOpen
});
module.exports["useSidePanelStateActions"] = $30dd91193859fc54$export$d4bcf572fecd48f5;
module.exports["useIsSidePanelOpen"] = $30dd91193859fc54$export$f3f6191f6fee6235;

});

parcelRegister("aWwYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4BDAe = parcelRequire("4BDAe");


var $6mKj3 = parcelRequire("6mKj3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            setState({
                panelWidth: Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97) + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $1P1Tu.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $9zUhf.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $42omo.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = (0, $42omo.useMemo)(()=>(0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? showObjectSidebarWrapper : internalActions.showObjectSidebar, [
        showObjectSidebarWrapper,
        internalActions.showObjectSidebar
    ]);
    const memoizedActions = (0, $42omo.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $42omo.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("fQa5o", function(module, exports) {
/* OnboardingNthUserContentTypeSpotlight.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $fw9LG = parcelRequire("fw9LG");


var $tAt1Q = parcelRequire("tAt1Q");


var $7Sm4c = parcelRequire("7Sm4c");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $1uFM6 = parcelRequire("1uFM6");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $lsxnT = parcelRequire("lsxnT");


var $6mKj3 = parcelRequire("6mKj3");

const $3e3a23abea467e8a$export$e2e108cbe2e4f865 = (0, $tAt1Q.NthUserContentType);
function $3e3a23abea467e8a$var$isErrorHandled(error) {
    // Mark unauthorized error as handled and not report to monitoring client
    if ((0, $1uFM6.isUnauthorizedError)(error) || error?.graphQLErrors?.[0]?.message === 'unauthorized') {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    return false;
}
const $3e3a23abea467e8a$var$i18n = (0, $cgtv4.defineMessages)({
    popularHeading: {
        id: "experiment-onboarding-content-type-spotlight.nth-user.content-types.popular.heading",
        defaultMessage: "{contentType, select, page {This is the most popular page in your site} whiteboard {This is the most popular whiteboard in your site} liveDoc {This is the most popular live doc in your site} database {This is the most popular database in your site} other {This content is popular on your site}}"
    },
    nonPopularHeading: {
        id: "experiment-onboarding-content-type-spotlight.nth-user.content-types.non-popular.heading",
        defaultMessage: "{contentType, select, page {This is a sample page in your space} whiteboard {This is a sample whiteboard in your space} liveDoc {This is a sample live doc in your space} database {This is a page on how to use databases} other {This is an example of your selected content type in your space}}"
    },
    contentDescription: {
        id: "experiment-onboarding-content-type-spotlight.nth-user.content-types.content.description",
        defaultMessage: "{contentType, select, page {Take a quick look at the page and learn how Confluence pages work.} whiteboard {Take a quick look at the whiteboard and learn how Confluence whiteboards work.} liveDoc {Take a quick look at the live doc and learn how Confluence live docs work.} database {Take a quick look at the database and learn how Confluence databases work.} databaseDefault {Take a quick look at the page and learn how Confluence databases work.} other {Take a quick look at the content and learn how Confluence content types work.}}"
    },
    dismissAction: {
        id: "experiment-onboarding-content-type-spotlight.dismiss.action",
        defaultMessage: "Dismiss"
    }
});
const $3e3a23abea467e8a$var$styles = {
    fixedSpotlightWrapper: "_kqsw1n9t _1pby9y44 _1xi21epz _154ixncg",
    relativeSpotlightWrapper: "_kqswh2mm _154i1epz",
    liveDocSpacing: "_kqswh2mm _154ixncg"
};
const $3e3a23abea467e8a$export$38c962029328197d = (contentType)=>{
    switch(contentType){
        case (0, $tAt1Q.NthUserContentType).PAGE:
            return {
                messageId: 'onboarding-nth-user-page-content-type-spotlight'
            };
        case (0, $tAt1Q.NthUserContentType).LIVE_DOC:
            return {
                messageId: 'onboarding-nth-user-live-doc-content-type-spotlight'
            };
        case (0, $tAt1Q.NthUserContentType).WHITEBOARD:
            return {
                messageId: 'onboarding-nth-user-whiteboard-content-type-spotlight'
            };
        case (0, $tAt1Q.NthUserContentType).DATABASE:
            return {
                messageId: 'onboarding-nth-user-database-content-type-spotlight'
            };
        default:
            return {
                messageId: ''
            };
    }
};
const $3e3a23abea467e8a$var$actionSubjectId = 'contentTypeNthUserOnboardingSpotlight';
const $3e3a23abea467e8a$var$source = 'nthUserContentTypeScreen';
const $3e3a23abea467e8a$export$f624ac630094c7f0 = ({ contentType: contentType, contentId: contentId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { SpotlightCard: SpotlightCard } = (0, $lsxnT.useChoreographerAssets)();
    const [isLocalNudgeShowing, setIsLocalNudgeShowing] = (0, $42omo.useState)(false);
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.NTH_USER_SETUP_CONTENT_TYPE).NTH_USER_SELECTED_CONTENT_TYPE,
        (0, $dBcar.NTH_USER_SETUP_CONTENT_TYPE).NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN,
        (0, $dBcar.NTH_USER_SETUP_CONTENT_TYPE).NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND,
        (0, $dBcar.NTH_USER_SETUP_CONTENT_TYPE).NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID
    ]);
    const { nthUserContentTypeSpotlightSeen: nthUserContentTypeSpotlightSeen, nthUserContentTypePopularContentFound: nthUserContentTypePopularContentFound, nthUserSelectedContentType: nthUserSelectedContentType, nthUserContentTypeLandingContentId: nthUserContentTypeLandingContentId } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const isOnboardingStateLoaded = Boolean(!onboardingStateLoading && !onboardingStateError && onboardingStateData);
    const isEligibleForNudge = isOnboardingStateLoaded && !nthUserContentTypeSpotlightSeen && Boolean($3e3a23abea467e8a$export$38c962029328197d(contentType).messageId);
    const isDefaultDatabaseContent = nthUserSelectedContentType === (0, $tAt1Q.NthUserContentType).DATABASE && contentType === (0, $tAt1Q.NthUserContentType).PAGE;
    const isTargetContent = (contentType === nthUserSelectedContentType || isDefaultDatabaseContent) && // if there is popular content, ensure the content ids match
    contentId === nthUserContentTypeLandingContentId;
    const hasMetAllSpotlightConditions = isEligibleForNudge && isTargetContent;
    const choreographerMessageId = $3e3a23abea467e8a$export$38c962029328197d(contentType).messageId;
    (0, $42omo.useEffect)(()=>{
        if (hasMetAllSpotlightConditions) setIsLocalNudgeShowing(true);
    }, [
        hasMetAllSpotlightConditions
    ]);
    const handleOnDismiss = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'button',
                actionSubjectId: $3e3a23abea467e8a$var$actionSubjectId,
                source: $3e3a23abea467e8a$var$source,
                attributes: {
                    contentType: contentType,
                    isPopularContent: nthUserContentTypePopularContentFound ?? false
                }
            }
        }).fire();
        setIsLocalNudgeShowing(false);
    };
    const headingMessage = nthUserContentTypePopularContentFound ? $3e3a23abea467e8a$var$i18n.popularHeading : $3e3a23abea467e8a$var$i18n.nonPopularHeading;
    const getLocalizedSelectOptionString = (isHeading = true)=>{
        if (nthUserSelectedContentType === (0, $tAt1Q.NthUserContentType).LIVE_DOC) // Select values only accept alphanumeric or underscores characters
        return 'liveDoc';
        if (!nthUserContentTypePopularContentFound && isDefaultDatabaseContent) // the spotlight for database default content shows up on a page
        // the non-popular database heading already adjusts for the database default content
        return isHeading ? (0, $tAt1Q.NthUserContentType).DATABASE : 'databaseDefault';
        return contentType;
    };
    const onMessageDispositionCallback = (0, $42omo.useCallback)((message)=>{
        if (message === (0, $fw9LG.MessageDeliveryStatus).STARTED) {
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: $3e3a23abea467e8a$var$actionSubjectId,
                    source: $3e3a23abea467e8a$var$source,
                    attributes: {
                        contentType: contentType,
                        isPopularContent: nthUserContentTypePopularContentFound ?? false
                    }
                }
            }).fire();
            if (!nthUserContentTypeSpotlightSeen) setOnboardingState({
                key: (0, $dBcar.NTH_USER_SETUP_CONTENT_TYPE).NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN,
                value: 'true'
            });
        }
    }, [
        createAnalyticsEvent,
        contentType,
        nthUserContentTypePopularContentFound,
        nthUserContentTypeSpotlightSeen,
        setOnboardingState
    ]);
    if (onboardingStateError && !$3e3a23abea467e8a$var$isErrorHandled(onboardingStateError)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: onboardingStateError
    }));
    if (!isLocalNudgeShowing) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $3e3a23abea467e8a$var$styles.fixedSpotlightWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $3e3a23abea467e8a$var$styles.relativeSpotlightWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(contentType === (0, $tAt1Q.NthUserContentType).LIVE_DOC && $3e3a23abea467e8a$var$styles.liveDocSpacing)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SpotlightCard, {
        messageId: choreographerMessageId,
        messageType: "engagement",
        width: 275,
        heading: intl.formatMessage(headingMessage, {
            contentType: getLocalizedSelectOptionString()
        }),
        actions: [
            {
                onClick: handleOnDismiss,
                text: intl.formatMessage($3e3a23abea467e8a$var$i18n.dismissAction)
            }
        ],
        onMessageDisposition: onMessageDispositionCallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$3e3a23abea467e8a$var$i18n.contentDescription,
        values: {
            contentType: getLocalizedSelectOptionString(false)
        }
    }))))));
};
const $3e3a23abea467e8a$export$5f3827ac6e1d7daa = ({ contentType: contentType, contentId: contentId })=>{
    if (// eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
    !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-engagement-content-type-nth-user-screen-rollout', 'cohort', 'experiment')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ACTIVATION,
        renderOnError: ()=>{
            return null;
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3e3a23abea467e8a$export$f624ac630094c7f0, {
        contentType: contentType,
        contentId: contentId
    }));
};
module.exports["ContentType"] = $3e3a23abea467e8a$export$e2e108cbe2e4f865;
module.exports["OnboardingNthUserContentTypeSpotlight"] = $3e3a23abea467e8a$export$5f3827ac6e1d7daa;

});

parcelRegister("tAt1Q", function(module, exports) {
var $cabc5f48a2666489$export$3e5d0af8e738b082 = /*#__PURE__*/ function(Team) {
    Team["SoftwareDevelopment"] = "software-development";
    Team["ProductManagement"] = "product-management";
    Team["Marketing"] = "marketing";
    Team["Design"] = "design";
    Team["ProjectManagement"] = "project-management";
    Team["Operations"] = "operations";
    Team["ITSupport"] = "it-support";
    Team["Finance"] = "finance";
    Team["HumanResources"] = "human-resources";
    Team["Legal"] = "legal";
    Team["Sales"] = "sales";
    Team["Other"] = "other";
    return Team;
}({});
const $cabc5f48a2666489$export$77134aba51f821f8 = {
    ["software-development"]: 'onboarding-helpers.team.software.development.modern.branding',
    ["product-management"]: 'onboarding-helpers.team.productManagement',
    ["marketing"]: 'onboarding-helpers.team.marketing.modern.branding',
    ["design"]: 'onboarding-helpers.team.design',
    ["project-management"]: 'onboarding-helpers.team.projectManagement',
    ["operations"]: 'onboarding-helpers.team.operations.modern.branding',
    ["it-support"]: 'onboarding-helpers.team.it.support.modern.branding',
    ["finance"]: 'onboarding-helpers.team.finance.modern.branding',
    ["human-resources"]: 'onboarding-helpers.team.human.resources.modern.branding',
    ["legal"]: 'onboarding-helpers.team.legal.modern.branding',
    ["sales"]: 'onboarding-helpers.team.sales.modern.branding',
    ["other"]: 'onboarding-helpers.team.other'
};
var $cabc5f48a2666489$export$a0b0994d6b76cdaa = /*#__PURE__*/ function(FocusArea) {
    FocusArea["PlanOutProjects"] = "plan-out-projects";
    FocusArea["CreateTechnicalDocumentation"] = "create-technical-documentation";
    FocusArea["CreateMarketingCampaigns"] = "create-marketing-campaigns";
    FocusArea["ShareStatusUpdates"] = "share-status-updates";
    FocusArea["BrainstormAndStrategize"] = "brainstorm-and-strategize";
    FocusArea["PlanAndPrioritize"] = "plan-and-prioritize";
    FocusArea["GetAlignment"] = "get-alignment";
    FocusArea["ImproveTeamProcesses"] = "improve-team-processes";
    FocusArea["ShareUpdatesWithStakeholders"] = "share-updates-with-stakeholders";
    FocusArea["StrategizeOnMarketingContent"] = "strategize-on-marketing-content";
    FocusArea["ShareWeeklyMeetingNotes"] = "share-weekly-meeting-notes";
    return FocusArea;
}({});
const $cabc5f48a2666489$export$8764a1262502aaf9 = {
    itProjectPoster: 'com.atlassian.confluence.plugins.confluence-business-blueprints:it-project-poster-blueprint',
    sprintPlanning: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-blueprint',
    productRequirements: 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
    softwareArchitectureReview: 'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-blueprint',
    howToArticle: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint',
    architectureDiagram: 'com.atlassian.confluence.plugins.confluence-business-blueprints:aws-architecture-diagram-blueprint',
    incidentCommunication: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-communication-blueprint',
    experimentPlanAndResults: 'com.atlassian.confluence.plugins.confluence-business-blueprints:experiment-planning-and-results-blueprint',
    dailyStandUp: 'com.atlassian.confluence.plugins.confluence-business-blueprints:daily-stand-up-blueprint',
    projectPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
    strategicPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-strategy-blueprint',
    productRoadmap: 'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-blueprint',
    workingAgreements: 'com.atlassian.confluence.plugins.confluence-business-blueprints:working-agreements-blueprint',
    teamPoster: 'com.atlassian.confluence.plugins.confluence-business-blueprints:team-poster-blueprint',
    rolesAndResponsibilities: 'com.atlassian.confluence.plugins.confluence-business-blueprints:roles-responsibilities-blueprint',
    stakeholderCommunications: 'com.atlassian.confluence.plugins.confluence-business-blueprints:stakeholder-communications-blueprint',
    endOfWeekStatusReport: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
    marketingCampaign: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint',
    marketingPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blueprint',
    brainstorming: 'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-blueprint',
    swotAnalysis: 'com.atlassian.confluence.plugins.confluence-business-blueprints:swot-analysis-blueprint',
    competitiveAnalysis: 'com.atlassian.confluence.plugins.confluence-business-blueprints:competitive-analysis-blueprint',
    meetingNotes: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
    daci: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
    customerJourneyMapping: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-journey-mapping-blueprint',
    toDoList: 'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint',
    retrospective: 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint',
    devOpsRunbook: 'com.atlassian.confluence.plugins.confluence-business-blueprints:devops-runbook-blueprint',
    itsmKnownErrors: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-known-errors-blueprint',
    businessStatusUpdate: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
    workshopPlanner: 'com.atlassian.confluence.plugins.confluence-business-blueprints:workshop-planner-blueprint',
    designSystems: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-systems-blueprint',
    designReview: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-review-blueprint',
    businessPlanOnePager: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-plan-one-pager-blueprint',
    riskAssessmentMatrix: 'com.atlassian.confluence.plugins.confluence-business-blueprints:risk-assessment-blueprint',
    vendorAgreement: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vendor-agreement-blueprint',
    visionToValues: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vision-to-values-blueprint',
    careerDevelopmentPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:career-development-plan-blueprint',
    hrKnowledgeBaseManagement: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hr-knowledge-base-management-blueprint',
    salesAccountPlanning: 'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-blueprint',
    salesPortal: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-blueprint',
    smartGoals: 'com.atlassian.confluence.plugins.confluence-business-blueprints:smart-goals-blueprint',
    projectStatus: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-blueprint',
    itsmChangeManagement: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-change-management-blueprint',
    itsmPostIncidentReviews: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-pir-blueprint',
    itsmRunbook: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint',
    troubleshootingArticle: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-article-blueprint',
    mvpIdeation: 'com.atlassian.confluence.plugins.confluence-business-blueprints:mvp-ideation-blueprint',
    designSprint: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-blueprint',
    elevatorPitch: 'com.atlassian.confluence.plugins.confluence-business-blueprints:elevator-pitch-blueprint',
    mutualActionPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:mutual-action-plan-blueprint',
    executiveBusinessReview: 'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-blueprint',
    fiveWhysAnalysis: 'com.atlassian.confluence.plugins.confluence-business-blueprints:5-whys-analysis-blueprint',
    okrs: 'com.atlassian.confluence.plugins.confluence-business-blueprints:okr-blueprint',
    employeeHandbook: 'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-blueprint',
    hiringProcess: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hiring-process-blueprint',
    contentStrategy: 'com.atlassian.confluence.plugins.confluence-business-blueprints:content-strategy-blueprint',
    blankPage: ''
};
var $cabc5f48a2666489$export$14416b8d99d47caa = /*#__PURE__*/ function(Template) {
    Template["ITProjectPoster"] = "it-project-poster";
    Template["SprintPlanning"] = "sprint-planning";
    Template["ProductRequirements"] = "product-requirements";
    Template["SoftwareArchitectureReview"] = "software-architecture-review";
    Template["HowToArticle"] = "how-to-article";
    Template["ArchitectureDiagram"] = "architecture-diagram";
    Template["IncidentCommunication"] = "incident-communication";
    Template["ExperimentPlanAndResults"] = "experiment-plan-and-results";
    Template["DailyStandUp"] = "daily-stand-up";
    Template["ProjectPlan"] = "project-plan";
    Template["StrategicPlan"] = "strategic-plan";
    Template["ProductRoadmap"] = "product-roadmap";
    Template["BlankPage"] = "blank-page";
    Template["WorkingAgreements"] = "working-agreements";
    Template["TeamPoster"] = "team-poster";
    Template["RolesAndResponsibilities"] = "roles-and-responsibilities";
    Template["StakeholderCommunications"] = "stakeholder-communications";
    Template["EndOfWeekStatusReport"] = "end-of-week-status-report";
    Template["MarketingCampaign"] = "marketing-campaign";
    Template["MarketingPlan"] = "marketing-plan";
    Template["Brainstorming"] = "brainstorming";
    Template["SWOTAnalysis"] = "swot-analysis";
    Template["CompetitiveAnalysis"] = "competitive-analysis";
    Template["MeetingNotes"] = "meeting-notes";
    Template["DACI"] = "daci";
    Template["CustomerJourneyMapping"] = "customer-journey-mapping";
    Template["ToDoList"] = "to-do-list";
    Template["Retrospective"] = "retrospective";
    Template["DevOpsRunbook"] = "dev-ops-runbook";
    Template["ITSMKnownErrors"] = "itsm-known-errors";
    Template["BusinessStatusUpdate"] = "business-status-update";
    Template["WorkshopPlanner"] = "workshop-planner";
    Template["DesignSystems"] = "design-systems";
    Template["DesignReview"] = "design-review";
    Template["BusinessPlanOnePager"] = "business-plan-one-pager";
    Template["RiskAssessmentMatrix"] = "risk-assessment-matrix";
    Template["VendorAgreement"] = "vendor-agreement";
    Template["VisionToValues"] = "vision-to-values";
    Template["CareerDevelopmentPlan"] = "career-development-plan";
    Template["HRKnowledgeBaseManagement"] = "hr-knowledge-base-management";
    Template["SalesAccountPlanning"] = "sales-account-planning";
    Template["SalesPortal"] = "sales-portal";
    Template["SMARTGoals"] = "smart-goals";
    Template["ProjectStatus"] = "project-status";
    Template["ITSMChangeManagement"] = "itsm-change-management";
    Template["ITSMPostIncidentReviews"] = "itsm-post-incident-reviews";
    Template["ITSMRunbook"] = "itsm-runbook";
    Template["TroubleshootingArticle"] = "troubleshooting-article";
    Template["MVPIdeation"] = "mvp-ideation";
    Template["DesignSprint"] = "design-sprint";
    Template["ElevatorPitch"] = "elevator-pitch";
    Template["MutualActionPlan"] = "mutual-action-plan";
    Template["ExecutiveBusinessReview"] = "executive-business-review";
    Template["FiveWhysAnalysis"] = "five-whys-analysis";
    Template["OKRs"] = "okrs";
    Template["EmployeeHandbook"] = "employee-handbook";
    Template["HiringProcess"] = "hiring-process";
    return Template;
}({});
var $cabc5f48a2666489$export$32da9fe1f998b96c = /*#__PURE__*/ function(ContentKeys) {
    ContentKeys["BRAINSTORMING"] = "BRAINSTORMING";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-page'
    ContentKeys["REQUIREMENTS_DOC"] = "REQUIREMENTS_DOC";
    // 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint'
    ContentKeys["TASK_TRACKING"] = "TASK_TRACKING";
    // 'com.atlassian.confluence.plugins.confluence-space-blueprints:task-tracker-template'
    ContentKeys["FLOWCHART_AND_DIAGRAMS"] = "FLOWCHART_AND_DIAGRAMS";
    // 'whiteboard:flow-chart'
    ContentKeys["MEETING_NOTES"] = "MEETING_NOTES";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-page'
    ContentKeys["KNOWLEDGE_HUB"] = "KNOWLEDGE_HUB";
    // 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-blueprint'
    ContentKeys["PROJECT_PLAN"] = "PROJECT_PLAN";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-page'
    ContentKeys["GANTT_CHART"] = "GANTT_CHART";
    // 'whiteboard:product-roadmap'
    ContentKeys["CREATIVE_BREIFS"] = "CREATIVE_BRIEFS";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:creative-brief-blueprint'
    ContentKeys["CUSTOMER_JOURNEYS"] = "CUSTOMER_JOURNEYS";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-journey-mapping-blueprint'
    ContentKeys["CAMPAIGN_PLANNING"] = "CAMPAIGN_PLANNING";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-content'
    ContentKeys["PROCESS_MAPPING"] = "PROCESS_MAPPING";
    // 'whiteboard:swimlanes'
    ContentKeys["TEAM_STATUS_UPDATE"] = "TEAM_STATUS_UPDATE";
    return ContentKeys;
}({});
var $cabc5f48a2666489$export$64e2ed2cf579d2ef = /*#__PURE__*/ function(AccountSetupScreens) {
    AccountSetupScreens["TEAM"] = "onboarding-account-setup-modal.teamScreen";
    AccountSetupScreens["TEAM_NO_SKIP"] = "onboarding-account-setup-modal.teamScreen.branding";
    AccountSetupScreens["JTBD"] = "onboarding-account-setup-modal.jtbdScreen";
    AccountSetupScreens["JTBD_MODERN_BRANDING"] = "onboarding-account-setup-modal.jtbdScreen.branding";
    AccountSetupScreens["LOADING"] = "onboarding-account-setup-modal.loadingScreen";
    AccountSetupScreens["LOADING_MODERN_BRANDING"] = "onboarding-account-setup-modal.loadingScreen.branding";
    AccountSetupScreens["TEMPLATE"] = "onboarding-account-setup-modal.templateScreen";
    AccountSetupScreens["TEMPLATE_MODERN_BRANDING"] = "onboarding-account-setup-modal.templateScreen.branding";
    AccountSetupScreens["INVITE"] = "onboarding-account-setup-modal.inviteScreen";
    AccountSetupScreens["INVITE_MODERN_BRANDING"] = "onboarding-account-setup-modal.inviteScreen.branding";
    AccountSetupScreens["CONTENTTYPE"] = "onboarding-account-setup-modal.contentTypeScreen";
    // founding admin
    AccountSetupScreens["NTH_USER_CONTENT_TYPE"] = "onboarding-account-setup-modal.nthUserContentTypeScreen";
    // nth user
    AccountSetupScreens["SPACESTOFOLLOW"] = "onboarding-account-setup-modal.spacesToFollowScreen";
    AccountSetupScreens["EDITION"] = "onboarding-account-setup-modal.editionCommunicationScreen";
    AccountSetupScreens["AUTOPROVISIONING_EDITION"] = "onboarding-account-setup-modal.autoprovisioningEditionScreen";
    AccountSetupScreens["JTBD_CONTENT"] = "onboarding-account-setup-modal.jtbdContentScreen";
    AccountSetupScreens["MADLIBS_CONTENT"] = "onboarding-account-setup-modal.madlibsContentScreen";
    AccountSetupScreens["PRODUCT_QUESTIONS"] = "onboarding-account-setup-modal.productQuestionsScreen";
    AccountSetupScreens["USE_CASES"] = "onboarding-account-setup-modal.useCasesScreen";
    AccountSetupScreens["TEAMMATE_CONTENT"] = "onboarding-account-setup-modal.teammateContentScreen";
    return AccountSetupScreens;
}({});
var $cabc5f48a2666489$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["PAGE"] = "page";
    ContentType["LIVE_DOC"] = "live-doc";
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["DATABASE"] = "database";
    return ContentType;
}({});
var $cabc5f48a2666489$export$6435071f58aaae6a = /*#__PURE__*/ function(NthUserContentType) {
    NthUserContentType["PAGE"] = "page";
    NthUserContentType["WHITEBOARD"] = "whiteboard";
    NthUserContentType["LIVE_DOC"] = "live-doc";
    NthUserContentType["DATABASE"] = "database";
    return NthUserContentType;
}({});
var $cabc5f48a2666489$export$3a8c8363200890be = /*#__PURE__*/ function(RecommendationType) {
    RecommendationType["POPULAR"] = "popular";
    RecommendationType["TEAM_SPACE"] = "teammates";
    return RecommendationType;
}({});
var $cabc5f48a2666489$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
module.exports["Team"] = $cabc5f48a2666489$export$3e5d0af8e738b082;
module.exports["TEAM_ID_MAP"] = $cabc5f48a2666489$export$77134aba51f821f8;
module.exports["FocusArea"] = $cabc5f48a2666489$export$a0b0994d6b76cdaa;
module.exports["TemplateBlueprintModuleCompleteKey"] = $cabc5f48a2666489$export$8764a1262502aaf9;
module.exports["Template"] = $cabc5f48a2666489$export$14416b8d99d47caa;
module.exports["ContentKeys"] = $cabc5f48a2666489$export$32da9fe1f998b96c;
module.exports["AccountSetupScreens"] = $cabc5f48a2666489$export$64e2ed2cf579d2ef;
module.exports["ContentType"] = $cabc5f48a2666489$export$e2e108cbe2e4f865;
module.exports["NthUserContentType"] = $cabc5f48a2666489$export$6435071f58aaae6a;
module.exports["RecommendationType"] = $cabc5f48a2666489$export$3a8c8363200890be;
module.exports["ConfluenceEdition"] = $cabc5f48a2666489$export$68577d543b14ae02;

});

parcelRegister("lrMxq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7d2Nc = parcelRequire("7d2Nc");


var $jmjWc = parcelRequire("jmjWc");


var $fgdVB = parcelRequire("fgdVB");


const $172892494f392667$var$ObjectSidebarControlLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "liSnz",
    name: "ObjectSidebarControlLoader",
    loader: async ()=>(await (parcelRequire("8Dk7o"))).ObjectSidebarControl
});
const $172892494f392667$export$3fab07431350539e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($172892494f392667$var$ObjectSidebarControlLoader, props));
module.exports["ObjectSidebarControl"] = $172892494f392667$export$3fab07431350539e;

});

parcelRegister("fgdVB", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $70b3fb0961586b52$export$ac619e1da09d5f80 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["OBJECT_SIDEBAR_CONTROL_METRIC"] = $70b3fb0961586b52$export$ac619e1da09d5f80;

});

parcelRegister("8Dk7o", function(module, exports) {

let $6491925386b9571f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6491925386b9571f$var$load("li9sm"),
    $6491925386b9571f$var$load("aLLXO"),
    $6491925386b9571f$var$load("9A0ig"),
    $6491925386b9571f$var$load("fTFcV"),
    $6491925386b9571f$var$load("hxZ2q"),
    $6491925386b9571f$var$load("gC5n8"),
    $6491925386b9571f$var$load("iRFO3"),
    $6491925386b9571f$var$load("aPo1I"),
    $6491925386b9571f$var$load("2YffH"),
    $6491925386b9571f$var$load("dFVoN"),
    $6491925386b9571f$var$load("kTdzk"),
    $6491925386b9571f$var$load("igHL0"),
    $6491925386b9571f$var$load("4HdA1"),
    $6491925386b9571f$var$load("i0ttV"),
    $6491925386b9571f$var$load("kCTMZ"),
    $6491925386b9571f$var$load("kSBog"),
    $6491925386b9571f$var$load("2O2Xv"),
    $6491925386b9571f$var$load("grD80"),
    $6491925386b9571f$var$load("1Jgsw"),
    $6491925386b9571f$var$load("dclpt"),
    $6491925386b9571f$var$load("tKhaz"),
    $6491925386b9571f$var$load("4VOW6"),
    $6491925386b9571f$var$load("iK6Gk"),
    $6491925386b9571f$var$load("g5HUX"),
    $6491925386b9571f$var$load("h9Ed7"),
    $6491925386b9571f$var$load("90kvt"),
    $6491925386b9571f$var$load("8TKWI"),
    $6491925386b9571f$var$load("RXppq"),
    $6491925386b9571f$var$load("a0ybh"),
    $6491925386b9571f$var$load("h2QhJ"),
    $6491925386b9571f$var$load("65rGD"),
    $6491925386b9571f$var$load("5Vmp6"),
    $6491925386b9571f$var$load("9jS5g"),
    $6491925386b9571f$var$load("7f9Fz"),
    $6491925386b9571f$var$load("6XCf4"),
    $6491925386b9571f$var$load("St9Nk"),
    $6491925386b9571f$var$load("5pvpJ"),
    $6491925386b9571f$var$load("1Bh2o"),
    $6491925386b9571f$var$load("5CdWD"),
    $6491925386b9571f$var$load("8bZKp"),
    $6491925386b9571f$var$load("9xMxM"),
    $6491925386b9571f$var$load("7RNcA"),
    $6491925386b9571f$var$load("hhss7"),
    $6491925386b9571f$var$load("Wowvf"),
    $6491925386b9571f$var$load("7jSfd"),
    $6491925386b9571f$var$load("4HZlX"),
    $6491925386b9571f$var$load("6wr18"),
    $6491925386b9571f$var$load("kjZZD"),
    $6491925386b9571f$var$load("ckIo9"),
    $6491925386b9571f$var$load("gfSAM"),
    $6491925386b9571f$var$load("1qlDN"),
    $6491925386b9571f$var$load("1yVM6"),
    $6491925386b9571f$var$load("7EorR"),
    $6491925386b9571f$var$load("ffEVr"),
    $6491925386b9571f$var$load("8bVS2"),
    $6491925386b9571f$var$load("hHIPg")
]).then(()=>parcelRequire('lVF98'));

});

parcelRegister("6KaG6", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ce38ba3becf24406$export$877a45ed8043e865 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K9Gzp",
    name: "ObjectSidebarPanel",
    loader: async ()=>(await (parcelRequire("4Ppn3"))).ObjectSidebarPanelWrapper
});
module.exports["ObjectSidebarPanel"] = $ce38ba3becf24406$export$877a45ed8043e865;

});

parcelRegister("4Ppn3", function(module, exports) {

let $383f9af3792e0d6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $383f9af3792e0d6e$var$load("5tz7G"),
    $383f9af3792e0d6e$var$load("gr9Xf")
]).then(()=>parcelRequire('iFpSu'));

});

parcelRegister("lwNi3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $04e9M = parcelRequire("04e9M");


var $jOtRZ = parcelRequire("jOtRZ");


var $lBR3p = parcelRequire("lBR3p");

const $5efec5cf952678ca$export$ddc368dc94a41e62 = (withChoreographer = true)=>{
    const { cloudId: cloudId, activationId: activationId, environment: environment } = (0, $bQm3c.useSessionData)();
    const workspaceId = (0, $04e9M.getWorkspaceId)(cloudId, activationId);
    const disableEngagementForTests = sessionStorage.getItem('confluence.disable-engagement-for-tests') === 'true';
    const envType = (0, $jOtRZ.useAnalyticsEnvironment)(environment);
    return (0, $42omo.useMemo)(()=>(0, $lBR3p.getCoordinationClient)(disableEngagementForTests, cloudId, workspaceId, withChoreographer, envType), [
        disableEngagementForTests,
        cloudId,
        workspaceId,
        withChoreographer,
        envType
    ]);
};
module.exports["useCoordinationClient"] = $5efec5cf952678ca$export$ddc368dc94a41e62;

});

parcelRegister("lBR3p", function(module, exports) {

var $5loD0 = parcelRequire("5loD0");


var $fw9LG = parcelRequire("fw9LG");

const $b379edbfb382bc54$var$noop = async ()=>false;
const $b379edbfb382bc54$export$a3f969ef7d35205d = (disableEngagementForTests, cloudId, workspaceId, enableChoreographer, environment)=>{
    if (disableEngagementForTests) return {
        start: $b379edbfb382bc54$var$noop,
        stop: $b379edbfb382bc54$var$noop
    };
    else {
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: environment,
            additionalData: {
                sourceProductId: (0, $fw9LG.ProductIds).CONFLUENCE
            }
        };
        return new (0, $5loD0.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api',
            isFedRAMPEnvironment: false,
            workspaceId: workspaceId,
            coordinationOptions: coordinationOptions
        });
    }
};
module.exports["getCoordinationClient"] = $b379edbfb382bc54$export$a3f969ef7d35205d;

});

parcelRegister("5loD0", function(module, exports) {

var $ll2sR = parcelRequire("ll2sR");


var $4nGsu = parcelRequire("4nGsu");

class $4b61f610720049a6$export$2e2bcd8739ae039 {
    async start(messageId, variationId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    constructor(configOrCloudId, stargateUrl){
        this.cloudId = void 0;
        this.stargateUrl = void 0;
        this.orgId = void 0;
        this.workspaceId = void 0;
        this.coordinationOptions = void 0;
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
}
module.exports["default"] = $4b61f610720049a6$export$2e2bcd8739ae039;

});

parcelRegister("1UCmC", function(module, exports) {
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5614199f62986e3b = 'all-drafts';
const $00aca2e58bbddd9e$export$3bbaa81ece500746 = 'recent-pages';
const $00aca2e58bbddd9e$export$b634edee624f5dc2 = 'starred-pages';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$cc53520b570e0a46 = 'content-manager';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9ee3c9e81070f140;
module.exports["ADVANCED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$162462d8f302c50a;
module.exports["UNIFIED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$17e011598d6a739d;
module.exports["CONFLUENCE_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$a88513891a2ab6b7;
module.exports["CONFLUENCE_DRAFTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$5614199f62986e3b;
module.exports["CONFLUENCE_RECENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$3bbaa81ece500746;
module.exports["CONFLUENCE_STARRED_LOAD_KEY"] = $00aca2e58bbddd9e$export$b634edee624f5dc2;
module.exports["CONTENT_HISTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$5946c48030569b81;
module.exports["EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$1eefb862c6c6ce00;
module.exports["EDIT_TEMPLATE_LOAD_KEY"] = $00aca2e58bbddd9e$export$e164999ba8681ff6;
module.exports["EDIT_TEMPLATE_OLD_LOAD_KEY"] = $00aca2e58bbddd9e$export$6cdf3f4614ddd679;
module.exports["EMBEDDED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$8faa34d8ba45e128;
module.exports["EMBEDDED_EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$3fb3338cf2b36704;
module.exports["GLOBAL_PERMISSIONS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$779fbc1a16a8cb5d;
module.exports["INACCESSIBLE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9d8c586f3355f180;
module.exports["NOT_FOUND_LOAD_KEY"] = $00aca2e58bbddd9e$export$a0c73183bde575ec;
module.exports["SPACE_DIRECTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$6d480c75094dbd7f;
module.exports["SPACE_OVERVIEW_LOAD_KEY"] = $00aca2e58bbddd9e$export$8d0f9920174f22b4;
module.exports["SPACE_PAGES_LOAD_KEY"] = $00aca2e58bbddd9e$export$228f2841a225e5ad;
module.exports["TASKS_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$fe4f0edc4d6532a8;
module.exports["CONTENT_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$cc53520b570e0a46;
module.exports["SPACE_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$bdc26b2b517231a;
module.exports["TEMPLATE_GALLERY_LOAD_KEY"] = $00aca2e58bbddd9e$export$b6d237d1e8f12e5d;
module.exports["VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$a715ad00b824ec3f;
module.exports["EMBEDDED_MARKETPLACE_LOAD_KEY"] = $00aca2e58bbddd9e$export$132f38e0c19c02b6;
module.exports["CREATE_CONTENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$d2dddf4422ad7ae8;
module.exports["PUBLIC_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9c7a9f4f853f6fba;
module.exports["PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$643b9c181748da38;
module.exports["PUBLIC_LINKS_SPACE_SETTINGS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$4716363caa82a23b;
module.exports["WHITEBOARD_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$75726af5c0ee9402;
module.exports["DATABASE_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$afe76b61b3f9aaa8;
module.exports["EMBED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$dd63a13fc6c1ba34;
module.exports["LIVE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$16aeb03ec0c24b89;
module.exports["LIVE_PAGE_REACT_UFO_LOAD_KEY"] = $00aca2e58bbddd9e$export$ce4e0f6f3d614d45;
module.exports["TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$ecea02b4eaa314f3;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$726cbfa087a55101;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$2f245ed7ebaea89;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY"] = $00aca2e58bbddd9e$export$2af60fefae96902b;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY"] = $00aca2e58bbddd9e$export$fbea00ed02ef2502;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_KEY"] = $00aca2e58bbddd9e$export$6e9c07174668ae36;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$51fdddeccf175d74;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$2d0370cc7d14b72e;
module.exports["ADMIN_IMPORT_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$a8d02dbd84c83dd;
module.exports["ADMIN_TRASHED_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$1d91ea2ef976728a;
module.exports["ADMIN_APPLICATION_NAVIGATOR_KEY"] = $00aca2e58bbddd9e$export$a13bfc71dc6b7924;
module.exports["ADMIN_THEMES_LOAD_KEY"] = $00aca2e58bbddd9e$export$3ba6335cd90d2e59;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY"] = $00aca2e58bbddd9e$export$cb4b6b707a32ee92;
module.exports["ADMIN_PDF_EXPORT_LOAD_KEY"] = $00aca2e58bbddd9e$export$5cb6689cb672a5c0;
module.exports["ADMIN_MACRO_USAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$fff7d33fb1514c44;
module.exports["ADMIN_USER_ACCESS_KEY"] = $00aca2e58bbddd9e$export$d4aa60a3ffc18652;
module.exports["PAGE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$52c0c13179848b50;
module.exports["SPACE_ANALYTICS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$40dab65f060e1231;
module.exports["SITE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$b682ed6d6fa429fb;
module.exports["SPACE_DETAILS_LOAD_KEY"] = $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1;
module.exports["PDF_EXPORT_ROUTE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2633c6986b98b723;

});

parcelRegister("7fw2E", function(module, exports) {

var $6VdZc = parcelRequire("6VdZc");

const $4bc3b2e76c18c48c$export$94f26401757ac8e7 = (metric)=>{
    let params;
    try {
        if ((0, $6VdZc.isInitial)()) {
            if (metric) {
                const data = metric.getData?.();
                const start = data?.start || 0;
                const stop = data?.stop || 0;
                params = [
                    {
                        duration: stop - start,
                        end: 'browser-metric.end'
                    }
                ];
            } else params = [
                undefined,
                'browser-metric.end'
            ];
        } else params = [
            'browser-metric.start',
            'browser-metric.end'
        ];
        performance.mark('browser-metric.end');
        performance.measure('browser-metric:tti', ...params);
    } catch (e) {
    // Suppress error when performance API failed.
    // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
    // That's why wrap with try catch statement.
    }
};
module.exports["markBrowserMetricEnd"] = $4bc3b2e76c18c48c$export$94f26401757ac8e7;

});

parcelRegister("aWrnw", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");


var $1Hqbt = parcelRequire("1Hqbt");

const $d4615ab6ca7803f7$export$b9931e60e47a0122 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
const $d4615ab6ca7803f7$export$618f453a5683e37b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_APPS_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
module.exports["SPACE_NAVIGATION_METRIC"] = $d4615ab6ca7803f7$export$b9931e60e47a0122;
module.exports["SPACE_APPS_METRIC"] = $d4615ab6ca7803f7$export$618f453a5683e37b;

});

parcelRegister("1Hqbt", function(module, exports) {
const $a75b16828791e7fd$export$ea92d4e542ec02b3 = ()=>Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined;
module.exports["ssrConfig"] = $a75b16828791e7fd$export$ea92d4e542ec02b3;

});

parcelRegister("8w1c1", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $73e19354f9924125$export$d9a22aa9387ada7a = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["APP_NAVIGATION_METRIC"] = $73e19354f9924125$export$d9a22aa9387ada7a;

});

parcelRegister("1q7H7", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

var $jX1qB = parcelRequire("jX1qB");

const $108e3019fffb7b94$export$6e28125ef9389dc6 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $108e3019fffb7b94$export$45b21bbf8961b519 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.MOVE_PAGE_DIALOG_INTERACTION)
});
module.exports["PAGE_TREE_METRIC"] = $108e3019fffb7b94$export$6e28125ef9389dc6;
module.exports["MOVE_PAGE_DIALOG_INTERACTION_METRIC"] = $108e3019fffb7b94$export$45b21bbf8961b519;

});

parcelRegister("6hmtW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $83FW4 = parcelRequire("83FW4");


var $jil6p = parcelRequire("jil6p");

const $99a81cd20c880202$export$1cacdacf9568d373 = ()=>{
    const context = (0, $42omo.useContext)((0, $83FW4.CommentContext));
    const memoizedCommentService = (0, $42omo.useMemo)(()=>new (0, $jil6p.ContentTypesCommentService)(), []);
    if (!context) return {
        commentService: (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedCommentService : new (0, $jil6p.ContentTypesCommentService)()
    };
    return context;
};
module.exports["useCommentService"] = $99a81cd20c880202$export$1cacdacf9568d373;

});

parcelRegister("cgpF0", function(module, exports) {
class $ef2bdef46a40b8c0$export$b44304baa0bf4e7b {
    updateTitle(title) {
        this.titleChangeHandler(title);
    }
    setTitleChangeHandler(cb) {
        this.titleChangeHandler = cb;
    }
    constructor(){
        this.titleChangeHandler = void 0;
        this.titleChangeHandler = ()=>{};
    }
}
const $ef2bdef46a40b8c0$export$6450770420296206 = new $ef2bdef46a40b8c0$export$b44304baa0bf4e7b();
module.exports["contentTypesTitleServiceSingleton"] = $ef2bdef46a40b8c0$export$6450770420296206;

});

parcelRegister("9XexZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $15h8H = parcelRequire("15h8H");

const $26e790de36bba91a$export$a74fbbd6fb01001c = (clientId, setupHandlers, apiInstance = (0, $15h8H.getBrowserBridgeAPI)())=>{
    const refApi = (0, $42omo.useRef)(apiInstance);
    const refReady = (0, $42omo.useRef)(false);
    const refMount = (0, $42omo.useRef)(setupHandlers);
    const api = refApi.current;
    const setup = (0, $42omo.useCallback)(()=>{
        // register all handlers
        // devx: provide current `clientId`
        setupHandlers?.((command, handler)=>api.on(clientId, command, handler));
    }, [
        clientId,
        setupHandlers,
        api
    ]);
    const ready = (0, $42omo.useCallback)(()=>{
        // setup all handlers
        setup();
        // mark client as ready
        api.ready(clientId);
        // now, the client can receive messages AND handle them
        refReady.current = true;
    }, [
        clientId,
        setup,
        api
    ]);
    const send = (0, $42omo.useCallback)((command, params)=>{
        // devx: provide current `clientId`
        return api.send(command, {
            ...params,
            senderId: clientId
        });
    }, [
        clientId,
        api
    ]);
    const broadcast = (0, $42omo.useCallback)((command, params, options)=>{
        api.broadcast(command, params, options);
    }, [
        api
    ]);
    const teardown = (0, $42omo.useCallback)(()=>{
        // devx: provide current `clientId`
        return api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    (0, $42omo.useEffect)(()=>{
        // teardown if component tree is being destroyed
        // note: will also tear down all command handlers on your behalf
        return ()=>api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    /**
	 * If we have already mounted our handlers once and marked ourselves as ready, then this
	 * bridge API client is already capable of receiving & handling commands. On subsequent renders
	 * if our {@link setupHandlers} reference changes, we need to make sure we run our setup again.
	 *
	 * This will ensure the newest state of every handler is being used, with no stale references
	 * in closures, as can often occur with initialise-only-once code in React.
	 */ if (refReady.current && refMount.current !== setupHandlers) setup();
    // so we can compare on next render
    refMount.current = setupHandlers;
    return {
        id: api.id,
        ready: ready,
        send: send,
        teardown: teardown,
        broadcast: broadcast
    };
};
module.exports["useRovoContentBridgeAPI"] = $26e790de36bba91a$export$a74fbbd6fb01001c;

});

parcelRegister("gejop", function(module, exports) {
/**
 * @generated SignedSource<<dcc7465266fc46a48308c2a084af2ed9>>
 * @relayHash 3a27260e57e410ffecd4ba617c6d3637
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 31c4e4a3ba20d4a057426f91f20e95897295f9d91218d2d7ad20c63eb6d8908d
const $3cac748832e2023e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsAIEnabledForContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsAIEnabledForContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3a27260e57e410ffecd4ba617c6d3637",
            "id": "31c4e4a3ba20d4a057426f91f20e95897295f9d91218d2d7ad20c63eb6d8908d",
            "metadata": {},
            "name": "useIsAIEnabledForContentQuery",
            "operationKind": "query",
            "text": "query useIsAIEnabledForContentQuery($contentId:ID!){content(id:$contentId){nodes{id,operations{targetType,operation}}}}"
        }
    };
}();
$3cac748832e2023e$var$node.hash = "87034a7db072a7db419402593bcbd707";
var $3cac748832e2023e$export$2e2bcd8739ae039 = $3cac748832e2023e$var$node;
module.exports["default"] = $3cac748832e2023e$export$2e2bcd8739ae039;

});

parcelRegister("7mpOv", function(module, exports) {

var $gejop = parcelRequire("gejop");


var $42omo = parcelRequire("42omo");


var $lzcvT = parcelRequire("lzcvT");


var $jMyy4 = parcelRequire("jMyy4");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $9wGTI = parcelRequire("9wGTI");

const $7ae32555811cd45f$var$UseIsAIEnabledForContentQuery = (0, $gejop.default);
const $7ae32555811cd45f$var$isAIReadAllowed = (operationsList)=>{
    if (operationsList) return operationsList.some((item)=>item?.operation === 'ai_read');
    else return false;
};
const $7ae32555811cd45f$export$cc5edac91cdebf9b = ({ contentId: contentId })=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const shouldShowRovo = (0, $9wGTI.fg)('rovo_use_rovo_llm_enabled_check') ? isRovoLLMEnabled : isRovoEnabled;
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)($7ae32555811cd45f$var$UseIsAIEnabledForContentQuery, {
        variables: {
            contentId: contentId
        },
        skip: !contentId || (0, $lzcvT.isFedRamp)() || !isAdminHubAIEnabled && !shouldShowRovo || !(0, $9wGTI.fg)('confluence_ai_access_policy')
    });
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    if (!(0, $9wGTI.fg)('confluence_ai_access_policy')) return {
        isAIEnabledForContent: isAdminHubAIEnabled,
        isRovoEnabledForContent: shouldShowRovo
    };
    const aiRead = $7ae32555811cd45f$var$isAIReadAllowed(data?.content?.nodes?.[0]?.operations);
    return {
        isAIEnabledForContent: aiRead && isAdminHubAIEnabled,
        isRovoEnabledForContent: aiRead && shouldShowRovo
    };
};
function $7ae32555811cd45f$export$fb975e2d7306f54a(WrappedComponent) {
    return function EnhancedComponent(props) {
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = $7ae32555811cd45f$export$cc5edac91cdebf9b({
            contentId: contentId ?? ''
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            isAIEnabledForContent: isAIEnabledForContent,
            isRovoEnabledForContent: isRovoEnabledForContent
        });
    };
}
module.exports["useIsAIEnabledForContent"] = $7ae32555811cd45f$export$cc5edac91cdebf9b;
module.exports["withIsAIEnabledForContent"] = $7ae32555811cd45f$export$fb975e2d7306f54a;

});

parcelRegister("bMmYR", function(module, exports) {
/**
 * Sleep an async context for timeoutMs milliseconds
 *
 * Note this does not block but instead sets a timeout
 *
 * @param timeoutMs The timeout in milliseconds
 * @returns {Promise} A promise that resolves after timeoutMs milliseconds
 */ const $e3747894d76f1f8c$var$sleep = (timeoutMs)=>new Promise((resolve)=>setTimeout(resolve, timeoutMs));
const $e3747894d76f1f8c$export$9369b12211e1fce4 = (action, { backOff: backOff = true, jitter: jitter = true, timeout: timeout = 2000, maxAttempts: maxAttempts = 3 } = {}, shouldRetry)=>{
    const recursiveRetry = async (attempt)=>{
        let nextTryIn = null;
        if (attempt < maxAttempts) {
            const jitterFactor = jitter ? 1 + Math.random() : 1;
            const backOffFactor = backOff ? Math.pow(2, attempt) : 1;
            nextTryIn = timeout * backOffFactor * jitterFactor;
        }
        try {
            return await action(attempt, nextTryIn);
        } catch (ex) {
            if (nextTryIn === null) throw ex;
            if (shouldRetry && !await shouldRetry(ex)) throw ex;
            await $e3747894d76f1f8c$var$sleep(nextTryIn);
            return await recursiveRetry(attempt + 1);
        }
    };
    return recursiveRetry(0);
};
module.exports["retry"] = $e3747894d76f1f8c$export$9369b12211e1fce4;

});

parcelRegister("7aw3q", function(module, exports) {

var $1iSzD = parcelRequire("1iSzD");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");

const $440129e2f2e8f952$export$d22f0c9bbe97be97 = ()=>{
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasComments: hasPageComments, hasInlineCommentsAndHighlightActions: hasViewInlineComments } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    const allowPageCommentsInEmbeddedMode = hasPageComments;
    const allowInlineCommentsInEmbeddedMode = hasViewInlineComments || hasEditInlineComments;
    return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
module.exports["useEmbeddedComments"] = $440129e2f2e8f952$export$d22f0c9bbe97be97;

});

parcelRegister("9bL1w", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $gyiJY = parcelRequire("gyiJY");

const { edit: $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
var $30ba1cd08ee89eb0$export$36621fa7e88734f8 = /*#__PURE__*/ function(EmbeddedEditPageButtons) {
    EmbeddedEditPageButtons["DELETE_DRAFT"] = "delete-draft";
    EmbeddedEditPageButtons["TEMPLATE_BROWSER"] = "template-browser";
    return EmbeddedEditPageButtons;
}({});
const $30ba1cd08ee89eb0$export$3f18272ea50bc7e1 = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)() || $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES;
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-publish-close-buttons" out of allowedEditPageFeatures,
	 * so that the Publish and Close buttons won't be hidden when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-publish-close-buttons'
    ];
    const allAllowedFeaturesEnabled = allowedFeatures === 'all';
    const allowedEditPageFeatures = allAllowedFeaturesEnabled ? (0, $9VQUw.EDIT_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const allowedEllipsisButtons = [];
    const isDeleteDraftEnabled = allowedEditPageFeatures?.includes("delete-draft");
    if (isDeleteDraftEnabled) allowedEllipsisButtons.push("delete-draft");
    const templateBrowserConfig = !allAllowedFeaturesEnabled ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser' in x) : undefined;
    const isTemplateBrowserEnabled = allowedEditPageFeatures?.includes("template-browser") || !!templateBrowserConfig;
    if (isTemplateBrowserEnabled) allowedEllipsisButtons.push("template-browser");
    const isSpacePickerDisabled = templateBrowserConfig?.['template-browser']?.['space-picker-disabled'] ?? false;
    const hasInlineCommentsAndHighlightActions = allowedEditPageFeatures?.includes('inline-comments');
    const isPublishModalEnabled = allowedEditPageFeatures?.includes('publish-modal');
    const hidePublishCloseButtons = allowedEditPageFeatures?.includes('disable-publish-close-buttons');
    const loomExternalOpenRoute = allowedEditPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route;
    return {
        allowedEllipsisButtons: allowedEllipsisButtons,
        isTemplateBrowserEnabled: isTemplateBrowserEnabled,
        isSpacePickerDisabled: isSpacePickerDisabled,
        hasInlineCommentsAndHighlightActions: hasInlineCommentsAndHighlightActions,
        isPublishModalEnabled: isPublishModalEnabled,
        hidePublishCloseButtons: hidePublishCloseButtons,
        loomExternalOpenRoute: loomExternalOpenRoute
    };
};
module.exports["useEmbeddedEditPageFeatures"] = $30ba1cd08ee89eb0$export$3f18272ea50bc7e1;

});

parcelRegister("9VQUw", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

const $4ea72974304e25a5$export$1acbaeb6a9a6bc40 = (0, $hpNab.ALLOWED_FEATURES).view;
const $4ea72974304e25a5$export$2c7469b01e61fde2 = (0, $hpNab.ALLOWED_FEATURES).edit;
const $4ea72974304e25a5$export$72afc086e90eb0bf = (0, $hpNab.ALLOWED_FEATURES).whiteboard;
module.exports["VIEW_PAGE_FEATURES"] = $4ea72974304e25a5$export$1acbaeb6a9a6bc40;
module.exports["EDIT_PAGE_FEATURES"] = $4ea72974304e25a5$export$2c7469b01e61fde2;
module.exports["WHITEBOARD_FEATURES"] = $4ea72974304e25a5$export$72afc086e90eb0bf;

});

parcelRegister("gyiJY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iV5Ic = parcelRequire("iV5Ic");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");

const $b2e9e223d7519ab7$var$QUERY_NAME = 'initialAllowedFeatures';
var $b2e9e223d7519ab7$export$2ba0e67b02c658ce = /*#__PURE__*/ function(FeatureMode) {
    FeatureMode["VIEW"] = "view";
    FeatureMode["EDIT"] = "edit";
    FeatureMode["WHITEBOARD"] = "whiteboard";
    return FeatureMode;
}({});
function $b2e9e223d7519ab7$export$745a9b66a8f1814a() {
    const { allowedFeatures: allowedFeatures } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    /**
	 * When allowedFeatures passthrough props not available but query param `initialAllowedFeatures` available, we resolve allowedFeatures from this query param
	 * After allowedFeatures passthrough props become available again at SPA, the allowedFeatures should be resolved by passthrough props
	 * This is needed for rendering consistent features between SSR and SPA phases, as SSR phase cannot resolve passthrough props through `window.postMessage`
	 *
	 * E.g.
	 * - `?embedded=true&initialAllowedFeatures=edit,delete` should only enable Edit and Delete features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=all` should enable all features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=` should enable no features in SSR phase
	 */ const queriedAllowedFeatures = (0, $42omo.useMemo)(()=>(0, $c3Qwv.getSingleParam)(getQueryParams(), $b2e9e223d7519ab7$var$QUERY_NAME), [
        getQueryParams
    ]);
    const initialAllowedFeatures = (0, $42omo.useMemo)(()=>{
        let features;
        if (queriedAllowedFeatures === '') features = [];
        else if (queriedAllowedFeatures === 'all') features = 'all';
        else // There is a bug to be fixed where comma "," in query param will break view page SSR https://product-fabric.atlassian.net/browse/SCALE-5274
        // Workaround is to allow "." as query param separator instead of comma ",". Use regex here to support both characters.
        features = queriedAllowedFeatures?.split(/[\s,.]+/).map((feature)=>{
            try {
                return JSON.parse(feature);
            } catch (error) {
                return feature;
            }
        }) ?? undefined;
        return features;
    }, [
        queriedAllowedFeatures
    ]);
    // Ensure the return type matches UseAllowedFeaturesType<T>
    if (!allowedFeatures && initialAllowedFeatures !== undefined) return initialAllowedFeatures;
    return allowedFeatures;
}
module.exports["useAllowedFeatures"] = $b2e9e223d7519ab7$export$745a9b66a8f1814a;

});

parcelRegister("cxu5H", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $gyiJY = parcelRequire("gyiJY");

const { view: $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
const $9b72a1c744147957$export$f9f73b7eca94463f = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)();
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-share" out of allowedViewPageFeatures,
	 * so that the Share button won't be disable when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-share',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar'
    ];
    const allowedViewPageFeatures = allowedFeatures === 'all' ? (0, $9VQUw.VIEW_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const showShare = !(allowedViewPageFeatures?.includes('disable-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-share'));
    return {
        showShare: showShare,
        hasByLineContributors: allowedViewPageFeatures?.includes('byline-contributors') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-contributors'),
        hasByLineExtensions: allowedViewPageFeatures?.includes('byline-extensions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-extensions'),
        hasPageReactions: allowedViewPageFeatures?.includes('page-reactions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-reactions'),
        hasStickyHeader: allowedViewPageFeatures?.includes('sticky-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('sticky-header'),
        showEdit: allowedViewPageFeatures?.includes('edit') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('edit'),
        showDelete: allowedViewPageFeatures?.includes('delete') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('delete'),
        hasComments: allowedViewPageFeatures?.includes('page-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-comments'),
        hasInlineCommentsAndHighlightActions: allowedViewPageFeatures?.includes('inline-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('inline-comments'),
        includeNonLicensedUsersToShare: showShare && (allowedViewPageFeatures?.includes('non-licensed-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('non-licensed-share')),
        hasModernHeader: allowedViewPageFeatures?.includes('modern-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('modern-header'),
        hideHelpButton: allowedViewPageFeatures?.includes('disable-help-button') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-help-button'),
        hideTitleToolbar: allowedViewPageFeatures?.includes('disable-title-toolbar') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-title-toolbar'),
        loomExternalOpenRoute: allowedViewPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route
    };
};
module.exports["useEmbeddedViewPageFeatures"] = $9b72a1c744147957$export$f9f73b7eca94463f;

});

parcelRegister("5fMeR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $21K7m = parcelRequire("21K7m");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $cZa7r = parcelRequire("cZa7r");


var $3mVfX = parcelRequire("3mVfX");


var $ep3mz = parcelRequire("ep3mz");


var $dANtQ = parcelRequire("dANtQ");


var $gEtAQ = parcelRequire("gEtAQ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $2eC70 = parcelRequire("2eC70");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $bSvtO = parcelRequire("bSvtO");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $9buj5 = parcelRequire("9buj5");


const $3b7f940e5fdc8097$var$CommentsPanelFilterMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Cp4VO",
    name: "CommentsPanelFilterMenu",
    loader: async ()=>(await (parcelRequire("aVZaK"))).CommentsPanelFilterMenu
});

const $3b7f940e5fdc8097$var$CommentsPanelFooter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "V6uhH",
    name: "CommentsPanelFooter",
    loader: async ()=>(await (parcelRequire("1b6Ok"))).CommentsPanelFooter
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EqpEC",
    name: "CommentsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("68wB4"))).CommentsPanelHeaderIcon
});

const $3b7f940e5fdc8097$var$CommentsPanelWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r3W5r",
    name: "CommentsPanelWrapper",
    loader: async ()=>(await (parcelRequire("3N4O8"))).CommentsPanelWrapper
});
const $3b7f940e5fdc8097$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    commentsPanelHeaderLabel: {
        id: "comments-panel.panel.header.label",
        defaultMessage: "Comments"
    }
});
const $3b7f940e5fdc8097$export$833f9a16214bbf3d = ()=>{
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isDatabaseView = (0, $gEtAQ.isDatabase)();
    const isWhiteboardView = (0, $gEtAQ.isWhiteboard)();
    const { handleMarkCommentsAsRead: handleMarkCommentsAsRead } = (0, $9buj5.useUnreadPanelComments)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const [shouldClearUnreads, setShouldClearUnreads] = (0, $42omo.useState)(false);
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setViewProps: setViewProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', true);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    // a ref is needed here because of a closure issue with canClosePanel
    const hasContentChangedRef = (0, $42omo.useRef)(hasContentChanged);
    (0, $42omo.useEffect)(()=>{
        hasContentChangedRef.current = hasContentChanged;
    }, [
        hasContentChanged
    ]);
    // Required to invoke handleMarkCommentsAsRead and if any commentsMarkedAsRead
    // then we will call the MarkCommentsReadMutation Mutation
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        if (shouldClearUnreads) handleMarkCommentsAsRead();
        return ()=>{
            setShouldClearUnreads(false);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldClearUnreads,
        setShouldClearUnreads
    ]);
    const onPanelCloseFunction = ()=>{
        setCurrentView(undefined);
        setShouldClearUnreads(true);
        // Unselect active annotations on the page
        if (pageMode === (0, $cD1qu.PageMode).VIEW) {
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
            setViewProps(null);
        } else {
            eventEmitter.emit('setselectedannotation', '');
            setEditorViewProps(null);
        }
        // clear selected comment thread in the comments panel
        setCurrentlySelectedThreadKey('');
        if ((0, $6mKj3.expValEquals)('confluence_comments_5766_bugfix', 'isEnabled', true)) setReplyToCommentId();
    };
    const onPanelCloseCallback = (0, $42omo.useCallback)(onPanelCloseFunction, [
        setCurrentView,
        setShouldClearUnreads,
        pageMode,
        eventEmitter,
        setViewProps,
        setEditorViewProps,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId
    ]);
    const onPanelClose = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? onPanelCloseCallback : onPanelCloseFunction;
    const canClosePanel = (0, $42omo.useCallback)(async ()=>{
        if (hasContentChangedRef.current && !(0, $9wGTI.fg)('confluence_comments_fix_duplicate_modal')) return new Promise((resolve)=>{
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged && resetContentChanged();
                    resolve(true);
                },
                onCancel: ()=>{
                    resolve(false);
                }
            });
        });
        else return true;
    }, [
        resetContentChanged,
        showModal
    ]);
    const showCommentsPanelFunction = ({ openWithView: openWithView } = {})=>{
        if (!allowComments) return;
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE),
            attributes: {
                ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                openWithView: openWithView,
                contentId: contentId,
                pageMode: pageMode
            }
        });
        const loadFooterComments = (0, $9wGTI.fg)('confluence_comment_footercomments_editpage') ? pageMode !== (0, $cD1qu.PageMode).EDIT : true;
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).CommentsPanel,
            headerComponentElements: {
                HeaderIcon: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon : undefined,
                headerLabel: $3b7f940e5fdc8097$export$a7357cdd1f0b0168.commentsPanelHeaderLabel,
                HeaderRightAlignedElement: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? $3b7f940e5fdc8097$var$CommentsPanelFilterMenu : undefined
            },
            BodyComponent: ()=>$3b7f940e5fdc8097$var$CommentsPanelWrapper({
                    openWithView: openWithView
                }),
            FooterComponent: canAddComments && contentStatus !== (0, $cD1qu.ContentStatus).DRAFT && loadFooterComments && !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? $3b7f940e5fdc8097$var$CommentsPanelFooter : undefined,
            closeOptions: {
                canClosePanel: canClosePanel,
                onPanelClose: onPanelClose
            }
        }, 'push');
    };
    const showCommentsPanelHandler = (0, $42omo.useCallback)(showCommentsPanelFunction, [
        allowComments,
        canAddComments,
        canClosePanel,
        contentId,
        contentStatus,
        experienceTracker,
        isDatabaseView,
        isSpaceOverviewPage,
        isWhiteboardView,
        onPanelClose,
        pageMode,
        showObjectSidebar
    ]);
    const showCommentsPanel = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? showCommentsPanelHandler : showCommentsPanelFunction;
    // NOTE: Exposing the hide function for now while we have the CommentButton
    return {
        isCommentsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel,
        showCommentsPanel: showCommentsPanel,
        hideCommentsPanel: hideObjectSidebar
    };
};
module.exports["useShowCommentsPanel"] = $3b7f940e5fdc8097$export$833f9a16214bbf3d;

});

parcelRegister("jvYFk", function(module, exports) {
var $d9aaea339f75cad2$export$328a8baf694e5d32 = /*#__PURE__*/ function(PanelName) {
    PanelName["CommentsPanel"] = "commentsPanel";
    PanelName["DetailsPanel"] = "detailsPanel";
    PanelName["WorkflowsPanel"] = "workflowsPanel";
    return PanelName;
}({});
module.exports["PanelName"] = $d9aaea339f75cad2$export$328a8baf694e5d32;

});

parcelRegister("dANtQ", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $diswb = parcelRequire("diswb");

const $be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery = (0, $eSUdr.default)`query useAddCommentPermissionCheckPermissionCheckAddCommentQuery($contentId:ID!){content(id:$contentId status:["draft" "current"]){nodes{id type operations{operation targetType}}}}`;
const $be6154107952d370$export$4cae5d8963399c48 = (contentId, cacheOnly = false)=>{
    const { data: data, loading: loading, error: error, refetch: refetch, networkStatus: networkStatus } = (0, $diswb.useQuery)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, {
        variables: {
            contentId: contentId
        },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: cacheOnly ? 'cache-only' : 'cache-and-network',
        skip: !contentId
    });
    const contentNode = data?.content?.nodes?.[0];
    const operations = contentNode?.operations ?? [];
    const createPermission = operations.some((operationResults)=>operationResults?.operation === 'create' && operationResults?.targetType === 'comment');
    return {
        canAddComments: createPermission,
        loading: loading,
        contentQueryError: error,
        refetch: refetch,
        networkStatus: networkStatus
    };
};
module.exports["useAddCommentPermissionCheck"] = $be6154107952d370$export$4cae5d8963399c48;

});

parcelRegister("9buj5", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $diswb = parcelRequire("diswb");


var $8i27m = parcelRequire("8i27m");


var $fHAwL = parcelRequire("fHAwL");


var $3mVfX = parcelRequire("3mVfX");


var $9wGTI = parcelRequire("9wGTI");

const $02faaefae22f6672$var$useUnreadPanelCommentsMarkInlineCommentsReadMutation = (0, $eSUdr.default)`mutation useUnreadPanelCommentsMarkInlineCommentsReadMutation($commentIds:[ID!]!){markCommentsAsRead(input:{commentIds:$commentIds}){success errors}}`;
const $02faaefae22f6672$export$b2c07ec1a20446f7 = ()=>{
    const [{ commentsMarkedAsRead: commentsMarkedAsRead }, { clearCommentsMarkedAsRead: clearCommentsMarkedAsRead }] = (0, $3mVfX.useCommentsPanel)();
    const { updateUnreadStatus: updateUnreadStatus } = (0, $8i27m.useCommentsDataActions)();
    const [{ readCommentsListState: readCommentsListState, unreadCommentsListState: unreadCommentsListState }, { updateReadCommentsListState: updateReadCommentsListState, updateUnreadCommentsListState: updateUnreadCommentsListState }] = (0, $fHAwL.useUnreadComments)();
    // TODO: handle error
    const [markInlineCommentsRead] = (0, $diswb.useMutation)($02faaefae22f6672$var$useUnreadPanelCommentsMarkInlineCommentsReadMutation);
    // call the mutation to mark the list of comment IDs as read
    const handleMarkCommentsAsRead = (0, $42omo.useCallback)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        if (Object.keys(commentsMarkedAsRead.inline).length > 0 || Object.keys(commentsMarkedAsRead.general).length > 0) {
            const inlineCommentIdsToMarkAsRead = Object.values(commentsMarkedAsRead.inline).reduce((acc, set)=>{
                acc.push(...set);
                return acc;
            }, []);
            const generalCommentIdsToMarkAsRead = Object.values(commentsMarkedAsRead.general).reduce((acc, set)=>{
                acc.push(...set);
                return acc;
            }, []);
            const commentIdsToMarkAsRead = [
                ...inlineCommentIdsToMarkAsRead,
                ...generalCommentIdsToMarkAsRead
            ];
            if (!commentIdsToMarkAsRead?.length) return;
            markInlineCommentsRead({
                variables: {
                    commentIds: commentIdsToMarkAsRead
                }
            });
            // update our data store to indicate these comments are now read
            updateUnreadStatus(commentsMarkedAsRead, (0, $8i27m.UnreadAction).READ);
            // reset our list of comments to mark as read
            clearCommentsMarkedAsRead();
            // update existing unread and read data stores
            const commentIdsToMarkAsReadSet = new Set(commentIdsToMarkAsRead);
            const filteredUnreadComments = unreadCommentsListState.filter((unreadComment)=>!commentIdsToMarkAsReadSet.has(unreadComment.id));
            updateUnreadCommentsListState(()=>filteredUnreadComments);
            const newReadCommentsListState = new Set([
                ...readCommentsListState,
                ...commentIdsToMarkAsRead
            ]);
            updateReadCommentsListState(()=>newReadCommentsListState);
        }
    }, [
        markInlineCommentsRead,
        clearCommentsMarkedAsRead,
        commentsMarkedAsRead,
        updateUnreadStatus,
        readCommentsListState,
        unreadCommentsListState,
        updateReadCommentsListState,
        updateUnreadCommentsListState
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) return;
        const handleBeforeUnload = ()=>{
            // Mark comments as read if the user closes the window
            handleMarkCommentsAsRead();
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            // Mark comments as read when the component unmounts
            handleMarkCommentsAsRead();
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (0, $42omo.useMemo)(()=>({
            handleMarkCommentsAsRead: handleMarkCommentsAsRead
        }), [
        handleMarkCommentsAsRead
    ]);
};
module.exports["useUnreadPanelComments"] = $02faaefae22f6672$export$b2c07ec1a20446f7;

});

parcelRegister("aVZaK", function(module, exports) {

let $020dea077fc2d877$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $020dea077fc2d877$var$load("9jS5g"),
    $020dea077fc2d877$var$load("8bVS2"),
    $020dea077fc2d877$var$load("kHOMt"),
    $020dea077fc2d877$var$load("laMwR"),
    $020dea077fc2d877$var$load("aZinD"),
    $020dea077fc2d877$var$load("1QdXB"),
    $020dea077fc2d877$var$load("goLL0"),
    $020dea077fc2d877$var$load("9Z7qK"),
    $020dea077fc2d877$var$load("duPDN"),
    $020dea077fc2d877$var$load("70qyO"),
    $020dea077fc2d877$var$load("1Jgsw"),
    $020dea077fc2d877$var$load("iIL8i"),
    $020dea077fc2d877$var$load("lkOIY"),
    $020dea077fc2d877$var$load("hcj2C"),
    $020dea077fc2d877$var$load("2UF2x"),
    $020dea077fc2d877$var$load("1iUSs"),
    $020dea077fc2d877$var$load("4eboO"),
    $020dea077fc2d877$var$load("8YSo7"),
    $020dea077fc2d877$var$load("6FuHS"),
    $020dea077fc2d877$var$load("eyaRC"),
    $020dea077fc2d877$var$load("9ijrN"),
    $020dea077fc2d877$var$load("hv4mn"),
    $020dea077fc2d877$var$load("Wowvf"),
    $020dea077fc2d877$var$load("dTsOE"),
    $020dea077fc2d877$var$load("cyGuT"),
    $020dea077fc2d877$var$load("34a3A"),
    $020dea077fc2d877$var$load("34hCx"),
    $020dea077fc2d877$var$load("iRFO3"),
    $020dea077fc2d877$var$load("aPo1I"),
    $020dea077fc2d877$var$load("fZt2F"),
    $020dea077fc2d877$var$load("7u4WP"),
    $020dea077fc2d877$var$load("8Gekp"),
    $020dea077fc2d877$var$load("7e13v"),
    $020dea077fc2d877$var$load("let0D"),
    $020dea077fc2d877$var$load("6EQss"),
    $020dea077fc2d877$var$load("8KnyD"),
    $020dea077fc2d877$var$load("6M36W"),
    $020dea077fc2d877$var$load("ioQAS"),
    $020dea077fc2d877$var$load("kUbUu"),
    $020dea077fc2d877$var$load("4Lgj0"),
    $020dea077fc2d877$var$load("kSJiq"),
    $020dea077fc2d877$var$load("etaHA"),
    $020dea077fc2d877$var$load("3a0wT"),
    $020dea077fc2d877$var$load("gYeBT"),
    $020dea077fc2d877$var$load("fqGSw"),
    $020dea077fc2d877$var$load("gLGsg"),
    $020dea077fc2d877$var$load("dlZSj"),
    $020dea077fc2d877$var$load("5tz7G"),
    $020dea077fc2d877$var$load("6wr18"),
    $020dea077fc2d877$var$load("jwWp5"),
    $020dea077fc2d877$var$load("hhss7"),
    $020dea077fc2d877$var$load("7EorR"),
    $020dea077fc2d877$var$load("awqCy"),
    $020dea077fc2d877$var$load("lqbST"),
    $020dea077fc2d877$var$load("ffEVr"),
    $020dea077fc2d877$var$load("bZz7X")
]).then(()=>parcelRequire('g9dNl'));

});

parcelRegister("1b6Ok", function(module, exports) {

let $0dbc1a04916e0b24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0dbc1a04916e0b24$var$load("9jS5g"),
    $0dbc1a04916e0b24$var$load("8bVS2"),
    $0dbc1a04916e0b24$var$load("kHOMt"),
    $0dbc1a04916e0b24$var$load("laMwR"),
    $0dbc1a04916e0b24$var$load("aZinD"),
    $0dbc1a04916e0b24$var$load("1QdXB"),
    $0dbc1a04916e0b24$var$load("goLL0"),
    $0dbc1a04916e0b24$var$load("9Z7qK"),
    $0dbc1a04916e0b24$var$load("duPDN"),
    $0dbc1a04916e0b24$var$load("70qyO"),
    $0dbc1a04916e0b24$var$load("1Jgsw"),
    $0dbc1a04916e0b24$var$load("iIL8i"),
    $0dbc1a04916e0b24$var$load("lkOIY"),
    $0dbc1a04916e0b24$var$load("hcj2C"),
    $0dbc1a04916e0b24$var$load("2UF2x"),
    $0dbc1a04916e0b24$var$load("1iUSs"),
    $0dbc1a04916e0b24$var$load("4eboO"),
    $0dbc1a04916e0b24$var$load("8YSo7"),
    $0dbc1a04916e0b24$var$load("6FuHS"),
    $0dbc1a04916e0b24$var$load("eyaRC"),
    $0dbc1a04916e0b24$var$load("9ijrN"),
    $0dbc1a04916e0b24$var$load("hv4mn"),
    $0dbc1a04916e0b24$var$load("Wowvf"),
    $0dbc1a04916e0b24$var$load("dTsOE"),
    $0dbc1a04916e0b24$var$load("cyGuT"),
    $0dbc1a04916e0b24$var$load("34a3A"),
    $0dbc1a04916e0b24$var$load("34hCx"),
    $0dbc1a04916e0b24$var$load("iRFO3"),
    $0dbc1a04916e0b24$var$load("aPo1I"),
    $0dbc1a04916e0b24$var$load("fZt2F"),
    $0dbc1a04916e0b24$var$load("7u4WP"),
    $0dbc1a04916e0b24$var$load("8Gekp"),
    $0dbc1a04916e0b24$var$load("7e13v"),
    $0dbc1a04916e0b24$var$load("let0D"),
    $0dbc1a04916e0b24$var$load("6EQss"),
    $0dbc1a04916e0b24$var$load("8KnyD"),
    $0dbc1a04916e0b24$var$load("6M36W"),
    $0dbc1a04916e0b24$var$load("ioQAS"),
    $0dbc1a04916e0b24$var$load("kUbUu"),
    $0dbc1a04916e0b24$var$load("4Lgj0"),
    $0dbc1a04916e0b24$var$load("kSJiq"),
    $0dbc1a04916e0b24$var$load("etaHA"),
    $0dbc1a04916e0b24$var$load("3a0wT"),
    $0dbc1a04916e0b24$var$load("gYeBT"),
    $0dbc1a04916e0b24$var$load("fqGSw"),
    $0dbc1a04916e0b24$var$load("gLGsg"),
    $0dbc1a04916e0b24$var$load("dlZSj"),
    $0dbc1a04916e0b24$var$load("5tz7G"),
    $0dbc1a04916e0b24$var$load("6wr18"),
    $0dbc1a04916e0b24$var$load("jwWp5"),
    $0dbc1a04916e0b24$var$load("hhss7"),
    $0dbc1a04916e0b24$var$load("7EorR"),
    $0dbc1a04916e0b24$var$load("awqCy"),
    $0dbc1a04916e0b24$var$load("lqbST"),
    $0dbc1a04916e0b24$var$load("ffEVr"),
    $0dbc1a04916e0b24$var$load("bZz7X")
]).then(()=>parcelRequire('gFN6K'));

});

parcelRegister("68wB4", function(module, exports) {

let $477cc68011be90b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $477cc68011be90b5$var$load("9jS5g"),
    $477cc68011be90b5$var$load("8bVS2"),
    $477cc68011be90b5$var$load("kHOMt"),
    $477cc68011be90b5$var$load("laMwR"),
    $477cc68011be90b5$var$load("aZinD"),
    $477cc68011be90b5$var$load("1QdXB"),
    $477cc68011be90b5$var$load("goLL0"),
    $477cc68011be90b5$var$load("9Z7qK"),
    $477cc68011be90b5$var$load("duPDN"),
    $477cc68011be90b5$var$load("70qyO"),
    $477cc68011be90b5$var$load("1Jgsw"),
    $477cc68011be90b5$var$load("iIL8i"),
    $477cc68011be90b5$var$load("lkOIY"),
    $477cc68011be90b5$var$load("hcj2C"),
    $477cc68011be90b5$var$load("2UF2x"),
    $477cc68011be90b5$var$load("1iUSs"),
    $477cc68011be90b5$var$load("4eboO"),
    $477cc68011be90b5$var$load("8YSo7"),
    $477cc68011be90b5$var$load("6FuHS"),
    $477cc68011be90b5$var$load("eyaRC"),
    $477cc68011be90b5$var$load("9ijrN"),
    $477cc68011be90b5$var$load("hv4mn"),
    $477cc68011be90b5$var$load("Wowvf"),
    $477cc68011be90b5$var$load("dTsOE"),
    $477cc68011be90b5$var$load("cyGuT"),
    $477cc68011be90b5$var$load("34a3A"),
    $477cc68011be90b5$var$load("34hCx"),
    $477cc68011be90b5$var$load("iRFO3"),
    $477cc68011be90b5$var$load("aPo1I"),
    $477cc68011be90b5$var$load("fZt2F"),
    $477cc68011be90b5$var$load("7u4WP"),
    $477cc68011be90b5$var$load("8Gekp"),
    $477cc68011be90b5$var$load("7e13v"),
    $477cc68011be90b5$var$load("let0D"),
    $477cc68011be90b5$var$load("6EQss"),
    $477cc68011be90b5$var$load("8KnyD"),
    $477cc68011be90b5$var$load("6M36W"),
    $477cc68011be90b5$var$load("ioQAS"),
    $477cc68011be90b5$var$load("kUbUu"),
    $477cc68011be90b5$var$load("4Lgj0"),
    $477cc68011be90b5$var$load("kSJiq"),
    $477cc68011be90b5$var$load("etaHA"),
    $477cc68011be90b5$var$load("3a0wT"),
    $477cc68011be90b5$var$load("gYeBT"),
    $477cc68011be90b5$var$load("fqGSw"),
    $477cc68011be90b5$var$load("gLGsg"),
    $477cc68011be90b5$var$load("dlZSj"),
    $477cc68011be90b5$var$load("5tz7G"),
    $477cc68011be90b5$var$load("6wr18"),
    $477cc68011be90b5$var$load("jwWp5"),
    $477cc68011be90b5$var$load("hhss7"),
    $477cc68011be90b5$var$load("7EorR"),
    $477cc68011be90b5$var$load("awqCy"),
    $477cc68011be90b5$var$load("lqbST"),
    $477cc68011be90b5$var$load("ffEVr"),
    $477cc68011be90b5$var$load("bZz7X")
]).then(()=>parcelRequire('ioFqb'));

});

parcelRegister("3N4O8", function(module, exports) {

let $2c29ad5f3ee266d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2c29ad5f3ee266d0$var$load("9jS5g"),
    $2c29ad5f3ee266d0$var$load("8bVS2"),
    $2c29ad5f3ee266d0$var$load("kHOMt"),
    $2c29ad5f3ee266d0$var$load("laMwR"),
    $2c29ad5f3ee266d0$var$load("aZinD"),
    $2c29ad5f3ee266d0$var$load("1QdXB"),
    $2c29ad5f3ee266d0$var$load("goLL0"),
    $2c29ad5f3ee266d0$var$load("9Z7qK"),
    $2c29ad5f3ee266d0$var$load("duPDN"),
    $2c29ad5f3ee266d0$var$load("70qyO"),
    $2c29ad5f3ee266d0$var$load("1Jgsw"),
    $2c29ad5f3ee266d0$var$load("iIL8i"),
    $2c29ad5f3ee266d0$var$load("lkOIY"),
    $2c29ad5f3ee266d0$var$load("hcj2C"),
    $2c29ad5f3ee266d0$var$load("2UF2x"),
    $2c29ad5f3ee266d0$var$load("1iUSs"),
    $2c29ad5f3ee266d0$var$load("4eboO"),
    $2c29ad5f3ee266d0$var$load("8YSo7"),
    $2c29ad5f3ee266d0$var$load("6FuHS"),
    $2c29ad5f3ee266d0$var$load("eyaRC"),
    $2c29ad5f3ee266d0$var$load("9ijrN"),
    $2c29ad5f3ee266d0$var$load("hv4mn"),
    $2c29ad5f3ee266d0$var$load("Wowvf"),
    $2c29ad5f3ee266d0$var$load("dTsOE"),
    $2c29ad5f3ee266d0$var$load("cyGuT"),
    $2c29ad5f3ee266d0$var$load("34a3A"),
    $2c29ad5f3ee266d0$var$load("34hCx"),
    $2c29ad5f3ee266d0$var$load("iRFO3"),
    $2c29ad5f3ee266d0$var$load("aPo1I"),
    $2c29ad5f3ee266d0$var$load("fZt2F"),
    $2c29ad5f3ee266d0$var$load("7u4WP"),
    $2c29ad5f3ee266d0$var$load("8Gekp"),
    $2c29ad5f3ee266d0$var$load("7e13v"),
    $2c29ad5f3ee266d0$var$load("let0D"),
    $2c29ad5f3ee266d0$var$load("6EQss"),
    $2c29ad5f3ee266d0$var$load("8KnyD"),
    $2c29ad5f3ee266d0$var$load("6M36W"),
    $2c29ad5f3ee266d0$var$load("ioQAS"),
    $2c29ad5f3ee266d0$var$load("kUbUu"),
    $2c29ad5f3ee266d0$var$load("4Lgj0"),
    $2c29ad5f3ee266d0$var$load("kSJiq"),
    $2c29ad5f3ee266d0$var$load("etaHA"),
    $2c29ad5f3ee266d0$var$load("3a0wT"),
    $2c29ad5f3ee266d0$var$load("gYeBT"),
    $2c29ad5f3ee266d0$var$load("fqGSw"),
    $2c29ad5f3ee266d0$var$load("gLGsg"),
    $2c29ad5f3ee266d0$var$load("dlZSj"),
    $2c29ad5f3ee266d0$var$load("5tz7G"),
    $2c29ad5f3ee266d0$var$load("6wr18"),
    $2c29ad5f3ee266d0$var$load("jwWp5"),
    $2c29ad5f3ee266d0$var$load("hhss7"),
    $2c29ad5f3ee266d0$var$load("7EorR"),
    $2c29ad5f3ee266d0$var$load("awqCy"),
    $2c29ad5f3ee266d0$var$load("lqbST"),
    $2c29ad5f3ee266d0$var$load("ffEVr"),
    $2c29ad5f3ee266d0$var$load("bZz7X")
]).then(()=>parcelRequire('5hqV2'));

});

parcelRegister("d3bcC", function(module, exports) {

var $5VFXo = parcelRequire("5VFXo");


var $aXiya = parcelRequire("aXiya");


var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $jMyy4 = parcelRequire("jMyy4");


var $ij4CE = parcelRequire("ij4CE");


var $fFmJj = parcelRequire("fFmJj");


var $ep3mz = parcelRequire("ep3mz");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $18a2fd912dfb58ac$var$ContentAnalyticsViewedComments = (0, $eSUdr.default)`query useViewedCommentsQuery($contentId:ID!$contentType:ConfluenceAnalyticsCommentContentType!){contentAnalyticsViewedComments(contentId:$contentId contentType:$contentType){commentIds}}`;
// Helper function to safely convert content type for the viewed comments query
const $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments = (contentType)=>{
    // Only page, database, and whiteboard support the viewed comments query
    if (contentType === 'page' || contentType === 'database' || contentType === 'whiteboard') return contentType;
    // Fallback to page for other content types (blogpost, embed, etc.)
    return 'page';
};
// Helper to generate stable ROOT_QUERY cache key
// Ensures consistent key format regardless of object property order
const $18a2fd912dfb58ac$var$getRootQueryCacheId = (pageId, contentType)=>{
    const validContentType = $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType);
    // Sort keys to ensure stable JSON.stringify output
    const variables = {
        contentId: pageId,
        contentType: validContentType
    };
    return `$ROOT_QUERY.contentAnalyticsViewedComments(${JSON.stringify(variables)})`;
};
const $18a2fd912dfb58ac$export$cd81a9ad0848990 = ({ pageId: pageId })=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $aXiya.default)
    });
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $5VFXo.default)
    });
    // Network-only query for fresh data
    const { refetch: refetch } = (0, $jMyy4.useQueryInterop)(/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ $18a2fd912dfb58ac$var$ContentAnalyticsViewedComments, {
        skip: true,
        // Never query on render
        fetchPolicy: 'network-only',
        variables: {
            contentId: pageId,
            contentType: $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType)
        }
    });
    // Helper function to process the query result
    const processQueryResult = (0, $42omo.useCallback)((data)=>{
        const commentIds = data?.contentAnalyticsViewedComments?.commentIds ?? [];
        const viewedCommentsSet = new Set(commentIds.filter((id)=>id !== null));
        return {
            success: true,
            data: viewedCommentsSet
        };
    }, []);
    // Helper function for cache-only queries
    const executeCacheOnlyQuery = (0, $42omo.useCallback)(()=>{
        if (!pageId || !contentType) throw new Error('Page ID and content type are required');
        try {
            // Read from ROOT_QUERY (where Apollo stores query results)
            const rootQueryCacheId = $18a2fd912dfb58ac$var$getRootQueryCacheId(pageId, contentType);
            const rootQueryData = readFragmentInterop({
                id: rootQueryCacheId
            });
            if (rootQueryData) {
                // Convert fragment data to query result format
                const queryResult = {
                    contentAnalyticsViewedComments: {
                        commentIds: rootQueryData.commentIds,
                        __typename: 'ViewedComments'
                    }
                };
                return processQueryResult(queryResult);
            }
            return {
                success: false,
                error: new Error('No viewed comments data found in cache')
            };
        } catch (error) {
            // Handle cache read errors - these are local operations so we just log unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return {
                success: false,
                error: error
            };
        }
    }, [
        pageId,
        contentType,
        processQueryResult,
        readFragmentInterop
    ]);
    // Helper function for network-only queries
    const executeNetworkOnlyQuery = (0, $42omo.useCallback)(async ()=>{
        if (!pageId) throw new Error('Page ID and content type are required');
        try {
            const result = await refetch({
                contentId: pageId,
                contentType: $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType)
            });
            // Apollo automatically writes query results to ROOT_QUERY cache, so we don't need to explicitly write
            // The executeCacheOnlyQuery function will read from ROOT_QUERY directly
            return processQueryResult(result.data);
        } catch (error) {
            // Handle expected errors (403/unauthorized, network errors) - just mark as handled
            if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return {
                    success: false,
                    error: error
                };
            }
            // Handle unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return {
                success: false,
                error: error
            };
        }
    }, [
        pageId,
        contentType,
        processQueryResult,
        refetch
    ]);
    // Cached data query - uses cache-only for performance
    const getViewedCommentsCacheOnly = (0, $42omo.useCallback)(()=>{
        try {
            return executeCacheOnlyQuery();
        } catch (error) {
            return {
                success: false,
                error: error
            };
        }
    }, [
        executeCacheOnlyQuery
    ]);
    // Fresh data query - always uses network-only for latest data
    const getViewedCommentsFresh = (0, $42omo.useCallback)(()=>executeNetworkOnlyQuery(), [
        executeNetworkOnlyQuery
    ]);
    // Function to update the viewed comments cache
    // This is used for optimistic updates when comments are viewed locally
    const updateViewedCommentsCache = (0, $42omo.useCallback)((commentIds)=>{
        if (!pageId || !contentType || commentIds.length === 0) return;
        try {
            // Read from ROOT_QUERY (where Apollo stores query results)
            const rootQueryCacheId = $18a2fd912dfb58ac$var$getRootQueryCacheId(pageId, contentType);
            const rootQueryData = readFragmentInterop({
                id: rootQueryCacheId
            });
            const existingCommentIds = rootQueryData?.commentIds ?? [];
            // Merge new comment IDs with existing ones
            const existingSet = new Set(existingCommentIds.filter((id)=>id !== null));
            commentIds.forEach((id)=>existingSet.add(id));
            const mergedCommentIds = Array.from(existingSet);
            // Update ROOT_QUERY cache
            writeFragmentInterop({
                fragmentId: rootQueryCacheId,
                data: {
                    commentIds: mergedCommentIds,
                    __typename: 'ViewedComments'
                }
            });
        } catch (error) {
            // Handle cache writing errors - these are local operations so we just log unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        pageId,
        contentType,
        readFragmentInterop,
        writeFragmentInterop
    ]);
    return {
        getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
        getViewedCommentsFresh: getViewedCommentsFresh,
        updateViewedCommentsCache: updateViewedCommentsCache
    };
};
module.exports["useViewedComments"] = $18a2fd912dfb58ac$export$cd81a9ad0848990;

});

parcelRegister("5VFXo", function(module, exports) {
/**
 * @generated SignedSource<<d7ff2c3ce2ccb5f9937eae905c203b17>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a1027eddc6949c38$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewedComments_read",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "commentIds"
        }
    ],
    "type": "ViewedComments"
};
$a1027eddc6949c38$var$node.hash = "8133cc01831582777d2e0911570e19eb";
var $a1027eddc6949c38$export$2e2bcd8739ae039 = $a1027eddc6949c38$var$node;
module.exports["default"] = $a1027eddc6949c38$export$2e2bcd8739ae039;

});

parcelRegister("aXiya", function(module, exports) {
/**
 * @generated SignedSource<<4105699bb3b57f32cd10410da7fded55>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7e3d4a4e06abb15d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewedComments_write",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "commentIds"
        }
    ],
    "type": "ViewedComments"
};
$7e3d4a4e06abb15d$var$node.hash = "d155cf7774eeec1efd57aa640539aef9";
var $7e3d4a4e06abb15d$export$2e2bcd8739ae039 = $7e3d4a4e06abb15d$var$node;
module.exports["default"] = $7e3d4a4e06abb15d$export$2e2bcd8739ae039;

});

parcelRegister("9Bcrd", function(module, exports) {

var $9v2ll = parcelRequire("9v2ll");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/space/manifest.ts
var $6fd137ac0f81d835$var$confluenceSpaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $9v2ll.ConfluenceSpaceAriResourceOwner),
    resourceType: (0, $9v2ll.ConfluenceSpaceAriResourceType),
    resourceIdSlug: "{spaceId}",
    resourceIdSegmentFormats: {
        spaceId: /[0-9]+/
    }
};
// src/confluence/space/index.ts
var $6fd137ac0f81d835$export$4e1bd9257e1b7213 = class _ConfluenceSpaceAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get spaceId() {
        return this._spaceId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6fd137ac0f81d835$var$confluenceSpaceAriStaticOpts.qualifier,
            platformQualifier: $6fd137ac0f81d835$var$confluenceSpaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $6fd137ac0f81d835$var$confluenceSpaceAriStaticOpts.resourceOwner,
            resourceType: $6fd137ac0f81d835$var$confluenceSpaceAriStaticOpts.resourceType,
            resourceId: `${opts.spaceId}`,
            resourceIdSegmentValues: {
                spaceId: opts.spaceId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $6fd137ac0f81d835$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $6fd137ac0f81d835$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            spaceId: this.spaceId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._spaceId = opts.resourceIdSegmentValues.spaceId;
    }
};
module.exports["ConfluenceSpaceAri"] = $6fd137ac0f81d835$export$4e1bd9257e1b7213;

});

parcelRegister("9v2ll", function(module, exports) {
// src/confluence/space/types.ts
var $6ea8d3a61088a29d$export$204c4c730af505ce = "confluence", $6ea8d3a61088a29d$export$7c78a678ea7a8ac7 = "space";
module.exports["ConfluenceSpaceAriResourceOwner"] = $6ea8d3a61088a29d$export$204c4c730af505ce;
module.exports["ConfluenceSpaceAriResourceType"] = $6ea8d3a61088a29d$export$7c78a678ea7a8ac7;

});

parcelRegister("6S5EB", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $d5074feaeb7f756a$export$50d92d69a5c05c70 = ()=>!!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
module.exports["isExternalShareRequest"] = $d5074feaeb7f756a$export$50d92d69a5c05c70;

});

parcelRegister("c1UWH", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

class $992a1265dc051ead$var$UnreadCommentsIntersectionObserver {
    createObserver() {
        try {
            if (typeof IntersectionObserver === 'undefined') return;
            this.observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    const commentId = entry.target.getAttribute('data-comment-id');
                    if (!commentId) return;
                    if (entry.isIntersecting) {
                        // Comment became visible - set new timer for this specific comment
                        const timer = setTimeout(()=>{
                            this.intersectionCallbacks.forEach((callback)=>{
                                callback(commentId);
                            });
                            // Clear the timer for this comment
                            this.commentTimersMap.delete(commentId);
                            // Unobserve this element since it's been processed
                            if (this.observer) {
                                this.observer.unobserve(entry.target);
                                this.observedElementsSet.delete(entry.target);
                            }
                        }, 2000); // 2 seconds default
                        this.commentTimersMap.set(commentId, timer);
                    } else // Comment became invisible - clear timer for this comment
                    if (this.commentTimersMap.has(commentId)) {
                        clearTimeout(this.commentTimersMap.get(commentId));
                        this.commentTimersMap.delete(commentId);
                    }
                });
            }, {
                threshold: [
                    0.25
                ],
                // add a bottom root margin to account for sticky elements at the bottom of the observable viewport such as the sticky footer
                // this is because the intersection observer doesn't know about elements that are above the observed comments, and so we can avoid
                // marking comments as read when they're not actually visible to the user. this is a best effort approach
                rootMargin: '0px 0px -65px 0px',
                // Add a custom name to identify this as the unread comments observer
                // This helps in tests to distinguish it from other intersection observers
                name: 'unreadCommentsObserver'
            });
        } catch  {
            this.observer = null;
        }
    }
    observeComment(targetElement) {
        // don't observe if the observer is not initialized
        if (!this.observer) return;
        // don't observe if the targetElement is not a valid element
        if (!targetElement) return;
        // don't observe the same element twice
        if (this.observedElementsSet.has(targetElement)) return;
        this.observer.observe(targetElement);
        this.observedElementsSet.add(targetElement);
    }
    unobserveComment(targetElement) {
        // don't unobserve if the observer is not initialized
        if (!this.observer) return;
        // don't unobserve if the targetElement is not a valid element
        if (!targetElement) return;
        // only unobserve if we're actually observing this element
        if (!this.observedElementsSet.has(targetElement)) return;
        // Clear any running timer for this comment
        const commentId = targetElement.getAttribute('data-comment-id');
        if (commentId && this.commentTimersMap.has(commentId)) {
            clearTimeout(this.commentTimersMap.get(commentId));
            this.commentTimersMap.delete(commentId);
        }
        this.observer.unobserve(targetElement);
        this.observedElementsSet.delete(targetElement);
    }
    // By exposing this function, we allow consumers to register callbacks
    registerIntersectionCallback(callback) {
        this.intersectionCallbacks.push(callback);
    }
    // Reconnect the observer if it was disconnected
    reconnect() {
        if (!this.observer) this.createObserver();
    }
    // Clean up method
    disconnect() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
        // Clear all timers
        this.commentTimersMap.forEach((timer)=>clearTimeout(timer));
        this.commentTimersMap.clear();
        // Clear observed elements
        this.observedElementsSet.clear();
        // Clear callbacks
        this.intersectionCallbacks = [];
    }
    constructor(){
        this.observer = null;
        this.commentTimersMap = new Map();
        this.observedElementsSet = new Set();
        this.intersectionCallbacks = [];
        this.createObserver();
    }
}
// memoize ensures an IntersectionObserver is instantiated only once
const $992a1265dc051ead$var$getStableIntersectionObserver = (0, $2XqLN.default)(()=>{
    return new $992a1265dc051ead$var$UnreadCommentsIntersectionObserver();
});
const $992a1265dc051ead$export$ad65f5516d9692ed = ()=>{
    const intersectionObserver = $992a1265dc051ead$var$getStableIntersectionObserver();
    intersectionObserver.reconnect();
    return intersectionObserver;
};
module.exports["getUnreadCommentsIntersectionObserver"] = $992a1265dc051ead$export$ad65f5516d9692ed;

});

parcelRegister("e4kZB", function(module, exports) {
const $5243889752facbc2$export$446c7c25f5f55821 = (comment)=>{
    return {
        id: comment.id,
        author: {
            accountId: comment.author?.__typename === 'KnownUser' ? comment.author.accountId : undefined
        },
        createdAt: {
            value: comment.createdAt?.value || ''
        },
        location: {
            type: comment.location.type,
            inlineMarkerRef: comment.location?.inlineMarkerRef,
            inlineResolveProperties: comment.location?.inlineResolveProperties,
            commentResolveProperties: comment.location?.commentResolveProperties
        }
    };
};
const $5243889752facbc2$export$77349abd6de54bd8 = ({ commentId: commentId, userId: userId, createdAt: createdAt, commentType: commentType, resolveProperties: resolveProperties })=>{
    return {
        id: commentId,
        author: {
            accountId: userId || undefined
        },
        createdAt: {
            value: createdAt || ''
        },
        location: {
            type: commentType,
            ...commentType === 'INLINE' ? {
                inlineResolveProperties: resolveProperties || {
                    resolved: false
                }
            } : {
                commentResolveProperties: resolveProperties || {
                    resolved: false
                }
            }
        }
    };
};
const $5243889752facbc2$export$8df0b6c8bcdda615 = ({ pageMode: pageMode = 'view', annotationsInEditorDoc: annotationsInEditorDoc, rendererAnnotations: rendererAnnotations })=>(markerRef)=>{
        if (!markerRef) return false; // default to false if no marker ref
        // Treat 'live' mode as 'edit' mode
        const effectivePageMode = pageMode === 'live' ? 'edit' : pageMode;
        return effectivePageMode === 'view' ? !rendererAnnotations.has(markerRef) : !annotationsInEditorDoc.has(markerRef);
    };
const $5243889752facbc2$export$22ce26f7ba09f326 = ({ comment: comment, currentUserId: currentUserId, viewedComments: viewedComments, isDanglingCallback: isDanglingCallback })=>{
    // Early return if comment is already viewed
    if (viewedComments.has(comment.id)) return false;
    const isNotOwnComment = comment.author?.accountId && comment.author.accountId !== currentUserId;
    const createdLast30Days = new Date(comment.createdAt?.value) > new Date(Date.now() - 2592000000);
    const commentLocation = comment?.location;
    const markerRef = commentLocation?.inlineMarkerRef;
    const isDanglingInlineComment = isDanglingCallback ? isDanglingCallback(markerRef) : false;
    const isPageComment = comment?.location.type === 'FOOTER';
    const isResolved = comment?.location?.inlineResolveProperties?.resolved || comment?.location?.commentResolveProperties?.resolved;
    return !isResolved && isNotOwnComment && createdLast30Days && (!isDanglingInlineComment || isPageComment);
};
const $5243889752facbc2$export$92c1e243fe45a57f = async ({ allComments: allComments, currentUserId: currentUserId, pageId: pageId, updateUnreadCommentIDSet: updateUnreadCommentIDSet, resetStates: resetStates, viewedComments: viewedComments, isDanglingCallback: isDanglingCallback, addNewCommentThreads: addNewCommentThreads })=>{
    if (!allComments || !pageId) return;
    const unreadCommentIds = new Set();
    // keep track inline comment threads so we can prepopulate comments data map in order to keep track of dangling and resolved comments for unread
    const inlineCommentThreadsToAdd = {};
    allComments.forEach((comment)=>{
        if (!comment) return;
        if (comment.location.type === 'INLINE') {
            const commentLocation = comment.location;
            const threadKey = commentLocation?.inlineMarkerRef;
            if (threadKey) // Our query only returns open comments, so we need to set the isOpen status to true
            inlineCommentThreadsToAdd[threadKey] = {
                ...comment,
                isOpen: true,
                wasRemovedByAnotherUser: false
            };
        }
        if (currentUserId) {
            const parentCommentForValidation = $5243889752facbc2$export$446c7c25f5f55821(comment);
            if ($5243889752facbc2$export$22ce26f7ba09f326({
                comment: parentCommentForValidation,
                currentUserId: currentUserId,
                viewedComments: viewedComments,
                isDanglingCallback: isDanglingCallback
            })) unreadCommentIds.add(comment.id);
            if (comment.replies) comment.replies.forEach((reply)=>{
                if (reply) {
                    const replyForValidation = $5243889752facbc2$export$446c7c25f5f55821(reply);
                    if ($5243889752facbc2$export$22ce26f7ba09f326({
                        comment: replyForValidation,
                        currentUserId: currentUserId,
                        viewedComments: viewedComments,
                        isDanglingCallback: isDanglingCallback
                    })) unreadCommentIds.add(reply.id);
                }
            });
        }
    });
    updateUnreadCommentIDSet(unreadCommentIds, 'initialize');
    // Add the comment threads for inline comments at the end
    addNewCommentThreads && addNewCommentThreads({
        inline: inlineCommentThreadsToAdd,
        general: {}
    });
    // Once we are done updating the unread list, need to reset the states.
    resetStates();
};
module.exports["buildValidationObjectFromProps"] = $5243889752facbc2$export$77349abd6de54bd8;
module.exports["commentIsDangling"] = $5243889752facbc2$export$8df0b6c8bcdda615;
module.exports["isValidUnreadComment"] = $5243889752facbc2$export$22ce26f7ba09f326;
module.exports["createUnreadCommentsSet"] = $5243889752facbc2$export$92c1e243fe45a57f;

});

parcelRegister("8WQTF", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $4677820b18a14e4d$export$66feffbad722f9d4 = /*#__PURE__*/ (0, $42omo.createContext)({
    rendererActions: null,
    pageId: undefined
});
$4677820b18a14e4d$export$66feffbad722f9d4.displayName = 'RendererActionsContext';
const $4677820b18a14e4d$export$c7c5640cf8aff722 = /*#__PURE__*/ (0, $42omo.createContext)({
    setRendererActions: ()=>{}
});
$4677820b18a14e4d$export$c7c5640cf8aff722.displayName = 'RendererActionsDispatchContext';
const $4677820b18a14e4d$export$a41bfe8d4028fb59 = ({ children: children })=>{
    const [rendererActions, setRendererActions] = (0, $42omo.useState)(null);
    const [pageId, setPageId] = (0, $42omo.useState)(undefined);
    const providerValue = (0, $42omo.useMemo)(()=>({
            rendererActions: rendererActions,
            pageId: pageId
        }), [
        rendererActions,
        pageId
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setRendererActions: (actions, newPageId)=>{
                setRendererActions(actions);
                setPageId(newPageId);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4677820b18a14e4d$export$66feffbad722f9d4.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4677820b18a14e4d$export$c7c5640cf8aff722.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $4677820b18a14e4d$export$55249bdd00e8a5d6 = ()=>{
    return (0, $42omo.useContext)($4677820b18a14e4d$export$66feffbad722f9d4);
};
const $4677820b18a14e4d$export$6e9863dfedeaae60 = ()=>{
    return (0, $42omo.useContext)($4677820b18a14e4d$export$c7c5640cf8aff722);
};
module.exports["RendererActionsProvider"] = $4677820b18a14e4d$export$a41bfe8d4028fb59;
module.exports["useRendererActions"] = $4677820b18a14e4d$export$55249bdd00e8a5d6;
module.exports["useRendererActionsDispatch"] = $4677820b18a14e4d$export$6e9863dfedeaae60;

});

parcelRegister("hysf6", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $jmjWc = parcelRequire("jmjWc");


const $4119a6166d969e95$var$DetailsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "TmpiW",
    name: "DetailsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("1NFoH"))).DetailsPanelHeaderIcon
});

const $4119a6166d969e95$var$DetailsPanelBody = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "WdQRW",
    name: "DetailsPanelBody",
    loader: async ()=>(await (parcelRequire("kVv1F"))).DetailsPanelBody
});
const $4119a6166d969e95$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    detailsPanelHeaderLabel: {
        id: "details-panel.panel.header.label",
        defaultMessage: "Details"
    }
});
const $4119a6166d969e95$export$fd546c83bdd1393d = ()=>{
    const { showObjectSidebar: showObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const showDetailsPanel = ({ highlightLabels: highlightLabels } = {})=>{
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).DetailsPanel,
            headerComponentElements: {
                HeaderIcon: $4119a6166d969e95$var$DetailsPanelHeaderIcon,
                headerLabel: $4119a6166d969e95$export$a7357cdd1f0b0168.detailsPanelHeaderLabel
            },
            BodyComponent: $4119a6166d969e95$var$DetailsPanelBody,
            props: {
                highlightLabels: highlightLabels
            }
        }, 'push');
    };
    return {
        isDetailsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).DetailsPanel,
        showDetailsPanel: showDetailsPanel
    };
};
module.exports["useShowDetailsPanel"] = $4119a6166d969e95$export$fd546c83bdd1393d;

});

parcelRegister("1NFoH", function(module, exports) {

let $14fa7ab1cae2f4da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $14fa7ab1cae2f4da$var$load("6EQss"),
    $14fa7ab1cae2f4da$var$load("a08Vk"),
    $14fa7ab1cae2f4da$var$load("jtwfh"),
    $14fa7ab1cae2f4da$var$load("9ZkgN"),
    $14fa7ab1cae2f4da$var$load("2mt3f"),
    $14fa7ab1cae2f4da$var$load("l4YAS"),
    $14fa7ab1cae2f4da$var$load("lnnYm"),
    $14fa7ab1cae2f4da$var$load("4XFRu"),
    $14fa7ab1cae2f4da$var$load("gctwz"),
    $14fa7ab1cae2f4da$var$load("coJiW"),
    $14fa7ab1cae2f4da$var$load("hcj2C"),
    $14fa7ab1cae2f4da$var$load("2UF2x"),
    $14fa7ab1cae2f4da$var$load("h4Nf7"),
    $14fa7ab1cae2f4da$var$load("5uN9h"),
    $14fa7ab1cae2f4da$var$load("6FuHS"),
    $14fa7ab1cae2f4da$var$load("eyaRC"),
    $14fa7ab1cae2f4da$var$load("iXzmH"),
    $14fa7ab1cae2f4da$var$load("65c4i"),
    $14fa7ab1cae2f4da$var$load("7EorR"),
    $14fa7ab1cae2f4da$var$load("hhss7"),
    $14fa7ab1cae2f4da$var$load("Wowvf"),
    $14fa7ab1cae2f4da$var$load("kjZZD"),
    $14fa7ab1cae2f4da$var$load("ckIo9"),
    $14fa7ab1cae2f4da$var$load("gfSAM"),
    $14fa7ab1cae2f4da$var$load("iRFO3"),
    $14fa7ab1cae2f4da$var$load("aPo1I"),
    $14fa7ab1cae2f4da$var$load("6wr18"),
    $14fa7ab1cae2f4da$var$load("ffEVr"),
    $14fa7ab1cae2f4da$var$load("8zlfy")
]).then(()=>parcelRequire('7N9MO'));

});

parcelRegister("kVv1F", function(module, exports) {

let $03ee788edb9e411b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $03ee788edb9e411b$var$load("6EQss"),
    $03ee788edb9e411b$var$load("a08Vk"),
    $03ee788edb9e411b$var$load("jtwfh"),
    $03ee788edb9e411b$var$load("9ZkgN"),
    $03ee788edb9e411b$var$load("2mt3f"),
    $03ee788edb9e411b$var$load("l4YAS"),
    $03ee788edb9e411b$var$load("lnnYm"),
    $03ee788edb9e411b$var$load("4XFRu"),
    $03ee788edb9e411b$var$load("gctwz"),
    $03ee788edb9e411b$var$load("coJiW"),
    $03ee788edb9e411b$var$load("hcj2C"),
    $03ee788edb9e411b$var$load("2UF2x"),
    $03ee788edb9e411b$var$load("h4Nf7"),
    $03ee788edb9e411b$var$load("5uN9h"),
    $03ee788edb9e411b$var$load("6FuHS"),
    $03ee788edb9e411b$var$load("eyaRC"),
    $03ee788edb9e411b$var$load("iXzmH"),
    $03ee788edb9e411b$var$load("65c4i"),
    $03ee788edb9e411b$var$load("7EorR"),
    $03ee788edb9e411b$var$load("hhss7"),
    $03ee788edb9e411b$var$load("Wowvf"),
    $03ee788edb9e411b$var$load("kjZZD"),
    $03ee788edb9e411b$var$load("ckIo9"),
    $03ee788edb9e411b$var$load("gfSAM"),
    $03ee788edb9e411b$var$load("iRFO3"),
    $03ee788edb9e411b$var$load("aPo1I"),
    $03ee788edb9e411b$var$load("6wr18"),
    $03ee788edb9e411b$var$load("ffEVr"),
    $03ee788edb9e411b$var$load("8zlfy")
]).then(()=>parcelRequire('9igqG'));

});

parcelRegister("4B2M3", function(module, exports) {
/* ObservableSpinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");


var $l8oxh = parcelRequire("l8oxh");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5ccd6b86c893b680$var$SpinnerWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1ylp _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $5ccd6b86c893b680$var$SpinnerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41bpf _1reo15vq _18m915vq _1tke1tcg",
            __cmplp.className
        ])
    });
});
const $5ccd6b86c893b680$export$9c05ccc6295d539b = ({ onScrollTo: onScrollTo, testId: testId, cursor: cursor, observerOptions: observerOptions, spinnerSize: spinnerSize = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l8oxh.InfiniteScroll), {
        onScrollTo: onScrollTo,
        cursor: cursor,
        observerOptions: observerOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5ccd6b86c893b680$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5ccd6b86c893b680$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: spinnerSize,
        testId: testId
    }))));
};
module.exports["ObservableSpinner"] = $5ccd6b86c893b680$export$9c05ccc6295d539b;

});

parcelRegister("l8oxh", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $cb0d4ce40dbff1b4$export$c5295390d6167a3e = ({ onScrollTo: onScrollTo, cursor: cursor, observerOptions: observerOptions, children: children })=>{
    const loaderTarget = (0, $42omo.useRef)(null);
    const previousCursor = (0, $42omo.useRef)(null);
    // This function is called by the IntersectionObserver API when "loaderTarget" UI element
    // changes visibility.  If it has become visible (typically by user scrolling), call our
    // scroll handler and the parent will attempt to load more data
    const handleIntersect = (0, $42omo.useCallback)((entries)=>{
        // Sometimes based on an unknown render race condition, the previous IntersectionObserver is not
        // properly cleared before the next one is observed, which causes the 0th indexed IntersectionObserver
        // to never be intersecting, which causes the onScrollTo callback to not be called when it should be.
        // To fix this just get rid of the old observer if it is not properly cleaned up.
        if (entries.length > 1) entries.shift();
        // On the first scroll the previousCursor = null and cursor is a string or undefined
        // Intersection can occur multiple times but we only call onScrollTo again if we have a new cursor.
        if (entries?.[0]?.isIntersecting && cursor !== previousCursor.current) {
            previousCursor.current = cursor;
            onScrollTo();
        }
    }, [
        onScrollTo,
        cursor
    ]);
    // IntersectionObserver detects when our target element becomes visible
    (0, $42omo.useEffect)(()=>{
        // Adding a positive 'rootMargin' and setting 'root' to the scroll container *should* trigger
        // a positive 'intersection' result (thus loading results) before this element even comes into view
        // (when it is Xpx away from the viewport). 'rootMargin' follows CSS 'margin' syntax.
        // However, this doesn't seem to be working, intersection only triggers when element is in viewport.
        // Have also attempted to pass in a ref from the table tree container instead of querying the document,
        // but that also does not work.
        // @TODO figure out what is wrong here.
        // eslint-disable-next-line
        const observer = new IntersectionObserver(handleIntersect, observerOptions);
        const target = loaderTarget?.current;
        if (target) observer.observe(target);
        return ()=>{
            if (target) observer.unobserve(target);
            observer.disconnect();
        };
    }, [
        loaderTarget,
        handleIntersect,
        observerOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cb0d4ce40dbff1b4$var$LoaderTarget, {
        ref: loaderTarget
    }, children);
};
const $cb0d4ce40dbff1b4$var$LoaderTarget = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref
    }, children));
module.exports["InfiniteScroll"] = $cb0d4ce40dbff1b4$export$c5295390d6167a3e;

});

parcelRegister("ao6k0", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $kmyZQ = parcelRequire("kmyZQ");


var $78QFu = parcelRequire("78QFu");


var $7sK8i = parcelRequire("7sK8i");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");


var $6mKj3 = parcelRequire("6mKj3");


var $6VdZc = parcelRequire("6VdZc");

var $7fw2E = parcelRequire("7fw2E");

const $3ef4c99d4b0f9884$var$PageLoadEndImpl = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime, onComplete: onComplete })=>{
    (0, $42omo.useEffect)(()=>{
        const stopArguments = {
            stopTime: typeof stopTime === 'number' ? stopTime : undefined,
            customData: {
                ...customData,
                previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            }
        };
        metric.stop(stopArguments);
        (0, $7fw2E.markBrowserMetricEnd)(metric);
        (0, $7sK8i.resumeLowPriorityEvents)();
        // trigger onComplete regardless of FF - PageLoadEnd can stop the progress bar temporarily,
        // as ProgressBarContainer returns early if the progress bar has already been stopped.
        onComplete();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData` or `stopTime`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onComplete,
        metric
    ]);
    return null;
});
const $3ef4c99d4b0f9884$var$PageLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, customData: customData, stopTime: stopTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (window?.__SSR_RENDERED__ && Boolean(window.__HYDRATION_FAILED__)) {
        const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
        const attribution = Boolean(window.__SSR_REACT_STREAMING__) ? 'streaming-hydration' : 'hydration';
        if ((0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
            source: `PageLoadEnd - ${metric?.key}`,
            route: route,
            errorWithRoute: errorWithRoute,
            isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
        })).fire();
        else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
            attribution: attribution
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kmyZQ.ProgressBarContainer)
        ]
    }, (progressBar)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3ef4c99d4b0f9884$var$PageLoadEndImpl, {
            metric: metric,
            customData: customData,
            stopTime: stopTime,
            onComplete: progressBar.finish
        }));
});
const $3ef4c99d4b0f9884$export$570dec5b65c6715b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($3ef4c99d4b0f9884$var$PageLoadEndComponent);
module.exports["PageLoadEnd"] = $3ef4c99d4b0f9884$export$570dec5b65c6715b;

});

parcelRegister("6MSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9387550ed869acb8$export$4242cfff65d64b16 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "M3-19",
    name: "RestrictedPage",
    loader: async ()=>(await (parcelRequire("6COeq"))).RestrictedPage
});
module.exports["RestrictedPage"] = $9387550ed869acb8$export$4242cfff65d64b16;

});

parcelRegister("6COeq", function(module, exports) {

let $4d2d41aa9940d898$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4d2d41aa9940d898$var$load("6wr18"),
    $4d2d41aa9940d898$var$load("2F69B"),
    $4d2d41aa9940d898$var$load("ffEVr"),
    $4d2d41aa9940d898$var$load("hhss7"),
    $4d2d41aa9940d898$var$load("kUiwW")
]).then(()=>parcelRequire('3kPYw'));

});

parcelRegister("jEeDd", function(module, exports) {

var $6X8o4 = parcelRequire("6X8o4");


var $ge2sX = parcelRequire("ge2sX");

function $2dd269c5e0cf48e9$export$264b5fa7ee2d3260(continueUrl) {
    const identity = $2dd269c5e0cf48e9$var$getIdentity();
    if (typeof continueUrl === 'function') continueUrl = continueUrl(identity);
    if (!continueUrl) continueUrl = window.location.href; // eslint-disable-line no-restricted-syntax
    return `https://${identity}/login?application=confluence&continue=${encodeURIComponent(continueUrl)}`;
}
function $2dd269c5e0cf48e9$var$getIdentity() {
    let identity;
    const DEFAULT_PRODUCTION = 'id.atlassian.com';
    const DEFAULT_STAGING = 'id.stg.internal.atlassian.com';
    // 2. Fall back to the frontend build environment:
    if (!identity) identity = "id.atlassian.com";
    // 3. Fall back to the backend runtime environment:
    if (!identity) {
        // Turning getLoginLink into a hook would add the complexity of skipability.
        // Given that (a) we're implementing a fallback here and (b) the frontend
        // app figures out whether login is necessary by looking at session data,
        // the backend runtime environment will very likely be known already.
        const environment = (0, $6X8o4.getValue)((0, $ge2sX.getSessionData)())?.environment;
        identity = environment === 'PRODUCTION' ? DEFAULT_PRODUCTION : DEFAULT_STAGING;
    }
    return identity;
}
module.exports["getLoginLink"] = $2dd269c5e0cf48e9$export$264b5fa7ee2d3260;

});

parcelRegister("caYQd", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jmjWc = parcelRequire("jmjWc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a745dfd537cdace3$var$LoadingSpaceSelector = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1tke1ylp",
            __cmplp.className
        ])
    });
});

const $a745dfd537cdace3$export$ae81af835e192ac4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "SLEHS",
    name: "SpaceSelector",
    loader: async ()=>(await (parcelRequire("eBWU7"))).SpaceSelector,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a745dfd537cdace3$var$LoadingSpaceSelector, null)
});
module.exports["SpaceSelector"] = $a745dfd537cdace3$export$ae81af835e192ac4;

});

parcelRegister("eBWU7", function(module, exports) {

let $aa323687a3fd73c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aa323687a3fd73c3$var$load("lnnYm"),
    $aa323687a3fd73c3$var$load("6wr18"),
    $aa323687a3fd73c3$var$load("2mt3f"),
    $aa323687a3fd73c3$var$load("jXx9i"),
    $aa323687a3fd73c3$var$load("iRFO3"),
    $aa323687a3fd73c3$var$load("aPo1I"),
    $aa323687a3fd73c3$var$load("dlZSj"),
    $aa323687a3fd73c3$var$load("dS0Pr"),
    $aa323687a3fd73c3$var$load("huYla"),
    $aa323687a3fd73c3$var$load("37ZO9"),
    $aa323687a3fd73c3$var$load("1GxVg"),
    $aa323687a3fd73c3$var$load("let0D"),
    $aa323687a3fd73c3$var$load("6EQss"),
    $aa323687a3fd73c3$var$load("7EorR"),
    $aa323687a3fd73c3$var$load("ffEVr"),
    $aa323687a3fd73c3$var$load("kUbUu"),
    $aa323687a3fd73c3$var$load("hhss7"),
    $aa323687a3fd73c3$var$load("7Omhy"),
    $aa323687a3fd73c3$var$load("kC80R"),
    $aa323687a3fd73c3$var$load("eMbU0")
]).then(()=>parcelRequire('bHtQ2'));

});

parcelRegister("kmWRd", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $g9Srd = parcelRequire("g9Srd");

var $h3cbw = parcelRequire("h3cbw");

const $7a88b175622d580e$var$sidePanelContentStyling = (0, $ecnYn.xcss)({
    position: 'absolute',
    width: '100%',
    backgroundColor: 'elevation.surface',
    height: '100%',
    top: '0',
    right: '0',
    left: '0',
    bottom: '0',
    display: 'flex',
    flexDirection: 'column'
});
const $7a88b175622d580e$export$8689d3888980b1f3 = ({ headerHeight: headerHeight = 0, isFixed: isFixed, children: children, displayTopBorder: displayTopBorder, panelTop: panelTop = 0, isOpen: isOpen = true })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
        appear: true
    }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h3cbw.default), {
        enterFrom: "right",
        fade: "inout"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ...props,
            // `props` has className, so use inline styling to avoid conflicts
            style: {
                backgroundColor: 'elevation.surface',
                position: isFixed ? 'fixed' : 'absolute',
                right: '0',
                top: `${panelTop}px`,
                width: '320px',
                padding: 'space.300',
                borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
                height: `calc(100vh - ${headerHeight}px)`,
                borderTop: displayTopBorder ? `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}` : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $7a88b175622d580e$var$sidePanelContentStyling
        }, children))));
};
module.exports["SidePanel"] = $7a88b175622d580e$export$8689d3888980b1f3;

});

parcelRegister("4WZFP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $72d7920b18bf3596$export$70e0922268f2e08b = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlock: "space.100",
        paddingInlineStart: "space.300",
        paddingInlineEnd: "space.150"
    }, children);
};
module.exports["SidePanelHeader"] = $72d7920b18bf3596$export$70e0922268f2e08b;

});

parcelRegister("50sHn", function(module, exports) {

var $jgnk6 = parcelRequire("jgnk6");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $1cYlh = parcelRequire("1cYlh");


var $kknEZ = parcelRequire("kknEZ");


var $bFMG7 = parcelRequire("bFMG7");


var $lqrF0 = parcelRequire("lqrF0");

const $8082b61b869d342a$var$UseClassificationChangeStateQuery = (0, $jgnk6.default);
const $8082b61b869d342a$export$5527a2316b481463 = (contentId, selectedSpaceKey, currentSpaceKey)=>{
    const [unhandledError, setUnhandledError] = (0, $42omo.useState)();
    const [selectedSpaceClassification, setSelectedSpaceClassification] = (0, $42omo.useState)(null);
    // Mark 404 errors, when space data classification isn't assigned, as handled since it's expected
    // Set unhandled error for all other errors
    const processError = (0, $42omo.useCallback)((error)=>{
        if ((0, $aMcHK.isStatusCodeError)(error, '404')) (0, $7Sm4c.markErrorAsHandled)(error);
        else setUnhandledError(error);
    }, []);
    /*
     Fetch classification for current page
     Currently no error handling for content classification since the behavior is to
     ignore content classification and use space default classification if there's an error.
      If intended behavior changes in the future, we'll need to handle the error.
   */ const { classification: currentClassification, contentLevelLoading: currentClassificationLoading } = (0, $bFMG7.useContentClassification)({
        contentId: contentId,
        spaceKeyOverride: currentSpaceKey
    });
    // fetch classification for target space
    // default target space is current space
    const { data: selectedSpaceData, loading: selectedSpaceLoading, error: selectedSpaceError, refetch: selectedSpaceRefetch } = (0, $jMyy4.useQueryInterop)($8082b61b869d342a$var$UseClassificationChangeStateQuery, {
        variables: {
            spaceKey: currentSpaceKey || ''
        },
        skip: !currentSpaceKey,
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true
    });
    const { orgDefaultClassificationLevelId: orgDefaultClassificationLevelId, orgDefaultClasificationLoading: orgDefaultClasificationLoading, orgDefaultClassificationError: orgDefaultClassificationError } = (0, $lqrF0.useOrgDefaultClassificationLevelId)({
        skip: !currentSpaceKey
    });
    // if selected space changes, load/refetch query
    (0, $42omo.useEffect)(()=>{
        if (!selectedSpaceKey) return;
        // reset unhandled error (so if one exists, it'll cleared when the selected space changes)
        setUnhandledError(undefined);
        // reset selected space classification when selected space changes
        // causes additional rerender but necessary to avoid displaying wrong classification for space
        setSelectedSpaceClassification(null);
        selectedSpaceRefetch({
            spaceKey: selectedSpaceKey
        }).catch(processError);
    }, [
        selectedSpaceKey,
        selectedSpaceRefetch,
        processError
    ]);
    // handle selected space data updates
    (0, $42omo.useEffect)(()=>{
        if (selectedSpaceLoading || orgDefaultClasificationLoading) return;
        if (selectedSpaceError) {
            processError(selectedSpaceError);
            if (!orgDefaultClassificationLevelId) return;
        }
        if (orgDefaultClassificationError) {
            processError(orgDefaultClassificationError);
            return;
        }
        const selectedSpaceClassificationId = selectedSpaceData?.space?.defaultClassificationLevelId ?? orgDefaultClassificationLevelId;
        const selectedSpaceClassificationLevels = selectedSpaceData?.classificationLevels || [];
        const selectedSpaceClassification = selectedSpaceClassificationLevels.find((level)=>level?.id === selectedSpaceClassificationId) || null;
        // type error from converting `color: string` to `color: Color`, so safe to cast
        setSelectedSpaceClassification(selectedSpaceClassification);
    }, [
        selectedSpaceData,
        selectedSpaceLoading,
        selectedSpaceError,
        processError,
        orgDefaultClassificationLevelId,
        orgDefaultClasificationLoading,
        orgDefaultClassificationError
    ]);
    // retrieve classification name of selected space. Otherwise it's NO_CLASSIFICATION
    const selectedSpaceClassificationName = selectedSpaceClassification?.status === (0, $kknEZ.Status).PUBLISHED ? selectedSpaceClassification?.name || (0, $1cYlh.NO_CLASSIFICATION) : (0, $1cYlh.NO_CLASSIFICATION);
    // retrieve classification name of current space. Otherwise it's NO_CLASSIFICATION
    const currentClassificationName = currentClassification?.status === (0, $kknEZ.Status).PUBLISHED ? currentClassification?.name || (0, $1cYlh.NO_CLASSIFICATION) : (0, $1cYlh.NO_CLASSIFICATION);
    /*
   * evaluates if classification changed when new space was selected
   * Changed if selected space is different from current space
   * AND
   * if published classification id is different from current published classification id
   * if classification isn't published (e.g. archived/deleted), then it's considered as NO_CLASSIFICATION
   *
   * so if selected space classification is archived, and current classification is also archived, it's not considered as changed
   */ const classificationChanged = !!selectedSpaceKey && selectedSpaceKey !== currentSpaceKey && (selectedSpaceClassification?.status === (0, $kknEZ.Status).PUBLISHED || currentClassification?.status === (0, $kknEZ.Status).PUBLISHED) && selectedSpaceClassification?.id !== currentClassification?.id;
    return {
        classificationChanged: classificationChanged,
        selectedClassification: selectedSpaceClassificationName,
        selectedSpaceClassification: selectedSpaceClassification,
        currentClassification: currentClassificationName,
        classificationLoading: selectedSpaceLoading || currentClassificationLoading || orgDefaultClasificationLoading,
        classificationError: unhandledError
    };
};
module.exports["useClassificationChangeState"] = $8082b61b869d342a$export$5527a2316b481463;

});

parcelRegister("jgnk6", function(module, exports) {
/**
 * @generated SignedSource<<28dc1c090357e4d170090ae5576080c8>>
 * @relayHash 7370c42faa249d7757ef5cd22e31b2ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 94a2ac8398b5ffdfe9295c791c3389602bb05c8796536bfda83771de0d76dc25
const $dac1f9d1dac54bbf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "defaultClassificationLevelId"
                },
                {
                    "concreteType": "SpaceMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCurrentPages"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "ContentDataClassificationLevel",
            "kind": "LinkedField",
            "name": "classificationLevels",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "description"
                },
                {
                    "kind": "ScalarField",
                    "name": "color"
                },
                {
                    "kind": "ScalarField",
                    "name": "order"
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "kind": "ScalarField",
                    "name": "guideline"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useClassificationChangeStateQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useClassificationChangeStateQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "7370c42faa249d7757ef5cd22e31b2ce",
            "id": "94a2ac8398b5ffdfe9295c791c3389602bb05c8796536bfda83771de0d76dc25",
            "metadata": {},
            "name": "useClassificationChangeStateQuery",
            "operationKind": "query",
            "text": "query useClassificationChangeStateQuery($spaceKey:String!){space(key:$spaceKey){id,name,defaultClassificationLevelId,metadata{totalCurrentPages}},classificationLevels{id,name,description,color,order,status,guideline}}"
        }
    };
}();
$dac1f9d1dac54bbf$var$node.hash = "8fc79225eef7358ca30fd3ab64a818ef";
var $dac1f9d1dac54bbf$export$2e2bcd8739ae039 = $dac1f9d1dac54bbf$var$node;
module.exports["default"] = $dac1f9d1dac54bbf$export$2e2bcd8739ae039;

});

parcelRegister("1sAhh", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $diswb = parcelRequire("diswb");


var $eSUdr = parcelRequire("eSUdr");


var $dpPtd = parcelRequire("dpPtd");


var $imt6g = parcelRequire("imt6g");


var $d0hiC = parcelRequire("d0hiC");


var $ivb8S = parcelRequire("ivb8S");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");

const $1c2e5d021a484539$var$i18n = (0, $cgtv4.defineMessages)({
    flagTitle: {
        id: "experiment-land-in-sample-space-xflow.database.flag.title",
        defaultMessage: "We\u2019ve landed you in a database"
    },
    flagBody: {
        id: "experiment-land-in-sample-space-xflow.database.flag.body",
        defaultMessage: "Get started easily by trying out a database template from the right side panel."
    }
});
/**
 * This flag should only be displayed if the user selects to land in a sample database.
 * Once any sample content (whiteboard, live, database) flag is displayed, we don't want to display others.
 */ const $1c2e5d021a484539$var$DatabaseFlagComponent = ({ spaceKey: spaceKey })=>{
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        ...Object.values((0, $d0hiC.LAND_IN_SAMPLE_SPACE_ONBOARDING_STATE_KEYS))
    ]);
    const { hasSeenSampleContentFlag: hasSeenSampleContentFlag } = (0, $ivb8S.deserializeState)(onboardingStateData);
    if ((0, $1uFM6.isUnauthorizedError)(onboardingStateError)) (0, $7Sm4c.markErrorAsHandled)(onboardingStateError);
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data, error: error } = (0, $diswb.useQuery)((0, $eSUdr.gql)`
			query DatabaseFlagSpaceTypeQuery($spaceKey: String) {
				space(key: $spaceKey) {
					type
				}
			}
		`, {
        variables: {
            spaceKey: spaceKey
        },
        skip: hasSeenSampleContentFlag || onboardingStateLoading || onboardingStateError
    });
    if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const spaceType = data?.space.type;
    (0, $42omo.useEffect)(()=>{
        if (spaceType === 'xflow_sample_space' && !hasSeenSampleContentFlag) {
            showFlag({
                title: formatMessage($1c2e5d021a484539$var$i18n.flagTitle),
                description: formatMessage($1c2e5d021a484539$var$i18n.flagBody),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
                    label: "check",
                    color: "var(--ds-icon-accent-green, #22A06B)"
                })
            });
            // Mark as dismissed as long as the user has seen the flag
            setOnboardingState({
                key: (0, $d0hiC.LAND_IN_SAMPLE_SPACE_ONBOARDING_STATE_KEYS).hasSeenSampleContentFlag,
                value: 'true'
            });
        }
    }, [
        showFlag,
        formatMessage,
        spaceType,
        hasSeenSampleContentFlag,
        setOnboardingState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
};
const $1c2e5d021a484539$export$36beaa38e8625d98 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).FLYWHEEL_ACTIVATION
})($1c2e5d021a484539$var$DatabaseFlagComponent);
module.exports["DatabaseFlag"] = $1c2e5d021a484539$export$36beaa38e8625d98;

});


//# sourceMappingURL=DatabaseContainer.d97fdad5.js.map
